(function (angular, schoolwork12) {

    'use strict';


    var schoolDataController= angular.module(schoolwork12.app.manageSchoolData.name);
    schoolDataController.controller(schoolwork12.app.manageSchoolData.controllers.schoolDataDetails, [
         '$rootScope', '$scope', '$timeout', '$http', '$location', '$uibModal', '$filter', '$state', 'uiGridConstants', '$q',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.common.services.utilService,
         schoolwork12.app.manageSchoolData.services.schoolDataEditSvc,
         function ($rootScope, $scope, $timeout, $http,$location, $uibModal, $filter, $state, uiGridConstants, $q,
         authentication, eventNotification, utilService, schoolDataEditSvc) {
             
        
            console.info("In school data details controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn, function (event, authenticatedUser) {
                console.info('Student Details controller: Subscribe On UserLogin Event: '.concat(angular.toJson(authenticatedUser)));
             });

            $scope.forms = {};
            $scope.oneAtATime = true;
            $scope.editAccordions = {   manageMainData: false,manageClassroomDates: false, manageCourseCatalogs: false, manageDefaultCourses: false, 
                                        manageGrademarkSets: false, manageSchoolDates: false, manageDataFields: false, attDataField: false, RRegistField : false,
                                        PulseCheckField:false, MessagedField:false, reactivateClassromms: false, MessagedField_Academics:false,
                                        MessagedField_Attendance:false, MessagedField_Compliance:false, MessagedField_Engagement:false,
                                        MessagedField_SpecialPrograms:false, MessagedField_StrongStart:false, MessagedField_Testing:false,
                                        duplicateCatalog:false, opened: true , manageIntegration: false};
            $scope.noSearchResults = false;
            $scope.noSearchResultsMsg = "No search results found.";
            $scope.editErrorOccurred = false;
            $scope.editErrorMsgOccurred=false ;
            $scope.editGradeMErrorOccurred= false;
            $scope.editReasonErrorOccurred = false;
            $scope.editYearErrorOccurred = false;
            $rootScope.hideSchoolDataSearch = true;
            $scope.hideSchoolDataDetails = false;
            $scope.showClassroomSavedMsg = false;
            $scope.grade = {selected: ''};
            $scope.dropdown ={selectedType:''};
            $scope.cteProgSelected=false;
            $scope.futureCteProgSelected= false;
            $scope.showGradeMarkSet = true;

            $scope.dateTags=[];
            $scope.currentDateTags=[];
            $scope.buttonDisabled = false;
            var classroomDatesCreate = [];
            var classroomDatesDelete = [];
            var grademarkDeleted=false;
            var dateRegex = new RegExp('^(0[0-9]|1[0-2])\/(0[0-9]|[1-2][0-9]|3[0-1])\/[0-9]{4}$');

            $scope.clearErrorMessages = function(){
                $scope.editErrorMesg="";
                $scope.showSavedSchoolDataMsg = false;
                $scope.editErrorOccurred =false;
                $scope.editErrorMsgOccurred=false;
                $scope.editGradeMErrorOccurred= false;
                $scope.editReasonErrorOccurred = false;
                $scope.editYearErrorOccurred = false;
                $scope.editMainDataErrorOccured = false;
            };

            $scope.keyPressed= function(keyEvent){
                keyEvent.preventDefault();
                return false;
            };

            $scope.classDatePicker = { opened : false, dateToAdd: '' }
            $scope.openDatePicker = function() {
                $scope.classDatePicker.opened = true;
            };

            // STT-8081 Adding new datePicker Variables to School Year Accordion
            $scope.schoolYearDatePicker = {
                startDate: false,
                endDate: false,
                courseStartDate: false,
                courseEndDate: false
            }
            $scope.openDatePickerByName = function(datePickerName,event) {
                Object.keys($scope.schoolYearDatePicker).forEach(function(value,index){
                    if(value === datePickerName){
                        this[value] = true;
                    }else{
                        this[value] = false;
                    }
                },$scope.schoolYearDatePicker);
            };

            // STT-8343 Adding new datePickers variables to School Year Term Table
            $scope.schoolYearTermDatePicker = {
                startDate: false,
                endDate: false,
                courseStartDate: false,
                courseEndDate: false
            }
            $scope.openDatePickerTermByName = function(datePickerName) {
                $scope.schoolYearTermDatePicker[datePickerName] = true;
            };
            // page refresh redirect to search page    
            if(!$scope.$parent.schoolDataResultsGridObject){
                $location.url('/manage-school-data');
            }else{
                $scope.gridPaginationSize = $scope.$parent.schoolDataResultsGridObject.gridPageSize;
            }

            //STT-9213: STT.9185c User views and edits the Main Data for a school in TV Action

            //Main Data Form Errors messages
            $scope.mainDataSchoolNameRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolNameRequired;
            $scope.mainDataSchoolAbbrevRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolAbbrevRequired;
            $scope.mainDataSchoolZipInvalid = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolZipInvalid;
            $scope.mainDataSchoolCountryRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolCountryRequired;
            $scope.mainDataSchoolPhoneInvalid = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolPhoneInvalid;
            $scope.mainDataSchoolDefaultBillRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolDefaultBillRequired;
            $scope.mainDataSchoolDefaultShipRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolDefaultShipRequired;
            $scope.mainDataSchoolEmailNotificationRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolEmailNotificationRequired;
            $scope.mainDataSchoolAllowBoosterMatsRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolAllowBoosterMatsRequired;
            $scope.mainDataSchoolAllowRecycledMatsRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolAllowRecycledMatsRequired;
            $scope.mainDataSchoolBillingRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolBillingRequired;
            $scope.mainDataSchoolBillingInvalid = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolBillingInvalid;
            $scope.mainDataSchoolMaterialsRequired = schoolwork12.app.manageSchoolData.errorMessages.mainDataSchoolMaterialsRequired;

            $scope.mainData = {
                defaultBillAndShipOptions:[
                    {
                        id: 0,
                        name: "person"

                    },
                    {
                        id: 1,
                        name: "student"

                    },
                    {
                        id: 2,
                        name: "school"

                    },
                    {
                        id: 3,
                        name: "district"

                    }
                ],
                materialsOptions:[
                    {
                        id: 1200,
                        name: "Standard"
                    },
                    {
                        id: 1201,
                        name: "Standard Plus"
                    },
                    {
                        id: 1202,
                        name: "No Material"
                    }
                ],
                schoolYearOptions: [],
                fillInSchoolYearOptions: function(schoolYears){
                    let currentYearExist = false;
                    schoolYears.forEach(element => {
                        if(element.year == $scope.editSchoolData.currentYear)
                            currentYearExist = true;
                        $scope.mainData.schoolYearOptions.push(element.year);
                    });
                    if(!currentYearExist)
                        $scope.mainData.schoolYearOptions.push($scope.editSchoolData.currentYear);
                    $scope.mainData.schoolYearOptions.sort((a,b) =>  a - b);
                }
            }

            $scope.resetMainDataAccordion = function(){
                $scope.mainData.object = angular.copy($scope.schoolMainData);
                $scope.resetForms();
                resetMainDataValidationErrors();   
            }

            $scope.printMainDataObject = function(){
                console.log($scope.mainData.object);
            }

            let resetMainDataValidationErrors = function(){
                $scope.editMainDataErrorOccured = false;
                $scope.forms.mainDataForm['mainDataSchoolName'].$setValidity('schoolNameRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolAbbrev'].$setValidity('schoolAbbrevRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolZipCode'].$setValidity('schoolZipCodeInvalid',true);
                $scope.forms.mainDataForm['mainDataSchoolCountry'].$setValidity('schoolCountryRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolPhone'].$setValidity('schoolPhoneInvalid',true);
                $scope.forms.mainDataForm['mainDataSchoolDefaultBill'].$setValidity('schoolDefaultBillRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolDefaultShip'].$setValidity('schoolDefaultShipRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolEmailNotification'].$setValidity('schoolEmailNotificationRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolAllowBoosterMats'].$setValidity('schoolAllowBoosterMatsRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolAllowRecycledMats'].$setValidity('schoolAllowRecycledMatsRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolBillingId'].$setValidity('schoolBillingIdRequired',true);
                $scope.forms.mainDataForm['mainDataSchoolBillingId'].$setValidity('schoolBillingIdInvalid',true);
                $scope.forms.mainDataForm['mainDataSchoolMaterials'].$setValidity('schoolMaterialsRequired',true);
                
            }

            $scope.phoneCharsValidation = function (event,phone){
                var keyCode = event.keyCode;
                var key = event.key;

                if ((keyCode < 48 || keyCode > 57) && (key != '(' && key != ')' && key != '-')){
                    event.preventDefault();
                }
            }

            let validateMainDataForm = function(){
                let result = true;

                //Validating School Name
                if($scope.mainData.object.name == null || $scope.mainData.object.name.trim() == ''){
                    $scope.forms.mainDataForm['mainDataSchoolName'].$setValidity('schoolNameRequired',false);   
                    result = false;
                }

                //Validating School Abbrev
                if($scope.mainData.object.abbreviation == null || $scope.mainData.object.abbreviation.trim() == ''){
                    $scope.forms.mainDataForm['mainDataSchoolAbbrev'].$setValidity('schoolAbbrevRequired',false);
                    result = false;
                }

                //Validating School Zip Code
                let zipcode = $scope.mainData.object.zip.toString();
                if($scope.mainData.object.zip && (!(/^\d+$/).test(zipcode) || zipcode.length !== 5)){
                    $scope.forms.mainDataForm['mainDataSchoolZipCode'].$setValidity('schoolZipCodeInvalid',false);
                    result = false;
                }

                //Validating School Country
                if(($scope.mainData.object.country == null || $scope.mainData.object.country.trim() == "")
                    && (($scope.mainData.object.address1 != null && $scope.mainData.object.address1.trim() != "")
                        || ($scope.mainData.object.address2 != null && $scope.mainData.object.address2.trim() != "")
                        || ($scope.mainData.object.address3 != null && $scope.mainData.object.address3.trim() != "" )
                        || ($scope.mainData.object.city != null && $scope.mainData.object.city != "")
                        || ($scope.mainData.object.state != null && $scope.mainData.object.state != "")
                        || ($scope.mainData.object.zip != null && $scope.mainData.object.zip != "")) ){
                    $scope.forms.mainDataForm['mainDataSchoolCountry'].$setValidity('schoolCountryRequired',false);
                    result = false;
                }

                //Validating School Phone 
                if($scope.mainData.object.phone){
                    let tmpPhoneValue = $scope.mainData.object.phone;
                    if((tmpPhoneValue.replace(/[- )(]/g,'')).length < 10){
                        $scope.forms.mainDataForm['mainDataSchoolPhone'].$setValidity('schoolPhoneInvalid',false);
                        result = false;
                    }
                }

                //Validating School Default Bill to
                if($scope.mainData.object.defaultBillTo == null || $scope.mainData.object.defaultBillTo.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolDefaultBill'].$setValidity('schoolDefaultBillRequired',false);
                    result = false;
                }

                //Validating School Default Ship to
                if($scope.mainData.object.defaultShipTo == null || $scope.mainData.object.defaultShipTo.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolDefaultShip'].$setValidity('schoolDefaultShipRequired',false);
                    result = false;
                }

                //Validating School Materials
                if($scope.mainData.object.materialReq == null || $scope.mainData.object.materialReq.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolMaterials'].$setValidity('schoolMaterialsRequired',false);
                    result = false;
                }

                //validating School Email Notification
                if($scope.mainData.object.notificationReq == null || $scope.mainData.object.notificationReq.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolEmailNotification'].$setValidity('schoolEmailNotificationRequired',false);
                    result = false;
                }

                //validating School Allow Booster Materials
                if($scope.mainData.object.allowBoosterMaterials == null || $scope.mainData.object.allowBoosterMaterials.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolAllowBoosterMats'].$setValidity('schoolAllowBoosterMatsRequired',false);
                    result = false;
                }

                //validating School Allow Recycled Materials
                if($scope.mainData.object.allowRecycledMaterials == null || $scope.mainData.object.allowRecycledMaterials.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolAllowRecycledMats'].$setValidity('schoolAllowRecycledMatsRequired',false);
                    result = false;
                }

                //validating School Billing Id
                if($scope.mainData.object.billingId == null || $scope.mainData.object.billingId.toString() == ""){
                    $scope.forms.mainDataForm['mainDataSchoolBillingId'].$setValidity('schoolBillingIdRequired',false);
                    result = false;
                }else if($scope.k12Billings.find(billing => billing.billingId == $scope.mainData.object.billingId) == null){
                    $scope.forms.mainDataForm['mainDataSchoolBillingId'].$setValidity('schoolBillingIdInvalid',false);
                    result = false;
                }

                $scope.editMainDataErrorOccured = !result;

                return result;

            }

            let isMainDataCheckValid = function(){
                resetMainDataValidationErrors();

                return validateMainDataForm();
            }

            //STT:9195: STT.7634a Duplicate School modal is displayed to user

            $scope.closeSchoolDuplicatedMsg = function () {
                $scope.showSchoolDuplicatedMessage = false;
                $scope.duplicatedSchoolName = '';
            };

            $scope.duplicateSchool = function (size) {
                let schoolNameAbbreviation = $scope.editSchoolData.name + ' (' + $scope.editSchoolData.abbreviation + ')';
                let currentSchoolId = $scope.editSchoolData.schoolId;
                let duplicateSchoolExitMessage = schoolwork12.app.manageSchoolData.errorMessages.duplicateSchoolExitModalMessage;
                let schoolDuplicateNameRequired = schoolwork12.app.manageSchoolData.errorMessages.schoolDuplicateNameRequired;
                let schoolDuplicateAbbrevRequired = schoolwork12.app.manageSchoolData.errorMessages.schoolDuplicateAbbrevRequired;
                let schoolDuplicateNameUnique = schoolwork12.app.manageSchoolData.errorMessages.schoolDuplicateNameUnique;
                let schoolDuplicateAbbrevUnique = schoolwork12.app.manageSchoolData.errorMessages.schoolDuplicateAbbrevUnique;
                var schoolDuplicateModal = function () {
                    let duplicateSchoolModalInstance = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'duplicateSchoolModal.html',
                        size: size,
                        keyboard: false,
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.schoolNameAbbreviation = schoolNameAbbreviation;
                            $scope.schoolDuplicateNameRequired = schoolDuplicateNameRequired;
                            $scope.schoolDuplicateAbbrevRequired = schoolDuplicateAbbrevRequired;
                            $scope.schoolDuplicateNameUnique = schoolDuplicateNameUnique;
                            $scope.schoolDuplicateAbbrevUnique = schoolDuplicateAbbrevUnique;
                            $scope.duplicatingInProcess = false;
                            let initializeFormErrors = function () {
                                $scope.forms.duplicateSchool.duplicateSchoolName.$setValidity('nameRequired', true);
                                $scope.forms.duplicateSchool.duplicateSchoolAbbreviation.$setValidity('abbreviationRequired', true);
                                $scope.forms.duplicateSchool.duplicateSchoolName.$setValidity('nameUnique', true);
                                $scope.forms.duplicateSchool.duplicateSchoolAbbreviation.$setValidity('abbreviationUnique', true);
                            };
                            let unSavedSchoolDuplicateModalAlert = function(size) {
                                let rootSchoolDuplicateModalInstance = $uibModalInstance;
                                $scope.modalInstance = $uibModal.open({
                                    animation: $scope.animationsEnabled,
                                    templateUrl: 'schoolDuplicateOkCancelModal.html',
                                    size: size,
                                    keyboard: false,
                                    backdrop: 'static',
                                    controller: ['$scope', '$uibModalInstance',
                                    function ($scope, $uibModalInstance) {
                                        $scope.discardSchoolDuplicate = function () {
                                            $uibModalInstance.close(true);
                                            rootSchoolDuplicateModalInstance.close(true);
                                        };
                
                                        $scope.schoolDuplicateOkCancelDialogMsg = duplicateSchoolExitMessage;
                                        $scope.remainSchoolDuplicate = function () {
                                            $uibModalInstance.close(false);
                                        };
                                    }], 
                                    
                                });
                            }
    
                            $scope.duplicateSchoolModalCancel = function () {
                                if($scope.forms.duplicateSchool.$dirty){
                                    unSavedSchoolDuplicateModalAlert();
                                }else{
                                    $uibModalInstance.close(true);
                                }   
                            }

                            let validateDuplicateSchoolObject = function () {
                                let result = true;
                                //validate Name
                                if($scope.duplicateSchoolObject.name == null || $scope.duplicateSchoolObject.name == ''
                                    || typeof($scope.duplicateSchoolObject.name) === 'undefined'){
                                        $scope.forms.duplicateSchool.duplicateSchoolName.$setValidity('nameRequired', false);
                                        result = false;
                                }

                                //validate Abbreviation
                                if($scope.duplicateSchoolObject.abbreviation == null || $scope.duplicateSchoolObject.abbreviation == ''
                                    || typeof($scope.duplicateSchoolObject.abbreviation) === 'undefined'){
                                        $scope.forms.duplicateSchool.duplicateSchoolAbbreviation.$setValidity('abbreviationRequired', false);
                                        result = false;
                                }

                                return result;
                            }

                            $scope.duplicateSchool = function () {
                                initializeFormErrors();
                                if(validateDuplicateSchoolObject()){
                                    $scope.duplicatingInProcess = true;
                                    var duplicateSchoolPromise = schoolDataEditSvc.duplicateSchool(authentication.getCurrentUser().keycode,currentSchoolId,$scope.duplicateSchoolObject);
                                    var duplicateSchoolPromiseChain = duplicateSchoolPromise.then(function (response) {
                                        if(response){
                                            $uibModalInstance.close($scope.duplicateSchoolObject.name);
                                        }
                                    },function(error) {
                                        console.error('Error when saving school year details....'.concat(angular.toJson(error)));
                                        $scope.duplicateSchoolError = "";
        
                                        if (error.status == 400) {
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.duplicateSchoolError = $scope.duplicateSchoolError + error.data._errors[j] + "\n";
                                            }
        
                                        var checkDuplicateSchoolErrorMsg = $scope.duplicateSchoolError;
                                        let duplicatedName = (~checkDuplicateSchoolErrorMsg.indexOf("School Name is already used by another school.  Please enter a unique School Name.")) ? true : false; 
                                        let duplicatedAbbrev = (~checkDuplicateSchoolErrorMsg.indexOf("School Abbreviation is already used by another school.  Please enter a unique School Abbreviation.")) ? true : false; 

                                        $scope.forms.duplicateSchool.duplicateSchoolName.$setValidity('nameUnique', !duplicatedName);
                                        $scope.forms.duplicateSchool.duplicateSchoolAbbreviation.$setValidity('abbreviationUnique', !duplicatedAbbrev);
        
                                        } 
                                     })['finally'](function () {
                                        $scope.duplicatingInProcess=false;
        
                                    });
                                }
                            }
                        }], 
                    });

                    duplicateSchoolModalInstance.result.then(function (newSchoolName) {
                        if(typeof (newSchoolName) === "string"){
                            $scope.duplicatedSchoolName = newSchoolName;
                            $scope.showSchoolDuplicatedMessage = true;
                        }
                    })
                }
                if($scope.forms.Dates.$dirty || $scope.forms.CatalogsForm.$dirty || $scope.forms.CoursesForm.$dirty || $scope.forms.FieldsForm.$dirty || 
                    $scope.forms.grademarkForm.$dirty || $scope.forms.dropDownListsForm.$dirty || $scope.forms.schoolYearForm.$dirty || $scope.forms.integrationForm.$dirty){
                        $scope.openAlertUnsaved();
                        $scope.modalInstance.result.then(function (option) {
                            if(option){
                                $scope.reset();
                                schoolDuplicateModal();
                            }
                        });
                }else{
                    schoolDuplicateModal();
                }   
            }

            $scope.resetForms = function(){
                $scope.showSavedSchoolDataMsg = false;
                $scope.showClassroomSavedMsg = false;

                $scope.editErrorOccurred =false;
                $scope.editErrorMsgOccurred=false;
                $scope.editGradeMErrorOccurred= false;
                $scope.editReasonErrorOccurred = false;
                $scope.editYearErrorOccurred = false;

                if($scope.forms.Dates){
                    $scope.forms.Dates.$setPristine();
                }
                if($scope.forms.CatalogsForm){
                    $scope.forms.CatalogsForm.$setPristine();
                }
                if($scope.forms.FieldsForm){
                    $scope.forms.FieldsForm.$setPristine();
                }
                if($scope.forms.MessagedDataFieldsForm){
                    $scope.forms.MessagedDataFieldsForm.$setPristine();
                }
                if($scope.forms.grademarkForm){
                    $scope.forms.grademarkForm.$setPristine();
                }
                if($scope.forms.integrationForm){
                    $scope.forms.integrationForm.$setPristine();
                }
                if($scope.forms.dropDownListsForm){
                    $scope.forms.dropDownListsForm.$setPristine();
                }
                if($scope.forms.schoolYearForm){
                    $scope.forms.schoolYearForm.$setPristine();
                }
                if($scope.forms.CoursesForm){
                    $scope.forms.CoursesForm.$setPristine();
                }
                if($scope.forms.mainDataForm){
                    $scope.forms.mainDataForm.$setPristine();
                }
            }

            //close success msg on click
            $scope.closeSchoolDataMsg = function() {
                $scope.showSavedSchoolDataMsg = false;
                $scope.showClassroomSavedMsg = false;
                $scope.popUpClosed = true;
            }


            //<!--alert dialog for leaving page without saving
            $scope.option1 = false;
            $scope.modalInstance = null;
            $scope.$parent.$on('$stateChangeStart', function(event, next, current) { 
                if($scope.forms.Dates.$dirty || $scope.forms.CatalogsForm.$dirty || $scope.forms.CoursesForm.$dirty || $scope.forms.FieldsForm.$dirty || 
                    $scope.forms.grademarkForm.$dirty || $scope.forms.dropDownListsForm.$dirty || $scope.forms.schoolYearForm.$dirty || $scope.forms.integrationForm.$dirty
                    || $scope.forms.mainDataForm.$dirty){

                    if(!$scope.option1){
                        $scope.openAlertUnsaved(); 
                        event.preventDefault();
                        $rootScope.hideSchoolDataSearch = true; 
                    }
                    
                    $scope.modalInstance.result.then(function (option) {

                        $scope.option1 = option;
                        if(option){
                             $location.url(next.url);   
                        }
                       
                    });
                }
                if($scope.$parent.schoolDataResultsGridObject){
                    $scope.gridPaginationSize = $scope.$parent.schoolDataResultsGridObject.gridPageSize;
                    $timeout(function() {
                        $scope.$parent.schoolDataResultsGridObject.grid.core.handleWindowResize();
                    });
                } 
            })

            $scope.openAlertUnsaved = function (size) {
                $scope.modalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    size: size,
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {
                            $uibModalInstance.close(true);

                        };

                        $scope.dialogMsg = 'You have un-saved changes for the current school. Do you want to continue without saving the changes?';
                        $scope.cancel = function () {
                            $uibModalInstance.close(false);
                        };
                    }], 
                    
                });
             };


            //Initialize navigation grid 
            $scope.gridNewOptions = { 
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                paginationPageSizes : [ 25, 50, 75 ],
                paginationPageSize : $scope.gridPaginationSize,
                rowHeight: 50,
                showGridFooter : false,
        
            };

            //Build column definitions  
            $scope.gridNewOptions.columnDefs = [{
                    field : 'schoolId',
                    width: '40%',
                    displayName : 'School ID',
                    sort: {direction: 'asc'},
                    cellTemplate: '<div ng-click="grid.appScope.getSchoolDataDetails(grid, row, true)"  title="Edit School Data details" class="ui-grid-cell-contents schoolDataEdit" style="text-align: center;" ng-class="{ \'savedStudentClass\': row.entity.editCompleted }" ><span >{{row.entity[col.field]}}</span></div>',
                }, {
                    field : 'abbreviation',
                    displayName : 'School Abbreviation',
                    cellTemplate: '<div ng-click="grid.appScope.getSchoolDataDetails(grid, row, true)" class="ui-grid-cell-contents" style="cursor: pointer; text-align: center;" ng-class="{ \'savedStudentClass\': row.entity.editCompleted }" ><span >{{row.entity[col.field]}}</span></div>',
               
                }
            ];

            $scope.gridNewOptions.data = $scope.$parent.schoolDataResultsGridObject.searchResults;
            $scope.gridNewOptions.multiSelect = false;

            $scope.gridNewOptions.onRegisterApi = function( gridApi ) {
                $scope.gridNewApi = gridApi;
                $scope.gridNewApi.selection.on.rowSelectionChanged($scope, function(row){ 
                    //get newly selected row 
                    $scope.schoolDataRow = row;
                    // $scope.initGradeMarkSet($scope.schoolDataRow);
                    $scope.initReactClassroomPanel();
                });
            };
             $scope.dateChange = function () {
                $scope.buttonDisabled = false;
                if((!classroomDatesCreate || classroomDatesCreate.length ==0) && ( !classroomDatesDelete || classroomDatesDelete.length ==0) ){
                     $scope.buttonDisabled = true;
                }                
             };

            //Reset schoolData details
            $scope.resetClassroomDatesPanel = function () {
                $scope.resetForms();
                $scope.editSchoolData = angular.copy($scope.currentSchoolData); 
                $scope.dateTags = angular.copy($scope.currentDateTags);
                $scope.classDatePicker.dateToAdd = '';
                classroomDatesCreate = [];
                classroomDatesDelete = [];                
            }

            $scope.resetDataFieldsPanel = function () {
                $scope.resetForms();
                $scope.editSchoolData = angular.copy($scope.currentSchoolData); 
                $scope.record.dataFields = angular.copy($scope.currentDataFields); 
            }

            $scope.resetMessageFieldValueShow = function(tempArray){
                var tempObj=[];
                for(var i =0; i < $scope.currentDataFields.length;i++){
                    if(tempArray.id == $scope.currentDataFields[i].id){
                        tempObj = angular.copy($scope.currentDataFields[i]); 
                    }
                }
                    
                for(var j =0; j< $scope.record.dataFields.length;j++){
                        if(tempArray.id ==  $scope.record.dataFields[j].id){
                            $scope.record.dataFields[j] = angular.copy(tempObj);
                            $scope.record.dataFields[j].value = true; 
                        }
                    }
              }
            
            $scope.resetMessageFieldValue = function(tempArray){
                var tempObj=[];
                
                for(var i =0; i < $scope.currentDataFields.length;i++){
                    if(tempArray.id == $scope.currentDataFields[i].id){
                        tempObj = angular.copy($scope.currentDataFields[i]); 
                    }
                }
                    
                for(var j =0; j< $scope.record.dataFields.length;j++){
                        if(tempArray.id ==  $scope.record.dataFields[j].id){
                            $scope.record.dataFields[j] = angular.copy(tempObj); 
                            $scope.record.dataFields[j].value = false;
                            $scope.record.dataFields[j].templateDetails = [];
                        }
                    }
              }
           
             var isValidDate = function (data) {
                console.log("Validating Date");
                    if (!data || (data && data.$valid)) {
                        $scope.editErrorMsgOccurred = true;
                        $scope.editErrorMesg = schoolwork12.app.manageSchoolData.errorMessages.invalidDate;
                        return false;
                    }
                    return true;
            };
   
            $scope.addDateToList = function () {
                // $scope.clearErrorMessages();
                $scope.showSavedSchoolDataMsg = false;
                $scope.showClassroomSavedMsg = false;

                if( isValidDate($scope.classDatePicker.dateToAdd)){
                    var date = ($filter('date')($scope.classDatePicker.dateToAdd,'MM/dd/yyyy'));
                    var duplicatedDate = false;
                    var previousExistingDate= false;
                    $scope.buttonDisabled = false ;
                    var newClassroomDate = {
                        'cdId': 0,
                        'schoolId': $scope.editSchoolData.schoolId,
                        'startDate': date
                     };
                     for(var i =0;i < classroomDatesDelete.length;i++){//check if date hasn't been delete from list before
                        if(angular.equals(date,classroomDatesDelete[i].startDate)){//so a new id won't be created for same date.
                            $scope.dateTags.push(classroomDatesDelete[i]);
                            classroomDatesDelete.splice(i,1);
                            previousExistingDate = true;
                            break;
                        }
                     }
                     if(!previousExistingDate){
                        for(var i =0;i < $scope.dateTags.length;i++){
                            if(angular.equals(date,$scope.dateTags[i].startDate)){
                                duplicatedDate = true;
                                break;
                            }
                         }
                         if(!duplicatedDate){
                            $scope.dateTags.push(newClassroomDate);
                            classroomDatesCreate.push(newClassroomDate);
                         }else {
                            $scope.editErrorMsgOccurred = true;
                            $scope.editErrorMesg = "Please don't insert duplicated date";
                         }
                     }
                     
                     if((!classroomDatesCreate || classroomDatesCreate.length ==0) && ( !classroomDatesDelete || classroomDatesDelete.length ==0) ){
                         $scope.buttonDisabled = true;
                      }
                  
                }
            };

            $scope.tagRemovedClassroom = function(tag){
                $scope.buttonDisabled = false;
                $scope.clearErrorMessages();                
                if(tag.cdId!=0){
                  classroomDatesDelete.push(tag);
                } else {
                    for (var i= 0;i<classroomDatesCreate.length ;i++){
                    if(angular.equals(classroomDatesCreate[i].startDate, tag.startDate)){
                          classroomDatesCreate.splice(i, 1);
                    }
                  }  
                }
                if((!classroomDatesCreate || classroomDatesCreate.length ==0) && ( !classroomDatesDelete || classroomDatesDelete.length ==0) ){
                    $scope.buttonDisabled = true;
                }
            };  

            $scope.getSchoolDataDetails = function(grid, row, details) {
                                      
                $scope.shoolDataEdited = false;
                $scope.savedShoolData = false;

                $scope.gradeSelList = [];
                $scope.clearErrorMessages();
                              
                $scope.schoolDataRow = details ? row : $scope.$parent.schoolDataResultsGridObject.row;
                $scope.schoolDataGrid = details ? grid : $scope.$parent.schoolDataResultsGridObject.grid;
                // console.log($scope.schoolDataRow);
                // console.log($scope.schoolDataGrid);
                $scope.showPageSelected = details ? false : true;
                // console.log($scope.showPageSelected);
                if($scope.forms.Dates) {
                    if($scope.forms.Dates.$dirty){
                       $scope.shoolDataEdited = true;
                    }
                } //CHECK DIRTY
                if($scope.forms.FieldsForm) {
                    if($scope.forms.FieldsForm.$dirty){
                       $scope.shoolDataEdited = true;
                    }
                }

                if($scope.forms.grademarkForm) {
                    if($scope.forms.grademarkForm.$dirty){
                       $scope.shoolDataEdited = true;
                    }
                }

                if($scope.forms.integrationForm) {
                    if($scope.forms.integrationForm.$dirty){
                       $scope.shoolDataEdited = true;
                    }
                }

                if($scope.forms.dropDownListsForm){
                    if($scope.forms.dropDownListsForm.$dirty){
                           $scope.shoolDataEdited = true;
                    }                    
                }

                if($scope.forms.schoolYearForm){
                    if($scope.forms.schoolYearForm.$dirty){
                           $scope.shoolDataEdited = true;
                    }                    
                }

                if($scope.forms.CatalogsForm) {
                    if($scope.forms.CatalogsForm.$dirty){
                       $scope.shoolDataEdited = true;
                    }
                }

                if($scope.forms.CoursesForm) {
                    if($scope.forms.CoursesForm.$dirty){
                       $scope.shoolDataEdited = true;
                    }
                }

                if($scope.forms.mainDataForm){
                    if($scope.forms.mainDataForm.$dirty){
                        $scope.shoolDataEdited = true;
                    }
                }



                //prompt before switching to next school data
                $scope.option2 = false;

                 //get school data details on load
                if (!$scope.shoolDataEdited){
                    $scope.getSchoolDataInfo();
                } else {
                    if(!$scope.savedShoolData){
                        //if unsaved changes, alert prompt
                        if(!$scope.option2){
                            //$scope.openAlertUnsavedSchoolData();
                            $scope.openAlertUnsaved();
                        }
                        
                        $scope.modalInstance.result.then(function (option) {
                            $scope.option2 = option;
                            if(option){
                                $scope.classDatePicker.dateToAdd = '';
                                $scope.getSchoolDataInfo();
                            } else {
                                //if no option is selected from modal
                                var index=-1;
                                var Data = $scope.gridNewOptions.data;
                                for(var i=0; i< $scope.gridNewOptions.data.length; i++){
                                  if(Data[i].schoolId==$scope.currentSchoolData.schoolId){
                                    index=i;
                                    $scope.gridNewApi.selection.selectRow($scope.gridNewOptions.data[i]);
                                    break;
                                    }

                                }

                            }
                        });
                    }
                }
            };

            var getDatesList = function(data){ //populate  $scope.dateTags list 
                var starDatesList = data.classroomDateList;
                    if(data.classroomDateList){
                        for(var i=0; i< starDatesList.length; i++){
                            $scope.dateTags.push({
                                'cdId': starDatesList[i].cdId,
                                'schoolId': starDatesList[i].schoolId,
                                'startDate': starDatesList[i].startDate
                            });
                        }
                    }
            } ;

            $scope.getSchoolIntegrationDetails = function () {
                schoolDataEditSvc.getSchoolIntegrationDetails(authentication.getCurrentUser().keycode,$scope.editSchoolData.schoolId).then(function(data){
                    $scope.resetSchoolIntegrationErrors();
                    if(typeof(data) != undefined && data != null){
                        data.lastRun = typeof (data.lastRun) != 'undefined' ? moment(data.lastRun).seconds(0).toDate() : null;
                        $rootScope.integrationObject = angular.copy(data);
                        $scope.integration.object = data;
                        $scope.integration.optionSelected = $scope.integration.options.find(x => x.isIntegrated == $scope.integration.object.isIntegrated);
                        if($scope.integration.object.lastRun == null){
                            document.getElementById("integrationLastRun").value = "";
                        }
                    }
                }, function(error){
                    console.error('Error when getting School Integration Details...'.concat(angular.toJson(error)));
                        $scope.editErrorOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                })['finally'](function () {
                    $scope.isSearchBusy=false;
               });
            };

            //  get school data info service
            $scope.getSchoolDataInfo = function(){
                $scope.dropDownTypeDetails = [];
                $scope.newSetDetails = [];
                $rootScope.allGradeSets = [];
                $scope.newSet = {};
                $scope.grade = {selected: ''};
                $scope.dropdown={selectedType:''};
                $scope.cteProgSelected=false;
                $scope.futureCteProgSelected = false;
                $scope.option6 = true;
                $scope.option8 = true;
                
                $scope.gradeSetAdded = false;
                $scope.gradeSetEdited = false;               
                $rootScope.noGradeSelected = true;
                $scope.newSetSelected = false;
                $scope.disableAddYear = false;

                /*Manage School Dates Variables*/
                $rootScope.schoolYears = [];
                $scope.xschSchTerms = [];
                $scope.xschSchGrades = [];
                /*This variable will contain all new K12 terms objects for the rows 
                added by user to the existing xschSchTerms*/
                $scope.schoolTerm = {selected: []}; 
                $scope.schoolYearAdded = false;
                $scope.schoolYearEdited = false;
                $scope.newSchoolYearSelected = false
                $scope.noSchoolYearSelected = true;
                $scope.noSchoolYearDeletedSelected = true;
                $scope.option8 = false;
                $scope.schoolYear = {
                    selected: null
                }
                $scope.deleteSchoolYearDisabled = true;
                $scope.schTermsError = false;

                //Holidays variables
                $scope.schoolYearHolyDatePicker = [];
                $scope.openDatePickerHolydayByName = function(datePickerName) {
                    $scope.schoolYearHolyDatePicker[datePickerName] = true;
                };

                $scope.isSearchBusy = true;
                //$scope.editErrorMesg="";
                $rootScope.hideSchoolDataSearch = true;
                $scope.dateTags=[];
                $scope.editSchoolData = angular.copy($scope.schoolDataRow.entity);


                /* Manage Course Catalog Variables */
                $scope.k12CoursesModalErrorMessage = "";
                $scope.k12CoursesModalErrorOccurred = false;
                $scope.closeK12CoursesModal = true;
                $scope.displayK12CoursesGrid = false;
                $scope.catalogSchoolYearSelected;
                $scope.catalogSchoolTermSelected;

                /* Manage Default Course Variables */
                $scope.courseSchoolYearSelected = {};
                $scope.courseSchoolTermSelected = {};
                $scope.courseSchoolGradeSelected = {};

                /* Manage Integration Variables */
                $scope.integration = {
                    optionSelected: {},
                    options: [
                        {
                            isIntegrated: 0,
                            name: "No Integration"
                        },
                        {
                            isIntegrated: 1,
                            name:  "Integrate All"
                        },
                        {
                            isIntegrated: 2,
                            name: "Integrate School, School Courses and Reg. Mail Only"
                        },
                        {
                            isIntegrated: 3,
                            name: "Closed School"
                        },
                    ]
                };

                //get School Main Data
                schoolDataEditSvc.getSchoolMainData(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId)
                .then(function (data) {
                    if(data){
                        $scope.schoolMainData = data;
                        $scope.mainData.object = angular.copy($scope.schoolMainData);
                        resetMainDataValidationErrors();
                    }
                },function(error) {
                    console.info('Error when getting School Main Data....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                //get K12 Country States
                schoolDataEditSvc.getK12CountryStates(authentication.getCurrentUser().keycode)
                .then(function (data) {
                    if(data && data.length > 0){
                        $scope.k12CountryStates = data;
                    }
                },function(error) {
                    console.info('Error when getting K12 Country States....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                //get K12 Country Regions
                schoolDataEditSvc.getK12CountryRegions(authentication.getCurrentUser().keycode)
                .then(function (data) {
                    if(data && data.length > 0){
                        $scope.k12CountryRegions = data;
                    }
                },function(error) {
                    console.info('Error when getting K12 Country Regions....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                //Get K12 Billings
                schoolDataEditSvc.getK12Billings(authentication.getCurrentUser().keycode)
                .then(function (data) {
                    if(data && data.length > 0){
                        $scope.k12Billings = data;
                    }
                },function(error) {
                    console.info('Error when getting K12 Billings....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                //Get K12 School Types
                schoolDataEditSvc.getK12SchoolTypes(authentication.getCurrentUser().keycode)
                .then(function (data) {
                    if(data && data.length > 0){
                        $scope.k12SchoolTypes = data;
                    }
                },function(error) {
                    console.info('Error when getting K12 School Types....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                //get classroom dates
                schoolDataEditSvc.getClassroomDates(authentication.getCurrentUser().keycode,$scope.editSchoolData.schoolId)
                .then(function (data) {
                    if(data){

                        getDatesList(data);
                        if ($scope.showPageSelected){
                             $scope.gridNewApi.pagination.seek($scope.$parent.schoolDataResultsGridObject.currentPage);
                        }
                        $scope.gridNewApi.selection.selectRow($scope.schoolDataRow.entity);
                        $scope.currentSchoolData = angular.copy($scope.editSchoolData); 
                        $scope.currentDateTags = angular.copy($scope.dateTags);
                        $scope.resetForms();

                    }
                },function(error) {
                    console.info('Error when getting classroom startdates....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                //get data fields
                schoolDataEditSvc.getDataFields(authentication.getCurrentUser().keycode,$scope.editSchoolData.schoolId)
                .then(function (data) {
                    if(data){
                        $scope.record = {};
                        $scope.record.dataFields = data.dataFieldList;

                        // getDatesList(data);
                        if ($scope.showPageSelected){
                             $scope.gridNewApi.pagination.seek($scope.$parent.schoolDataResultsGridObject.currentPage);
                        }
                        $scope.gridNewApi.selection.selectRow($scope.schoolDataRow.entity);
                        $scope.currentSchoolData = angular.copy($scope.editSchoolData); 
                        $scope.currentDataFields = angular.copy($scope.record.dataFields);
                        // console.info('Current DataFields:'.concat( $scope.currentDataFields) );
                        $scope.list = angular.copy($scope.currentDataFields);
                        $scope.resetForms();

                    }
                },function(error) {
                    console.info('Error when getting data fields....'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })

                schoolDataEditSvc.getAllGradesList(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId)
                    .then(function (data) {

                        if (data) {
                            $rootScope.allGradeSets = data;
                            $scope.currentGrades = data;
                            $scope.resetManageGradePanel();

                        }

                    },function(error) {
                        console.error('Error when getting grades....'.concat(angular.toJson(error)));
                        $scope.editErrorOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })

                schoolDataEditSvc.getAllSchoolYear(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId)
                    .then(function (data) {
                        if (data.schoolYearList && data.schoolYearList.length > 0) {
                            // $rootScope.allSchoolYear = data.schoolYearList;
                            $rootScope.schoolYears = data.schoolYearList;
                            $scope.currentSchoolYears = data.schoolYearList;
                            $scope.currentSchoolYearsDeleted = angular.copy(data.schoolYearList);
                            $scope.resetSchoolYearForm();

                            $scope.catalogStatus = { isYearOpen: new Array($scope.schoolYears.length),
                                                     isTermOpen: new Array($scope.xschSchTerms.length),
                                                   }; 

                            $scope.courseStatus = { isYearOpen: new Array($scope.schoolYears.length),
                                                     isTermOpen: new Array($scope.xschSchTerms.length),
                                                     isGradeOpen: new Array($scope.xschSchGrades.length)
                                                   };
                            //Create SchoolYear DropDown Options based on AllSchoolYears activated to the school
                            $scope.mainData.fillInSchoolYearOptions(data.schoolYearList);
                        } else{
                            $scope.schoolYears = [];
                        }

                    },function(error) {
                        console.error('Error when getting school years....'.concat(angular.toJson(error)));
                        $scope.editErrorOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    });

                    schoolDataEditSvc.getDropdownList(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId)
                    .then(function (data) {
                        if(data){
                        $scope.dropDownLists = data;
                        // console.log("$scope.dropDownLists", $scope.dropDownLists)
                        }

                    },function(error) {
                        console.error('Error when getting Dropdown options...'.concat(angular.toJson(error)));
                        $scope.editErrorOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })

                ['finally'](function () {
                     $scope.isSearchBusy=false;

                });

                //School Integration Details
                $scope.getSchoolIntegrationDetails();
                
            };
         
            /******* Drop Down List*********/
            
            $scope.loadingSchoolPeriod = false;

            $scope.openAlertDropDownListUnsaved = function (size) {
                $scope.modalInstanceDropDwon = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    size: size,
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {
                            $uibModalInstance.close(true);

                        };

                        $scope.dialogMsg = 'You have un-saved changes for the List Type. Do you want to continue without saving the changes?';
                        $scope.cancel = function () {
                            $uibModalInstance.close(false);
                        };
                    }], 
                    
                });
             };
            
            $scope.changeDropDownList = function(){
                console.log("dropdown.selectedType", $scope.dropdown.selectedType)
                
                if($scope.forms.dropDownListsForm.$dirty){
                    $scope.openAlertDropDownListUnsaved();
                    $scope.modalInstanceDropDwon.result.then(function(option) {

                        if (option) {
                            $scope.forms.dropDownListsForm.$setPristine();
                            getAllDropDownTypeDetails();

                            $scope.allCTEProgList = angular.copy($scope.currentCTEProgList); 
                            $scope.allPartProgramList = angular.copy($scope.currentPartProgramList);
                            $scope.dropDownTypeDetails = angular.copy($scope.currentDownTypeDetails);  
                            refreshDropDownList(); 
                        }else{
                            $scope.dropdown = angular.copy($scope.currentDropdown); 
                            console.log("no selected", $scope.dropDownTypeDetails)
                        }
                    } );   
                } else {
                    refreshDropDownList();
                    getAllDropDownTypeDetails();
                }                 
            }

            var refreshCTEShowHiddenValues = function ( ){
                if($scope.dropdown.selectedType==2){
                  $scope.cteProgSelected=true;
                  const allCteList = ($scope.allCTEProgList || []);
                  $scope.CTEList = allCteList
                  .filter(cte=>cte.status === 1)
                  .map(cte=> ({ id: cte.cteId, name: cte.name, isFuture: !!cte.isFutureCte, isCurrent: !!cte.isCurrentCte, displayName: cte.displayName, xschcteid: cte.xschcteid, status: cte.status, isSaved: true }));

                  const addedId = [];
                  $scope.cteOptionsList = allCteList.reduce((arr, cte) => {
                    if (!addedId.includes(cte.cteId)){
                      arr.push(cte)
                      addedId.push(cte.cteId)
                    }
                    return arr
                  }, []);;
                }
            }

            $scope.dropDownListExtraErrors = [];
            $scope.cteOptionsList = [];

            $scope.addCteNewRow = () => {
              $scope.forms.dropDownListsForm.$setDirty();
              $scope.CTEList.push({
                id: null,
                name: null,
                isFuture: true,
                isCurrent: true,
                status: 1,
                displayName: '',
                isSaved: false,
              })
            }
        
            $scope.onChangeCTEName = (cte) => {
              cte.name = cte.displayName = $scope.allCTEProgList.find(c => c.cteId === cte.id).name;
            }
        
            $scope.activeCTEList = () => $scope.CTEList.filter(cte=>cte.status === 1);
        
            $scope.removeCteRow = (cte) => {
              $scope.forms.dropDownListsForm.$setDirty();
              cte.status = 0;
            }
        
            $scope.isCteFieldErrorShown = (index, field) => {
              return $scope.forms.dropDownListsForm.$submitted && $scope.forms.dropDownListsForm[`cteForm_${index}`][field].$error.required
            }

            var refreshDropDownList = function(){
                $scope.currentDropdown = angular.copy($scope.dropdown);
                $scope.editReasonErrorOccurred = false;
                $scope.editYearErrorOccurred = false;
                $scope.cteProgSelected=false;
                $scope.futureCteProgSelected = false;
                $scope.dropDownListExtraErrors = [];
                if($scope.showSavedSchoolDataMsg){
                    $scope.showSavedSchoolDataMsg = false;
                } 
                refreshCTEShowHiddenValues();
            }
	    
	    //school Periods errors messages
            $scope.schoolPeriodInvalidSequenceValue = schoolwork12.app.manageSchoolData.errorMessages.schoolPeriodInvalidSequenceValue;
            $scope.schoolPeriodSequenceRequired = schoolwork12.app.manageSchoolData.errorMessages.schoolPeriodSequenceRequired;
            $scope.schoolPeriodSequenceUnique = schoolwork12.app.manageSchoolData.errorMessages.schoolPeriodSequenceUnique;
            $scope.schoolPeriodNameRequired = schoolwork12.app.manageSchoolData.errorMessages.schoolPeriodNameRequired;
            $scope.schoolPeriodNameUnique = schoolwork12.app.manageSchoolData.errorMessages.schoolPeriodNameUnique;

            $scope.schoolPeriodChanged = function(schoolPeriod){
                schoolPeriod.edited = true;
            }

            $scope.deleteSchoolPeriod = function (index,record) {
                if($scope.dropdown.selectedType == 6){
                    var dialogMsg = "You are about to delete School Period '" + record.name + "' Do you want to continue?";
                    $scope.schoolPeriodModalInstance = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'delSchoolPeriod.html',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'alert-Modal',
                        scope: $scope,
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.schoolPeriodDialogMsg = dialogMsg;
                            $scope.okDelSchoolPeriod = function () {
                                if(record.spId == -1 ){
                                    $scope.dropDownTypeDetails.splice(index,1);
                                }else{
                                    record.status = 0;
                                    record.edited = true;
                                }
                                $scope.forms.dropDownListsForm.$setDirty();
                                $uibModalInstance.close(true);
                            };  
                            $scope.cancelDelSchoolPeriod = function () {
                                $uibModalInstance.close(false);
                            };
                        }], 
                        
                    });
                }
            }

            $scope.addSchoolPeriod = function () {
                if($scope.dropdown.selectedType == 6){
                    var schoolPeriodTemp = {
                        "spId": -1,
                        "schoolId": $scope.editSchoolData.schoolId,
                        "name": "",
                        "sequence": null,
                        "status": 1,
                        "createdByName": "",
                        "createDate": "",
                        "modifiedByName": "",
                        "modifyDate": ""
                    }
                    $scope.dropDownTypeDetails.push(schoolPeriodTemp);
                    $scope.forms.dropDownListsForm.$setDirty();
                }
            }

            var getAllDropDownTypeDetails = function(){
                $scope.loadingSchoolPeriod = true;
                schoolDataEditSvc.getAllDropdownTypes(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, $scope.dropdown.selectedType)
                    .then(function (data) {
                        if(data){

                            if($scope.dropdown.selectedType==4){
                                $scope.allPartProgramList = data;

                                angular.forEach($scope.allPartProgramList, function (row) {
                                    if(row.displayName == null){
                                        row.displayName = angular.copy(row.name);
                                    }
                                });
                                $scope.currentPartProgramList = angular.copy($scope.allPartProgramList);
                            }

                            if($scope.dropdown.selectedType==2 || $scope.dropdown.selectedType==3){
                                $scope.allCTEProgList = data;

                                angular.forEach($scope.allCTEProgList, function (row) {
                                    if(row.displayName == null){
                                        row.displayName = angular.copy(row.name);
                                    }
                                });
                                refreshCTEShowHiddenValues();
                                $scope.currentCTEProgList = angular.copy($scope.allCTEProgList);
                            }

                            if($scope.dropdown.selectedType==5){
                                $scope.dropDownTypeDetails = data;
                                angular.forEach($scope.dropDownTypeDetails, function (row) {
                                    if(row.xschEthyId != -1){
                                        row.schoolEthyId = 1
                                    } else{
                                        row.schoolEthyId = -1
                                    }
                                });
                            }
                            
                            $scope.dropDownTypeDetails = data;
                            $scope.currentDownTypeDetails = angular.copy($scope.dropDownTypeDetails);
                            $scope.currentSchoolData = angular.copy($scope.editSchoolData); 
                            // console.log("$scope.dropDownTypeDetails", $scope.dropDownTypeDetails)
                        }else{// We need to reset in case the service returned empty response.
                            $scope.dropDownTypeDetails = [];
                            $scope.currentDownTypeDetails = [];
                        }

                    },function(error) {
                        console.error('Error when getting Dropdown details by type...'.concat(angular.toJson(error)));
                        $scope.editErrorOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })['finally'](function () {
                        $scope.loadingSchoolPeriod = false;
                    });

                    $scope.resetSchoolPeriodsErrors = function(){
                        $scope.dropDownTypeDetails.forEach(function(value,index){
                            if($scope.forms.dropDownListsForm['schoolPeriod_'+index]){
                                $scope.forms.dropDownListsForm['schoolPeriod_'+index]['sequence'].$setValidity('sequenceRequired', true);
                                $scope.forms.dropDownListsForm['schoolPeriod_'+index]['sequence'].$setValidity('sequenceValid', true);
                                $scope.forms.dropDownListsForm['schoolPeriod_'+index]['sequence'].$setValidity('sequenceDuplicated', true);
                                $scope.forms.dropDownListsForm['schoolPeriod_'+index]['name'].$setValidity('nameRequired', true);
                                $scope.forms.dropDownListsForm['schoolPeriod_'+index]['name'].$setValidity('nameDuplicated', true);
                            }
                        },$scope.dropDownTypeDetails);
                    }

                    $scope.isSchoolPeriodsCheckValid = function (){
                        $scope.resetSchoolPeriodsErrors();
                        var isSchoolPeriodsValid = true;
                        var schoolPeriodsIterated = [];
                        //filter out those schoolperiods with status 0
                        var tempSchoolPeriods = $scope.dropDownTypeDetails.filter(x => x.status == 1);
                        tempSchoolPeriods.forEach(function (schoolPeriod,index) {
                            if($scope.forms.dropDownListsForm['schoolPeriod_'+index]){
                                var duplications =  $scope.checkSchoolPeriodDuplication(schoolPeriodsIterated,schoolPeriod);
                                //sequence field validations
                                if(typeof (schoolPeriod.sequence) == 'undefined'){
                                    $scope.forms.dropDownListsForm['schoolPeriod_'+index]['sequence'].$setValidity('sequenceValid', false);
                                    isSchoolPeriodsValid = false;
                                }else if(schoolPeriod.sequence == null){
                                    $scope.forms.dropDownListsForm['schoolPeriod_'+index]['sequence'].$setValidity('sequenceRequired', false);
                                    isSchoolPeriodsValid = false; 
                                }else if(duplications.sequence > 0){
                                    $scope.forms.dropDownListsForm['schoolPeriod_'+index]['sequence'].$setValidity('sequenceDuplicated', false);
                                    isSchoolPeriodsValid = false;
                                }

                                //name field validations
                                if(schoolPeriod.name == null || typeof (schoolPeriod.name) == 'undefined' || schoolPeriod.name == ''){
                                    $scope.forms.dropDownListsForm['schoolPeriod_'+index]['name'].$setValidity('nameRequired', false);
                                    isSchoolPeriodsValid = false;
                                }else if(duplications.name > 0){
                                    $scope.forms.dropDownListsForm['schoolPeriod_'+index]['name'].$setValidity('nameDuplicated', false);
                                    isSchoolPeriodsValid = false;
                                }
                                schoolPeriodsIterated.push(schoolPeriod);
                            }
                        });
                        return isSchoolPeriodsValid;
                    }

                    $scope.checkSchoolPeriodDuplication = function (arrayToIterate,schoolPeriod) {
                        var duplicatedName = 0;
                        var duplicatedSequence = 0;
                        arrayToIterate.forEach(function (item) {
                            if(schoolPeriod.name == item.name && schoolPeriod.sequence == item.sequence){
                                duplicatedName++;
                                duplicatedSequence++;
                            }else if (schoolPeriod.name == item.name){
                                duplicatedName++;
                            }else if(schoolPeriod.sequence == item.sequence){
                                duplicatedSequence++;
                            }
                        });
                        return {'name': duplicatedName, 'sequence': duplicatedSequence}
                    }

            }
            
            /**************** Drop Down List*************/

        /************ MANAGE GRADEMARK SETS ************/
          $scope.isGradeSelected = false; 
            //color picker functionality
            $scope.colors =  [
                //new colors requested
                '#69BE27',
                '#BDD221',
                '#FFCA4B',
                '#FE8C00',
                '#EE4046',
                '#E7E7E7'
            ];

                $scope.changeColor = function(color, parentIndex){
                    $scope.initChangeColor(color, parentIndex);
                    $scope.forms.grademarkForm.$setDirty();
                }

                $scope.initChangeColor = function(color, parentIndex){                  
                    if($scope.newSetSelected){
                        $scope.newSetDetails[parentIndex].selectedColor = color;
                    }                    
                }

                $scope.changeSelColor = function(color, record){ 
                    // console.log("change color", $scope.selectedSetDetails, color, record);
                    record.selectedColor = color;
                    record.edited = true;
                    $scope.forms.grademarkForm.$setDirty();
                }

                //Get list of grademark sets
                $scope.changeGrademarkSet = function(selGradeSet){
                $scope.option6 = false;
                $scope.forms.grademarkForm['gradeSetName'].$setValidity('nameValid', true);

                if($scope.showSavedSchoolDataMsg){
                    $scope.showSavedSchoolDataMsg = false;
                }
                $scope.isGradeSelected = true; 
                // console.log("$scope.grade", $scope.grade);
                // console.log("$scope.selGradeSet", selGradeSet);
    
                    if(!$scope.option6 && $scope.forms.grademarkForm.$dirty){
                        console.log("change grade - alert");
                        $scope.changeGradeSetDirty = true;

                        $scope.openAlertGrademarkUnsaved(selGradeSet);
                        console.log("selGradeSet", selGradeSet);
                    } else {
                      console.log("fetch gradedetails");  
                      $scope.getGradeDetails(selGradeSet);
                    }
                }

                $scope.getGradeDetails = function(selGradeSet){
                        $scope.editGradeMErrorMsgOccurred =false;
                        $scope.editGradeMErrorOccurred= false;

                        $scope.noGradeMarks= false;
                        $scope.allGradeSetsCopy = angular.copy($scope.allGradeSets);
                        var a = $scope.allGradeSetsCopy.pop();
                        if(!a.hasOwnProperty('status')){
                            console.log("newset selected");
                            $scope.gradeSetAdded = true;
                        } else {
                            $scope.gradeSetAdded = false;
                        }

                        $scope.grademarkSet = selGradeSet;
                        console.log("selGradeSet - getGradeDetails", selGradeSet);

                        $rootScope.noGradeSelected = false;
                        $scope.forms.grademarkForm.$setPristine();  

                        if(angular.isDefined($scope.grademarkSet) && $scope.grademarkSet!=null && $scope.grademarkSet!='' && $scope.grademarkSet!=1){
                            $scope.newSetSelected  = false;
                            $rootScope.noGradeSelected = false;
                            schoolDataEditSvc.getAllGradesDetails(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, $scope.grademarkSet)
                                .then(function (data) {
                                    if (data) {
                                        $scope.allGradeDetails = data;
                                        console.log("$scope.allGradeDetails HERE", $scope.allGradeDetails);
                                        $scope.selectedSetDetails =angular.copy($scope.allGradeDetails.gradeMarksList);                        
                                    }
                                },function(error) {
                                    console.error('Error when getting grade details....'.concat(angular.toJson(error)));
                                    $scope.editErrorOccurred = true;
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                                    }
                                });
                            } else{
                                console.log("else block,", $scope.grademarkSet);
                                 if(angular.isDefined($scope.displayNewSet)){
                                    $scope.displayNewSet = {
                                        'gradeMarkSetId' : '',    
                                        'nameAndId': "New Grademark Set1",
                                        'name': "New Grademark Set1",
                                    }
                                    $scope.gradeSetAdded = true; 
                                    console.log("displayNewSet exists")
                                 } else {
                                    $scope.newSetDetails.push({
                                        abbreviation: "",
                                        selectedColor: "#FFFFFF",
                                        name: "",
                                        nextCourse: "0",
                                        status: "1"
                                    }) 
                                 }
                               
                                $scope.newSetSelected  = true;
                                $rootScope.noGradeSelected = false; 
                            }
                }


                $scope.counter = 1;
                $scope.option6 = false;
                // $scope.newSetAdded = false;
                $scope.addGrademarkSet = function(){
                    $scope.editGradeMErrorMsgOccurred =false;
                    $scope.editGradeMErrorOccurred= false;
                    if($scope.forms.grademarkForm.$dirty){
                         $scope.forms.grademarkForm.$setDirty();
                    }
                   
                    $scope.option6 = false;
                    $scope.noGradeMarks = false;
                    $scope.isGradeSelected = true;

                    if(!$scope.option6 && (!$rootScope.noGradeSelected && $scope.forms.grademarkForm.$dirty)){
                        $scope.gradeSetEdited = true;
                        console.log("addGrademarkSet");

                         $scope.openAlertGrademarkUnsaved();

                          $scope.modalInstance6.result.then(function (option) {
                            $scope.option6 = option;
                            console.log("option ",option );
                            console.log("$scope.newSetSelected ",$scope.newSetSelected );

                            if(option && !$scope.newSetSelected){

                                 $scope.newSetSelected = true;
                                 $scope.displayNewSet = {
                                    'gradeMarkSetId' : $scope.savedId,    
                                    'nameAndId': "New Grademark Set1",
                                    'name': "New Grademark Set1",
                                 }
                                 $scope.gradeSetAdded = true;
                                 $rootScope.allGradeSets.push($scope.displayNewSet);

                                 $scope.grade.selected = (_.last($rootScope.allGradeSets)).gradeMarkSetId;
                                 console.log("_.last($scope.allGradeSets)", $scope.grade.selected); 
                            } 
                         });

                    } else {
                         console.log("else here")
                         if($scope.newSet.hasOwnProperty('name')){
                           console.log("newset exists");
                         } else {
                            $scope.newSet =  {
                                'gradeMarkSetId' : '',    
                                'nameAndId': "New Grademark Set" + $scope.counter,
                                'name': "New Grademark Set" + $scope.counter,                    
                             };
                            $rootScope.allGradeSets.push($scope.newSet);
                            $scope.displayNewSet = angular.copy($scope.newSet);
                            $scope.newSetEdited = true;
                            console.log("addGrademarkSet else block - simple add")
                         }
                        $scope.gradeSetAdded = true;
                        $scope.newSetSelected  = true;
                        $rootScope.noGradeSelected = false;
                    }

                }


                $scope.addGrademarkSummaryNew = function(){
                    console.log("add new grademark row");
                     $scope.forms.grademarkForm.$setDirty();
                     $scope.newSetDetails.push({
                            abbreviation: "",
                            selectedColor: "#FFFFFF",
                            name: "",
                            nextCourse: "0",
                             status: 1

                        })
                }

                $scope.addGrademarkSummary = function(){
                    console.log("add existing grademark row");
                    $scope.forms.grademarkForm.$setDirty();
                        $scope.selectedSetDetails.push({
                            abbreviation: "",
                            selectedColor: "#FFFFFF",
                            name: "",
                            nextCourse: "0",
                            addGradeClicked: true,
                            status: 1,
                            edited: true
                        });
                    // $scope.selectedSetDetails =angular.copy($scope.allGradeDetails.gradeMarksList);  
                }

                $scope.option5 = false;
                $scope.modalInstance3 = null;
                $scope.deleteGrademarkSetNew = function(){
                    console.log("deleteGrademarkSetNew");
                    $scope.forms.grademarkForm.$setDirty();
                    if(!$scope.option5){
                         $scope.openAlertDeleteGrademarkSetNew();
                    }  
                    
                }

                $scope.option7 = false;
                $scope.modalInstance4 = null;
                $scope.deleteGrademarkSet = function(){
                    console.log("deleteGrademarkSet");
                    grademarkDeleted=true;
                    $scope.forms.grademarkForm.$setDirty();
                    if(!$scope.option7){
                         $scope.openAlertDeleteGrademarkSet();
                    }  
                    
                }

                $scope.option3 = false;
                $scope.modalInstance1 = null;
                $scope.deleteGrademarkRow = function(index, record){
                    console.log("delete grademark row", index, record);
                     $scope.forms.grademarkForm.$setDirty();
                     if(!$scope.option3){
                         $scope.openAlertDeleteGrademarkRow(index, record);
                     }  
                }

                $scope.option4 = false;
                $scope.modalInstance2 = null;
                $scope.deleteGrademarkRowNew = function(index, record){
                    console.log("delete grademark row", index);
                     $scope.forms.grademarkForm.$setDirty();
                      if(!$scope.option4){
                         $scope.openAlertDeleteGrademarkRowNew(index, record);
                     }  
                }

                $scope.openAlertGrademarkUnsaved = function(selGradeSet){
                    $scope.modalInstance6 = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'addGrademark.html',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'alert-Modal',
                        scope: $scope,
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.okAddGradeSet = function () {
                               
                                if(!$scope.newSetSelected && !$scope.changeGradeSetDirty){
                                    $scope.newSet =  {
                                        'gradeMarkSetId' : '',    
                                        'name': "New Grademark Set" + $scope.counter,                    
                                    };
                                   
                                    $scope.displayNewSet = angular.copy($scope.newSet);
                                    console.log("new grademark set added - YES: no new set sel", $scope.allGradeSets);
                                } 

                                if($scope.changeGradeSetDirty && $scope.forms.grademarkForm.$dirty && !$scope.gradeSetEdited){
                                  console.log("ok 1 - changeGradeSetDirty");
                                  $scope.gradeSetAdded = false;
                                  $scope.getGradeDetails(selGradeSet);
                                }  

                                if($scope.forms.grademarkForm.$dirty && $scope.gradeSetAdded){
                                  console.log("ok 2 - changeGradeSetDirty");
                                  $scope.getGradeDetails(selGradeSet);
                                  $scope.forms.grademarkForm.$setPristine();    
                                  console.log("$scope.allGradeSets", $scope.allGradeSets)

                                }  

                                $scope.gradeMarkSaved = false;
                                $uibModalInstance.close(true);
                            };  
                                
                            $scope.dialogMsg = "You have unsaved changes for the current Grademark Set. Do you want to continue without saving the changes?";
                            
                            $scope.cancelAddGradeSet = function () {
                                  console.log("new grademark set added - NO", $scope.allGradeSets);
                                  
                                  if($scope.gradeSetAdded){
                                    $rootScope.allGradeSets.pop();
                                    $scope.grade.selected = (_.last($rootScope.allGradeSets)).gradeMarkSetId;
                                    console.log("_.last($scope.allGradeSets)", $scope.grade.selected);
                                  }

                                if($scope.changeGradeSetDirty){
                                    console.log("NO - changeGradeSetDirty");
                                }    

                                $uibModalInstance.close(false);
                            };
                        }], 
                        
                    });
                }

                $scope.openAlertDeleteGrademarkRow = function(index, record){
                    $scope.modalInstance1 = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'deleteGrademark.html',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'alert-Modal',
                        scope: $scope,
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.okDelete = function () {
                                if(record.gradeMarkId && record.gradeMarkId!=0){
                                    record.status=0;
                                    record.edited=true;
                                }else{
                                   $scope.selectedSetDetails.splice(index,1);
                                }

                                $uibModalInstance.close(true);
                            };  
                                $scope.dialogMsg = "You are about to delete Grademark " + record.abbreviation + ". Do you want to continue?";
                            $scope.cancelDelete = function () {
                                $uibModalInstance.close(false);
                            };
                        }], 
                        
                    });
                }

                $scope.openAlertDeleteGrademarkRowNew = function(index, record){
                    $scope.modalInstance2 = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'deleteGrademark.html',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'alert-Modal',
                        scope: $scope,
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.okDelete = function () {
                                $scope.newSetDetails.splice(index,1);
                                $uibModalInstance.close(true);
                            };  
                                $scope.dialogMsg = "You are about to delete Grademark " + record.abbreviation + ". Do you want to continue?";
                            $scope.cancelDelete = function () {
                                $uibModalInstance.close(false);
                            };
                        }], 
                        
                    });
                }

            $scope.resetManageGradePanel = function () {
                $scope.resetForms();
                $scope.grade = {selected: ''};
                $rootScope.noGradeSelected = true;
                $scope.gradeSetAdded = false;
                $rootScope.allGradeSets = angular.copy($scope.currentGrades);
                resetNewGradeMark();
            }
            
            $scope.resetDropDownPanel = function () {
                $scope.resetForms();
                $scope.dropdown ={selectedType:''};
                $scope.cteProgSelected=false;
                $scope.futureCteProgSelected = false;
                $scope.editSchoolData = angular.copy($scope.currentSchoolData); 
                $scope.allCTEProgList = angular.copy($scope.currentCTEProgList); 
                $scope.allPartProgramList = angular.copy($scope.currentPartProgramList); 
                $scope.dropDownTypeDetails = angular.copy($scope.currentDownTypeDetails); 
                // console.log("reset DropDownPanel",  $scope.allCTEProgList);
            }

                var resetNewGradeMark = function (){
                    $scope.editGradeMErrorMsgOccurred =false;
                    $scope.editGradeMErrorOccurred= false;
                    $scope.displayNewSet = {
                                        'gradeMarkSetId' : '',    
                                        'nameAndId': "New Grademark Set1",
                                        'name': "New Grademark Set1",
                                    }
                    $scope.newSetDetails= [];
                    $scope.newSetDetails.push({
                            abbreviation: "",
                            selectedColor: "#FFFFFF",
                            name: "",
                            nextCourse: "0",
                            status:1,
                        })
                }

                $scope.openAlertDeleteGrademarkSetNew = function(){
                    $scope.modalInstance3 = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'deleteGrademark.html',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'alert-Modal',
                        scope: $scope,
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.okDelete = function () {
                                console.log("deleted new");
                                $rootScope.allGradeSets.pop();
                                $scope.resetManageGradePanel();
                                $scope.grade.selected = (_.last($rootScope.allGradeSets)).gradeMarkSetId;
                                $uibModalInstance.close(true);
                            };  
                                $scope.dialogMsg = "You are about to delete Grademark Set " + $scope.displayNewSet.name + ". Do you want to continue?";
                            $scope.cancelDelete = function () {
                                $uibModalInstance.close(false);
                            };
                        }], 
                        
                    });
                }


                $scope.openAlertDeleteGrademarkSet = function(){
                    $scope.modalInstance4 = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'deleteGrademark.html',
                        keyboard: false,
                        backdrop: 'static',
                        windowClass: 'alert-Modal',
                        scope: $scope,
                        controller: ['$scope', '$uibModalInstance',
                        function ($scope, $uibModalInstance) {
                            $scope.okDelete = function () {
                                console.log("deleted");
                                console.log("selgrade", $scope.grade.selected);
                               
                                var updatedArray = angular.copy($rootScope.allGradeSets);
                                updatedArray = updatedArray.filter(function( obj ) {
                                    console.log("$scope.grade.selected", $scope.grade.selected)
                                    return obj.gradeMarkSetId != $scope.grade.selected;
                                });

                                $rootScope.noGradeSelected = true;
                                $rootScope.allGradeSets = angular.copy(updatedArray);
                               
                                console.log("allGradeSets updated", $rootScope.allGradeSets);
                                $scope.grade.selected = (_.last($rootScope.allGradeSets)).gradeMarkSetId;
                                $scope.allGradeDetails.status=0;
                                $uibModalInstance.close(true);
                            };  
                                $scope.dialogMsg = "You are about to delete Grademark Set " + $scope.allGradeDetails.name + ". Do you want to continue?";
                            $scope.cancelDelete = function () {
                                console.log("no - delete");
                                // $scope.grade.selected = (_.last($rootScope.allGradeSets)).gradeMarkSetId;
                                // $rootScope.noGradeSelected = true;
                                $uibModalInstance.close(false);
                            };
                        }], 
                        
                    });
                }

            
            /********************************************* */
            /************* MANAGE SCHOOL DATES ************ */
            /********************************************* */

                /**
                 * STT-8343
                 * STT.7626a.1 User views existing terms for an existing school year and makes term edits
                 * Developer Comment: this method was defined in order to call the service for retrieving xschSchTerms1, 
                 * if latestYearTerms parameter is sent different to 0 means that response array will be iterated to set xschSchTerms.id = -1
                 * in order to add these xschSchTerms to a new year. */
                $scope.setXschSchTerms = function(year, latestYearTerms = 0){
                    //SIS-1018
                    $scope.setSchoolTerms = [];
                    $scope.schoolTerm = {selected: []};
                    schoolDataEditSvc.getXschSchTerms(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId,year)
                        .then(function(data){
                            console.log("XschSchTerms were fetched successfully");
                            if(data){
                                // This variable will contain original xschSchTerms list retrieved by service
                                $scope.xschSchTerms = data;
                                // thiss variable will be used to render xschSchTerms on grid and also handle changes
                                $scope.setSchoolTerms = angular.copy($scope.xschSchTerms);
                                if(latestYearTerms != 0){
                                    $scope.setSchoolTerms.forEach(function(item, index){
                                        item.id = -1;
                                        item.year = -1;
                                        item.edited = true;
                                        //SIS-1030: Term name is reset to "Select" after remove another term
                                        $scope.schoolTerm.selected[index] = "";
                                    },$scope.setSchoolTerms)
                                }
                                // console.log($scope.setSchoolTerms);
                            }
                        }, function(error){
                            console.info('Error when retrieving XschSchTerms...'.concat(angular.toJson(error)));
                            $scope.editErrorOccurred = true;
                            $scope.editErrorMsgOccurred = true;
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        })['finally'](function () {
                            $scope.isSearchBusy=false;
                        });
                }

            //clear off validation msgs
                $scope.resetSchoolYearErrorMsgs = function(){
                    if($scope.displayNewSchoolYear && !$scope.displayNewSchoolSet){
                        $scope.forms.schoolYearForm['year'].$setValidity('nameValid', true);
                        $scope.forms.schoolYearForm['schoolYearStartDate'].$setValidity('startDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearStartDate'].$setValidity('startDateValid', true);
                        $scope.forms.schoolYearForm['schoolYearEndDate'].$setValidity('endDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearEndDate'].$setValidity('endDateValid', true);
                        $scope.forms.schoolYearForm['schoolYearCourseStartDate'].$setValidity('courseStartDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearCourseStartDate'].$setValidity('courseStartDateValid', true);
                        $scope.forms.schoolYearForm['schoolYearCourseEndDate'].$setValidity('courseEndDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearCourseEndDate'].$setValidity('courseEndDateValid', true);
                    }
                    
                    if($scope.displayNewSchoolSet && !$scope.displayNewSchoolYear){
                        $scope.forms.schoolYearForm['yearVal'].$setValidity('nameValid', true);
                        $scope.forms.schoolYearForm['yearVal'].$setValidity('yearInvalid', true);
                        $scope.forms.schoolYearForm['newSchoolYearStartDate'].$setValidity('startDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearStartDate'].$setValidity('startDateValid', true);
                        $scope.forms.schoolYearForm['newSchoolYearEndDate'].$setValidity('endDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearEndDate'].$setValidity('endDateValid', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseStartDate'].$setValidity('courseStartDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseStartDate'].$setValidity('courseStartDateValid', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseEndDate'].$setValidity('courseEndDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseEndDate'].$setValidity('courseEndDateValid', true);
                    }
                    $scope.schTermsError = false;
                    $scope.editYearErrorOccurred = false;
                }

           // this method gets internally invoked from and on $scope.changeSchoolYearSet
           $scope.getSchoolYearDetails = function(schoolYear,operation){
                $scope.noSchoolYearSelected = false;
                $scope.noSchoolDeletedYearSelected = false;
                $scope.invalidNewSchoolYearError = false;
                $scope.duplicateSchoolYearError = false;
                $scope.schoolYearAdded = (schoolYear && schoolYear.id != -1) ? false : true;

                if(angular.isDefined($scope.schoolYears)){
                    //point to updated school years
                    angular.forEach($rootScope.schoolYears,function(item){
                      if (item.id == schoolYear.id){
                        $scope.updatedYear = item;
                      }
                    })

                    //checks if New School Year exists in dropdown
                    //SIS-1017
                    if(($scope.schoolYears.length > 0) && (_.last($scope.schoolYears).id == -1)){
                        $scope.disableAddYear = true;
                    }
                }
                

                switch(operation){
                    case "change":{
                        $scope.displayNewSchoolYear = Object.assign({},$scope.updatedYear);
                        $scope.resetSchoolYearErrorMsgs();
                        //STT-8343
                        $scope.setXschSchTerms($scope.displayNewSchoolYear.year);
                        $scope.getSchoolCalendar($scope.displayNewSchoolYear.year);
                        //STT-8346
                        $scope.displayNewSchoolSet = null;
                        console.log("change")
                    }break;
                    case "yesEdit":{
                        /*setting schoolYearForm of the new schoolYear selected by user from dropdown */
                        if($scope.displayNewSchoolYear && $scope.displayNewSchoolYear.status === 0){
                            $scope.schoolYears = angular.copy($scope.currentSchoolYears);
                            $scope.currentSchoolYearsDeleted = angular.copy($scope.currentSchoolYears);
                        }
                        $scope.displayNewSchoolYear = Object.assign({},$scope.updatedYear);
                        $scope.resetSchoolYearErrorMsgs();
                        $scope.forms.schoolYearForm.$setPristine();
                        //STT-8343
                        $scope.setXschSchTerms($scope.displayNewSchoolYear.year);
                        $scope.getSchoolCalendar($scope.displayNewSchoolYear.year);
                        //STT-8346
                        $scope.displayNewSchoolSet = null;
                        console.log("yesEdit")
                        if(_.last($scope.schoolYears).id == -1){
                            $scope.schoolYears.pop();
                            $scope.disableAddYear = false;
                        }
                    }break;
                    case "noEdit":{
                        $scope.schoolYear.selected = $scope.updatedYear;
                        console.log("noEdit", $scope.updatedYear)
                    }break;
                    case "addSchoolYear":{
                        $scope.schoolYears.push(schoolYear);
                        $scope.schoolYear.selected = schoolYear;
                        $scope.schoolYearAdded = true;
                        //STT-8346 & SIS-1017
                        if($scope.schoolYears[0].year != "New School Year"){
                            $scope.setXschSchTerms($scope.schoolYears[0].year,1);
                        }else{
                            $scope.setSchoolTerms = [];
                        }
                        $scope.setSchoolHolidays = [];
                        $scope.schoolHolidays = [];
                        $scope.displayNewSchoolYear = null;
                        //STT-8098: User deletes an existing school year (User Interactions)
                        $scope.deleteSchoolYearDisabled = false;
                    }break;
                }
                //validating deleteHyperLink should be enabled or disabled
                if(!$scope.schoolYearAdded)
                $scope.deleteSchoolYearDisabled = schoolYear.year <= $scope.editSchoolData.currentYear;
            }

            $scope.openAlertSchoolYearUnsaved = function(schoolYear){
                $scope.modalInstance8 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'addSchoolYear.html',
                    keyboard: false,
                    backdrop: 'static',
                    windowClass: 'alert-Modal',
                    scope: $scope,
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.okAddSchoolYear = function () {

                            if($scope.changeSchoolYearDirty && $scope.forms.schoolYearForm.$dirty && !$scope.schoolYearEdited){
                                console.log("ok 1 - changeSchoolYearDirty");
                                $scope.getSchoolYearDetails($scope.schoolYear.selected,"yesEdit");
                            }  

                            $uibModalInstance.close(true);
                        };  
                            
                        $scope.dialogMsg = "You have unsaved changes for the current School Year. Do you want to continue without saving the changes?";
                        
                        $scope.cancelAddSchoolYear = function () {
                            console.log("new school year set added - NO", $scope.schoolYears);

                            if($scope.schoolYearAdded){
                                console.log("schoolYearAdded - NO clicked");
                                $scope.schoolYear.selected = (_.last($scope.schoolYears));
                                // $scope.schoolYears.pop();
                            } else if($scope.changeSchoolYearDirty){
                                console.log("NO - changeSchoolYearDirty");
                                if($scope.displayNewSchoolYear && $scope.displayNewSchoolYear.status === 0){
                                    console.log($scope.schoolYear.selected);
                                    $scope.schoolYear.selected = null;
                                }
                                if($scope.displayNewSchoolYear && $scope.displayNewSchoolYear.status !== 0){
                                    $scope.getSchoolYearDetails($scope.displayNewSchoolYear,"noEdit");
                                }                                   
                                
                            }  

                            $uibModalInstance.close(false);
                        };
                    }], 
                    
                });
            }
            
            $scope.getIndexOfValueInArray = function (array, value){
                console.log(value);
                for(var i=0; i<array.length; i++){
                    console.log("position: "+i);
                    console.log(array[i]);
                    
                    if(angular.equals(array[i],value)){
                        return i;
                    }
                    
                }
                return -1;
            }
            
            
            //Get list of schoolYear sets
            $scope.changeSchoolYearSet = function(schoolYear){

                $scope.option8 = false;
                $scope.newSchoolYearSelected = false;
                $rootScope.noSchoolYearSelected = false;
                $rootScope.noSchoolDeletedYearSelected = false;
                if($scope.showSavedSchoolDataMsg){
                    $scope.showSavedSchoolDataMsg = false;
                }

                if(!$scope.option8 && $scope.forms.schoolYearForm.$dirty && schoolYear.id != -1){
                    console.log("change schoolYear - alert");
                    $scope.changeSchoolYearDirty = true;
                    $scope.openAlertSchoolYearUnsaved($scope.displayNewSchoolYear);
                    console.log("schoolYearSelected", $scope.schoolYear);
                } else{    
                    console.log("$scope.schoolYear", $scope.schoolYear);
                    if($scope.schoolYear.id != -1)
                    $scope.getSchoolYearDetails(schoolYear,"change");
                }
            }
            
            //STT-8098:STT.8026e.1 User deletes an existing school year (User Interactions)
            //STT-8099:STT.8026e.2 User deletes an existing school year (Validations & Save)
            $scope.openModalDelete = function(schoolYear) {    
                 var scopeCopy = $scope;
                $scope.modalInstance1 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'deleteYearDialog.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {                           
                            $scope.okDeleteYear = function() {                                  
                                if(schoolYear.id  === -1){
                                    scopeCopy.resetSchoolYearForm();
                                }
                                else{   
                                    scopeCopy.displayNewSchoolYear = schoolYear;
                                    var index = scopeCopy.getIndexOfValueInArray(scopeCopy.currentSchoolYearsDeleted, schoolYear);
                                    if(index !== -1){
                                        scopeCopy.currentSchoolYearsDeleted.splice(index,1);
                                    }
                                    
                                    scopeCopy.resetSchoolYearDeletedForm(); 
                  
                                    scopeCopy.displayNewSchoolYear.status = 0;
                                    scopeCopy.forms.schoolYearForm.$setDirty();                                 
                                }
                                $uibModalInstance.close(true);
                            };
                            $scope.deleteSchoolYearMsg= "You are about to delete the new, unsaved school year. Do you want to continue?";
                            
                            if(schoolYear.id  === -1)
                            {
                                $scope.deleteSchoolYearMsg= "You are about to delete the new, unsaved school year. Do you want to continue?";                                
                            }else{
                                $scope.deleteSchoolYearMsg= "You are about to delete the existing school year. Do you want to continue?";                                
                            }
                            $scope.cancelDeleteYear = function() {
                                $uibModalInstance.dismiss('cancel');
                            };
                        }
                    ],

                });
            }
            
            $scope.resetSchoolYearDeletedForm = function(){
                console.log("resetSchoolYearDeletedForm");
                $scope.resetForms();
                $scope.schoolYear.selected = null;
                $scope.schoolYearAdded = false;
                $scope.noSchoolYearSelected = true;
                $scope.noSchoolYearDeletedSelected = false;
                $scope.schoolYears = angular.copy($scope.currentSchoolYearsDeleted);
            }
            
            $scope.resetSchoolYearForm = function(){
                console.log("resetSchoolYearForm");
                $scope.resetForms();
                $scope.schoolYear.selected = null;
                $scope.displayNewSchoolYear = null;
                $scope.schoolYearAdded = false;
                $scope.noSchoolYearSelected = true;
                $scope.noSchoolYearDeletedSelected = true;
                $scope.invalidNewSchoolYearError = false;
                $scope.duplicateSchoolYearError = false;
                $scope.editYearErrorOccurred = false;
                $scope.schoolYears = angular.copy($scope.currentSchoolYears);
                $scope.currentSchoolYearsDeleted = angular.copy($scope.currentSchoolYears);
                $scope.setSchoolTerms = angular.copy($scope.mockSchoolYearTerms);
                $scope.setSchoolHolidays = angular.copy($scope.schoolHolidays);
            }
            
            $scope.option8 = false;
            $scope.addSchoolYear = function(){
                $scope.newSchoolYearSelected = true;
                $scope.option8 = false;
                if($scope.forms.schoolYearForm.$dirty){
                     $scope.forms.schoolYearForm.$setDirty();
                }

                if(!$scope.option8 && (!$scope.noSchoolYearSelected && $scope.forms.schoolYearForm.$dirty)){
                        console.log("addSchoolYearSet");
                         $scope.openAlertSchoolYearUnsaved();

                          $scope.modalInstance8.result.then(function (option) {
                            $scope.option8 = option;
                            console.log("option ",option );
                        
                            if(option){
                                $scope.displayNewSchoolSet = {
                                            'id' : -1,    
                                            'year': 'New School Year',
                                        }
                                $scope.schoolYearAdded = true;
                                $scope.getSchoolYearDetails($scope.displayNewSchoolSet,"addSchoolYear");
                            } 
                         });

                } else {
                     console.log("else here")
                         $scope.newSchoolSet = {
                                    'id' : -1,   
                                    'year': 'New School Year',
                                }
                      
                        $scope.schoolYearAdded = true;
                        $scope.noSchoolYearSelected = false;
                        $scope.displayNewSchoolSet = angular.copy($scope.newSchoolSet);
                        
                        $scope.getSchoolYearDetails($scope.displayNewSchoolSet,"addSchoolYear");
                        console.log("addschoolyear else block - simple add")
                    
                    $rootScope.noSchoolYearSelected = false;
                }

            }            
            
            //STT-8098:STT.8026e.1 User deletes an existing school year (User Interactions)
            //STT-8099:STT.8026e.2 User deletes an existing school year (Validations & Save)
            $scope.deleteSchoolYear = function(schoolYear){
                if($scope.deleteSchoolYearDisabled){
                    console.log("It is Not allowed to delete this SchoolYear");
                }else{                  
                    console.log("It is allowed to delete this SchoolYear");
                    $scope.forms.schoolYearForm.$setDirty();
                    $scope.openModalDelete($scope.schoolYear.selected);                    
                }
            }
            
            /**
             * STT-8343
             * STT.7626a.1 User views existing terms for an existing school year and makes term edits
             * Developer Comment: this method will add new schoolTerm row to the School Terms grid. */
            $scope.addSchoolTerm = function(){
                console.log("add existing school terms row");
                $scope.forms.schoolYearForm.$setDirty();
                $scope.schoolTerm.selected[$scope.schoolTerm.selected.length]="";
                schoolDataEditSvc.getSchoolTerms(authentication.getCurrentUser().keycode)
                .then(function(data){
                    console.log("School Terms were fetched successfully");
                    if(data){
                        //this variable will be used JUST to render schoolTerms list within dropdown from column "name" in grid.
                        $scope.schoolTerms = data.schoolTermList;
                    }
                }, function(error){
                    console.info('Error when retrieving school Terms...'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })['finally'](function () {
                    $scope.isSearchBusy=false;
                });
                $scope.setSchoolTerms.push({
                    schoolTermId: 1,
                    schoolId: $scope.editSchoolData.schoolId,
                    finalId: 0,
                    status: 1,
                    createdBy: "",
                    createDate: "",
                    modifiedBy: "",
                    modifyDate: "",
                    id: -1,
                    year: $scope.displayNewSchoolYear != null ? $scope.displayNewSchoolYear.year : -1,
                    name: "",
                    parentId: 0,
                    startDate: "",
                    endDate: "",
                    edited: true
                });
                // $scope.selectedSetDetails =angular.copy($scope.allGradeDetails.gradeMarksList);  
            }
            
            /**
             * STT-8343
             * STT.7626a.1 User views existing terms for an existing school year and makes term edits
             * Developer Comment: this method was defined to perform differents actions based on changes made
             * to a "new school term" row. */
            $scope.schoolTermChanged = function (schoolTermRow,index,field){
                switch(field){
                    case "name":{
                        if($scope.schoolTerm.selected[index] != null && $scope.schoolTerm.selected[index] != ""){
                            schoolTermRow.name = $scope.schoolTerm.selected[index].name;
                            schoolTermRow.schoolTermId = $scope.schoolTerm.selected[index].schoolTermId;
                        }
                    }break;
                    case "startDate":{
                        schoolTermRow.startDate = $filter('date')(schoolTermRow.startDate, 'MM/dd/yyyy');
                    }break;
                    case "endDate":{
                        schoolTermRow.endDate = $filter('date')(schoolTermRow.endDate, 'MM/dd/yyyy');
                    }
                }
                //SIS-1019
                schoolTermRow.edited = true;
                // console.log($scope.setSchoolTerms);
            }

            /**
             * STT-8343
             * STT.7626a.1 User views existing terms for an existing school year and makes term edits */
            $scope.openAlertDeleteSchoolTermRow = function(index, record){
                $scope.modalInstance1 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'deleteGrademark.html',
                    keyboard: false,
                    backdrop: 'static',
                    windowClass: 'alert-Modal',
                    scope: $scope,
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.okDelete = function () {
                            //Existing school Term
                            if(record.id && record.id != -1){
                                record.status=0;
                                record.finalId=0;
                                record.edited = true;
                                //SIS-1030: Term name is reset to "Select" after remove another term
                                $scope.schoolTerm.selected.splice(index,1);
                                console.log(record, $scope.setSchoolTerms)
                            }else{
                                $scope.schoolTerm.selected.splice(index,1);
                                $scope.setSchoolTerms.splice($scope.setSchoolTerms.indexOf(record),1);
                            }
                            $scope.forms.schoolYearForm.$setDirty();
                            $uibModalInstance.close(true);
                        };  
                            $scope.dialogMsg = "You are about to delete term " + record.name  + " from the selected school year. Do you want to continue?";
                        $scope.cancelDelete = function () {
                            $uibModalInstance.close(false);
                        };
                    }], 
                });
            }

            /**
             * STT-8343
             * STT.7626a.1 User views existing terms for an existing school year and makes term edits */
            $scope.deleteSchoolTermRow = function(index, record){
                console.log("delete School Term row", index, record);
                $scope.openAlertDeleteSchoolTermRow(index, record);
            }

            //Holidays Functionality

            $scope.noSchoolHolidaysMessage = schoolwork12.app.manageSchoolData.errorMessages.noSchoolHolidays;
            $scope.holidayStartDateRequired = schoolwork12.app.manageSchoolData.errorMessages.holidayStartDateRequired;
            $scope.holidayStartDateInvalid = schoolwork12.app.manageSchoolData.errorMessages.holidayStartDateInvalid;
            $scope.holidayStartDateDuplicated = schoolwork12.app.manageSchoolData.errorMessages.holidayStartDateDuplicated;
            $scope.holidayEndDateInvalid = schoolwork12.app.manageSchoolData.errorMessages.holidayEndDateInvalid;
            $scope.holidayEndDatePrior = schoolwork12.app.manageSchoolData.errorMessages.holidayEndDatePrior;

            $scope.schoolHolidayChanged = function (schoolHoliday,attribute){
                if(attribute == 'startDate'){
                    schoolHoliday.calendarDay = $filter('date')(schoolHoliday.calendarDay, 'MM/dd/yyyy');
                }
                schoolHoliday.edited = true;
            }

            $scope.getSchoolCalendar = function (schoolYear) {
                $scope.setSchoolHolidays = [];
                $scope.schoolHolidays = [];
                schoolDataEditSvc.getSchoolCalendar(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId,schoolYear)
                    .then(function(data){
                        console.log("School Calendar was fetched successfully");
                        if(data){
                            $scope.schoolHolidays = data;
                            $scope.setSchoolHolidays = angular.copy($scope.schoolHolidays);
                        }
                    }, function(error){
                        console.info('Error when retrieving School Calendar...'.concat(angular.toJson(error)));
                        $scope.editErrorOccurred = true;
                        $scope.editErrorMsgOccurred = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })['finally'](function () {
                        $scope.isSearchBusy=false;
                    });
            }

            $scope.deleteSchoolHoliday = function(index,holiday){
                if(holiday.calendarId == -1){
                    $scope.setSchoolHolidays.splice(index,1)
                }else{
                    holiday.status = 0;
                    holiday.edited = true;
                }            
                $scope.forms.schoolYearForm.$setDirty();
            }

            var checkDuplicateHoliday = function(calendarDay,holidaysList){
                var tempHoliday = null;
                tempHoliday = _.find(holidaysList,function name(listItem) {
                   return(listItem.status == 1 && moment(listItem.calendarDay).isSame(calendarDay))
                });

                return tempHoliday != null ? true : false;
            }

            var getDatesIntervalByRange = function (startDate, endDate, datesInterval) {
                if(startDate.isAfter(endDate)){
                    return datesInterval;
                }else{
                    datesInterval.push(startDate);
                    return getDatesIntervalByRange(moment(startDate).add(1,'d'),endDate, datesInterval);
                }
            }

            //STT-9162: STT.8075c User saves holidays for a school year in TV Action
            var resetHolidayTableErrors = function () {
                let activeHolidays = $scope.setSchoolHolidays.filter(function (item) {
                    return item.status === 1;
                });
                activeHolidays.forEach(function (holiday,index) {
                    $scope.forms.schoolYearForm['schoolYearHolidayForm_' + index].holidayDate.$setValidity('calendarDayValid',true);
                    $scope.forms.schoolYearForm['schoolYearHolidayForm_' + index].holidayDate.$setValidity('calendarDayDuplicate',true);
                    $scope.forms.schoolYearForm['schoolYearHolidayForm_' + index].holidayDate.$setValidity('calendarDayRequired',true);
                })
            }
            
            var isHolidaysValidCheck = function () {
                resetHolidayTableErrors();
                let result = true;
                let interatedHolidays = [];
                let activeHolidays = $scope.setSchoolHolidays.filter(function (item) {
                    return item.status === 1;
                });
                activeHolidays.forEach(function (holiday,index) {
                    if(!validateHolidayDate(holiday,index,interatedHolidays)){
                        result = false;
                    }
                    interatedHolidays.push(holiday);
                });
                return result;
            }

            var validateHolidayDate = function (holiday, index, interatedHolidays) {
                let result = true;
                if(typeof (holiday.calendarDay) === 'undefined' && !dateRegex.test(holiday.calendarDay)){
                    $scope.forms.schoolYearForm['schoolYearHolidayForm_' + index].holidayDate.$setValidity('calendarDayValid',false);
                    result = false;
                }else if(checkDuplicateHoliday(holiday.calendarDay, interatedHolidays)){
                    $scope.forms.schoolYearForm['schoolYearHolidayForm_' + index].holidayDate.$setValidity('calendarDayDuplicate',false);
                    result = false;
                }else if (holiday.calendarDay == null){
                    $scope.forms.schoolYearForm['schoolYearHolidayForm_' + index].holidayDate.$setValidity('calendarDayRequired',false);
                    result = false;
                }
                return result;
            }

            // STT-9166: STT.8075b.1 User adds holidays for a school year in TV Action (Display Modal, Cancel) 
            $scope.holidayModal = function (){
                var schoolYearSelected = $scope.displayNewSchoolYear != null ? $scope.displayNewSchoolYear.year : parseInt($scope.displayNewSchoolSet.yearVal);
                var currentSchoolId = $scope.editSchoolData.schoolId;
                var startDateRequiredMessage = $scope.holidayStartDateRequired;
                var startDateInvalidMessage = $scope.holidayStartDateInvalid;
                var endDateInvalidMessage = $scope.holidayEndDateInvalid;
                var endDatePriorMessage = $scope.holidayEndDatePrior;
                var holidayModalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'holidayModal.html',
                    size: 'lg',
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $scope.schoolYearSelected = isNaN(schoolYearSelected) ? '' : ('to: ' + schoolYearSelected + '-' + (schoolYearSelected + 1) + ' School Year');
                            $scope.newHoliday = {
                                isHoliday: 1,
                                startDate: null,
                                endDate: null,
                                status: 1,
                                calendarId: -1,
                                edited: true,
                                schoolId: currentSchoolId
                            };
                            $scope.newHolidayDates = {
                                startDate: false,
                                endDate: false
                            }
                            $scope.holidayStartDateRequired = startDateRequiredMessage;
                            $scope.holidayStartDateInvalid = startDateInvalidMessage;
                            $scope.holidayEndDateInvalid = endDateInvalidMessage;
                            $scope.holidayEndDatePrior = endDatePriorMessage;
                            $scope.resetErrors = function(){
                                $scope.forms.newHolidayForm['newHolidayStartDate'].$setValidity('startDateValid',true);
                                $scope.forms.newHolidayForm['newHolidayStartDate'].$setValidity('startDateRequired',true);
                                $scope.forms.newHolidayForm['newHolidayEndDate'].$setValidity('endDateValid',true);
                                $scope.forms.newHolidayForm['newHolidayEndDate'].$setValidity('endDatePrior',true); 
                            };

                            var unSavedHolidayModalAlert = function(size) {
                                var rootHolidayModalInstance = $uibModalInstance;
                                $scope.modalInstance = $uibModal.open({
                                    animation: $scope.animationsEnabled,
                                    templateUrl: 'holidayOkCancelModal.html',
                                    size: size,
                                    keyboard: false,
                                    backdrop: 'static',
                                    controller: ['$scope', '$uibModalInstance',
                                    function ($scope, $uibModalInstance) {
                                        $scope.discardHoliday = function () {
                                            $uibModalInstance.close(true);
                                            rootHolidayModalInstance.close(true);
                                        };
                
                                        $scope.holidayOkCancelDialogMsg = "You have begun entering a new holiday. Do you want to cancel without accepting your changes?";
                                        $scope.remainHoliday = function () {
                                            $uibModalInstance.close(false);
                                        };
                                    }], 
                                    
                                });
                            }

                            $scope.openDatePickerHolydayByName = function(attributeName){
                                $scope.newHolidayDates[attributeName] = true;
                            }
                            
                            $scope.holidayModalCancel = function() {
                                if ($scope.forms.newHolidayForm.$dirty){
                                    unSavedHolidayModalAlert();
                                }else{
                                    $uibModalInstance.dismiss('cancel');
                                }
                            };

                            var validate = function(){
                                $scope.resetErrors();
                                var result = true;
                                //startDate validation
                                if(typeof ($scope.newHoliday.startDate) === 'undefined' && !dateRegex.test($scope.newHoliday.startDate)){
                                    $scope.forms.newHolidayForm['newHolidayStartDate'].$setValidity('startDateValid',false);
                                    result = false;
                                }else if ($scope.newHoliday.startDate == null){
                                    $scope.forms.newHolidayForm['newHolidayStartDate'].$setValidity('startDateRequired',false);
                                    result = false;
                                }

                                //endDate validation                             
                                if($scope.newHoliday.startDate != null){
                                    if(typeof ($scope.newHoliday.endDate) === 'undefined' && !dateRegex.test($scope.newHoliday.endDate)){
                                        $scope.forms.newHolidayForm['newHolidayEndDate'].$setValidity('endDateValid',false);
                                        result = false;
                                    }else if($scope.newHoliday.endDate != null && moment($scope.newHoliday.endDate).isBefore($scope.newHoliday.startDate)){
                                        $scope.forms.newHolidayForm['newHolidayEndDate'].$setValidity('endDatePrior',false); 
                                        result = false;  
                                    }
                                } 
                                
                                return result;
                            }

                            $scope.addHoliday = function(){
                                if(validate()){
                                    $uibModalInstance.close($scope.newHoliday);
                                }
                            }
                        }
                    ],
                });
             
                //STT-9184:  STT.8075b.2 User adds holidays for a school year in TV Action (Validate, Add)
                holidayModalInstance.result.then(function(holiday){
                    if(holiday){
                        if(holiday.endDate == null || moment(holiday.endDate).isSame(holiday.startDate)){
                            if(!checkDuplicateHoliday(holiday.startDate,$scope.setSchoolHolidays)){
                                holiday.calendarDay = $filter('date')(holiday.startDate, 'MM/dd/yyyy');
                                $scope.setSchoolHolidays.push(holiday);
                                $scope.forms.schoolYearForm.$setDirty();
                            }
                        }else{
                            var insertions = 0;
                            var intervalDates = getDatesIntervalByRange(moment(holiday.startDate),moment(holiday.endDate), []);
                            intervalDates.forEach(function (date) {
                                if(!checkDuplicateHoliday(date,$scope.setSchoolHolidays)){
                                    var tempObject =  {...holiday}
                                    tempObject.startDate = date.toDate();
                                    tempObject.calendarDay = $filter('date')(tempObject.startDate, 'MM/dd/yyyy');
                                    $scope.setSchoolHolidays.push(tempObject);
                                    insertions++;
                                }
                            });
                            if(insertions > 0)
                                $scope.forms.schoolYearForm.$setDirty();
                        }
                    }
                });
         
            } /* END OF STT-9166 */

            /***********************************************/
            /********* MANAGE COURSE CATALOGS ************ */
            /***********************************************/
           
            //initialise courseGridOptions
            $scope.courseGridOptions = {
                enableFiltering: true,
                enableRowSelection: false,
                enableGridMenu: false,
                exporterMenuPdf: false,
                enableRowHeaderSelection: false,
                showGridFooter: true,
                enableCellEditOnFocus: false,
                rowHeight: 50,
                paginationPageSizes: [25, 50, 75],
                paginationPageSize: 25,
            };

            $scope.setXschSchYears = function(year, event){
                $scope.setSchoolYearTerms = [];
            
                if($scope.forms.CatalogsForm.$dirty){
                    console.log("CatalogsForm dirty - years accordion clicked");
                    event.preventDefault();
                    event.stopPropagation();
                    $scope.openAlertUnsavedCourses();

                    $scope.modalInstanceCourse.result.then(function(option){
                        if (option) {
                            console.log("yes clicked")
                            $scope.forms.CatalogsForm.$setPristine();
                            $scope.resetCatalogsFormPanel();
                        }
                    });

                } else {
                    $scope.catalogSchoolYearSelected = `${year} - ${year+1}`;

                    $scope.catalogStatus.isTermOpen = [];
                    $scope.xschSchYearTerms = [];
                    $scope.courseGridOptions.data = [];
                    $scope.courseGridOptions.xschSchTermIdOrigin = null;
                    schoolDataEditSvc.getXschSchTerms(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId,year)
                        .then(function(data){
                            console.log("XschSchYearTerms were fetched successfully");
                            if(data){
                                $scope.xschSchYearTerms = data;
                                $scope.setSchoolYearTerms = angular.copy($scope.xschSchYearTerms);
                                // console.log($scope.setSchoolYearTerms);
                            }
                        });
                    }
                
                }

            //fetch and set school courses for specified year and term
            $scope.setXschSchCourses = function(year, term, index, event){
                if($scope.forms.CatalogsForm.$dirty){
                    console.log("CatalogsForm dirty - course accordion clicked");
                    event.preventDefault();
                    event.stopPropagation();
                    $scope.openAlertUnsavedCourses();

                    $scope.modalInstanceCourse.result.then(function(option){
                        if (option) {
                            console.log("yes clicked")
                            $scope.forms.CatalogsForm.$setPristine();
                            $scope.resetCatalogsFormPanel();
                        }
                    });

                } else {
                    $scope.catalogSchoolTermSelected = $scope.xschSchYearTerms.find(xsch => xsch.id == term);

                    $scope.courseGridOptions.data = [];
                    $scope.courseGridOptions.xschSchTermIdOrigin = null;
                    $scope.isCatalogCoursesBusy = true;

                    $timeout(function () {
                        if($scope.catalogStatus.isTermOpen){
                            var a = $scope.catalogStatus.isTermOpen;
                            $scope.selCatalogTermIndex = a.indexOf(true);
                        }
                        
                        if($scope.selCatalogTermIndex == index){
                            //invoke svc to fetch school courses
                             schoolDataEditSvc.getXschSchCourses(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, year, term)
                            .then(function(data){
                                console.log("XschSchCourses were fetched successfully");
                                if(data){
                                    // this variable will contain original xschSchCourses list retrieved by service
                                    $scope.xschSchCourses = data;
                                    $scope.courseGridOptions.data = data.schoolCatalogCourses;

                                    $scope.origCourseData = angular.copy(data.schoolCatalogCourses);
                                    $scope.catalogSchoolTermSelected.numberOfCatalogCourses = data.schoolCatalogCourses.length;
                                    $scope.isCatalogCoursesBusy = false;
                                    $scope.isSearchBusy = false; 
                                }
                                })['finally'](function () {
                                    $scope.isSearchBusy = false;
                                    $scope.isCatalogCoursesBusy = false;
                                    if($scope.courseGridOptions.data.length == 0)
                                        $scope.catalogSchoolTermSelected.numberOfCatalogCourses = 0;
                                });
                            }

                        }, 500)
            
                }

            }

            //build column definitions
            $scope.courseGridOptions.columnDefs = [
                { field: 'courseCode', displayName: 'Course Code', maxWidth: 200 },
                { field: 'courseName', displayName: 'Course Name', maxWidth: 500 },
                { field: 'name', displayName: 'Grademark Set', width: '*',
                cellTemplate: 
                '<div style="border-bottom: solid 1px #ddd;" ng-if="grid.appScope.xschSchYearTerm.year >= grid.appScope.editSchoolData.currentYear">' +
                '<label class="selectLabel" style="margin: 5px 10px;">' + 
                  '<select class="customSelect form-control" style="height: 39px; width: 250px;" ng-model="row.entity.name" ng-change="grid.appScope.changeCourseGrademark(row.entity)">' +
                      '<option value="" ng-disabled="true">--SELECT--</option>' +
                      ' <option ng-repeat="grade in grid.appScope.allGradeSets track by grade.gradeMarkSetId">{{grade.name}}</option>' +
                  '</select>' +
                '</label>' +
                '</div>' +
                '<div class="ui-grid-cell-contents" ng-if="grid.appScope.xschSchYearTerm.year < grid.appScope.editSchoolData.currentYear">' +
                '<span>' + 
                '{{row.entity.name}}' +
                '</span>' +
                '</div>'
                },
                { field: 'credits', displayName: 'Credits', maxWidth: 100, enableFiltering: false, enableColumnMenu: false },
                { field: 'action', displayName: 'Action', maxWidth: 100, enableFiltering: false, enableColumnMenu: false ,
                cellTemplate: 
                '<div class="ui-grid-cell-contents actionIcons" ng-if="grid.appScope.xschSchYearTerm.year >= grid.appScope.editSchoolData.currentYear">' +  
                '<a target="_self" ng-click="grid.appScope.deleteCourseRow(row)" class="errorLogs" style="right: 3em;" title="Delete Course Row">' + 
                '<span class="glyphicon glyphicon glyphicon-trash"></span></a>' + 
                '</div>' +
                '<div style="border-bottom: solid 1px #ddd;" ng-if="grid.appScope.xschSchYearTerm.year < grid.appScope.editSchoolData.currentYear">' +
                '<span>' + '</span>' +
                '</div>'
            }
            ];


            $scope.deleteCourseRow = function(row){
                console.log("course deleted", row);
                $scope.forms.CatalogsForm.$setDirty();
                //if it is an existing course just set status to 0
                if(typeof (row.entity.id) !== 'undefined'){
                    row.entity.status = 0;
                    //SIS-1045
                    row.entity.edited = true;
                    row.setThisRowInvisible();
                }else{ // new course had been added but not saved to DB yet.
                    var index = $scope.courseGridOptions.data.indexOf(row.entity);
                    $scope.courseGridOptions.data.splice(index, 1);
                }
                $scope.catalogSchoolTermSelected.edited = true;
            }

            $scope.changeCourseGrademark = function(row) {
                console.log("before", row);
                var tempGmSet = _.find($scope.allGradeSets,function(gmSet){return gmSet.name == row.name});
                row.gradeMarkSetId = typeof (tempGmSet) !== 'undefined' ? tempGmSet.gradeMarkSetId : row.gradeMarkSetId;
                //SIS-1045
                row.edited = true;
                console.log("after", row);
                console.log("gmSetId changed", row.name)
            }

            $scope.resetCatalogsFormPanel = function () {
                $scope.resetForms();
                $scope.catalogSchoolTermSelected.edited = false;
                $scope.courseGridOptions.data = angular.copy($scope.origCourseData);
                $scope.catalogStatus.isTermOpen = [];
                console.log("resetCatalogsFormPanel");
            }

            $scope.openAlertUnsavedCourses = function () {
                $scope.modalInstanceCourse = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'editCourseCatalog.html',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.okEdit = function () {
                            console.log("yes: discard edits")
                            $uibModalInstance.close(true);
                        };

                        $scope.dialogMsg = 'You have unsaved changes for the current course catalog. Do you want to continue without saving the changes?';
                        $scope.cancelEdit = function () {
                            console.log("no:  keep edits")
                            $uibModalInstance.close(false);
                        };
                    }], 
                    
                });
             };
            //----End of STT-8377----//

             /**
             * STT-8378
             * STT.7803f.2 Modal is displayed so that the user can select additional courses 
             *  from the K12 catalog
             */

            $scope.k12CoursesModal = function (){
                var tempCatalogSchoolYearSelected = $scope.catalogSchoolYearSelected;
                var tempCatalogSchoolTermSelected = $scope.catalogSchoolTermSelected.name;
                var schoolId = $scope.editSchoolData.schoolId;
                var k12CoursesModalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'k12CoursesModal.html',
                    size: 'lg',
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            console.log("Viewing available K12 Courses");
                            $scope.catalogSchoolYearSelected = tempCatalogSchoolYearSelected;
                            $scope.catalogSchoolTermSelected = tempCatalogSchoolTermSelected;
                            $scope.courseGridModalOptions = {
                                enableFiltering: true,
                                enableRowSelection: true,
                                enableGridMenu: true,
                                exporterMenuPdf: false,
                                enableRowHeaderSelection: true,
                                showGridFooter: true,
                                enableCellEditOnFocus: true,
                                rowHeight: 50,
                                paginationPageSizes: [25, 50, 75],
                                paginationPageSize: 25,
                            };

                            //build K12 Courses Table column definitions
                            $scope.courseGridModalOptions.columnDefs = [
                                { field: 'courseCode', displayName: 'Course Code', minWidth: 130, cellClass: 'text-k12Grid-column'},
                                { field: 'courseName', displayName: 'Course Name', minWidth: 350 },
                                { field: 'subjectName', displayName: 'Subject', minWidth: 220, cellClass: 'text-k12Grid-column' },
                                { field: 'credits', displayName: 'Credits', minWidth: 10, enableFiltering: false, cellClass: 'text-k12Grid-column', enableSorting: false,  enableColumnMenu: false,},
                            ];

                            //  get Courses info service
                            $http({
                                url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + 'courses/' + schoolId,
                                method: "GET",
                                headers: {
                                    'X-API-TOKEN': authentication.getCurrentUser().keycode,
                                },
                            }).then(function(response) {
                                 if (typeof (response.data.courses) != 'undefined' && response.data.courses.length > 0) {
                                    $scope.displayK12CoursesGrid = true;
                                    $scope.courseGridModalOptions.data = response.data.courses;
                                } else {
                                    $scope.k12CoursesModalErrorOccurred = true;
                                    $scope.k12CoursesModalErrorMessage = schoolwork12.app.errorMessages.noResultsFound;
                                }
                            }, function(error) {
                                console.info('Error in viewing student audit trail....'.concat(angular.toJson(error)));
                                $scope.k12CoursesModalErrorOccurred = true;
                                $scope.k12CoursesModalErrorMessage = "";
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.k12CoursesModalErrorMessage = $scope.k12CoursesModalErrorMessage + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.k12CoursesModalErrorMessage = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.k12CoursesModalErrorMessage = schoolwork12.app.errorMessages.internalError;
                                }
                            });

                            var unSavedModalAlert = function(size) {
                                var k12CourseModalInstance = $uibModalInstance;
                                $scope.modalInstance = $uibModal.open({
                                    animation: $scope.animationsEnabled,
                                    templateUrl: 'commonDialog.html',
                                    size: size,
                                    keyboard: false,
                                    backdrop: 'static',
                                    controller: ['$scope', '$uibModalInstance',
                                    function ($scope, $uibModalInstance) {
                                        $scope.ok = function () {
                                            $uibModalInstance.close(true);
                                            k12CourseModalInstance.close(true);
                                        };
                
                                        $scope.dialogMsg = 'You have selected courses to be added to your course catalog. Do you want to continue without accepting the changes?';
                                        $scope.cancel = function () {
                                            $uibModalInstance.close(false);
                                        };
                                    }], 
                                    
                                });
                            }
                            
                            $scope.k12CoursesModalCancel = function() {
                                if ($scope.gridApi.selection.getSelectedRows().length > 0){
                                    unSavedModalAlert();
                                }else{
                                    $uibModalInstance.dismiss('cancel');
                                }
                            };

                            $scope.closeNotification = function() {
                                $scope.closeK12CoursesModal = true;
                            }

                            $scope.addk12Courses = function(){
                                $uibModalInstance.close($scope.gridApi.selection.getSelectedRows());
                            }

                            $scope.courseGridModalOptions.onRegisterApi = function(gridApi){
                                //set gridApi on scope and make it available on HTML
                                $scope.gridApi = gridApi;
                            };

                        }
                    ],
                });

                k12CoursesModalInstance.result.then(function (selectedK12Courses){
                    if(typeof (selectedK12Courses) != 'undefined' && selectedK12Courses.length > 0){
                        selectedK12Courses.forEach(function(item,index){
                            if(!_.find($scope.courseGridOptions.data, function (courseGridObject)
                                { return courseGridObject.courseCode == item.courseCode; })
                            ){
                                var temp = _.find($scope.allGradeSets, function(item2){return item2.gradeMarkSetId == item.gradeMarkSetId})
                                item.name = typeof (temp) !== 'undefined' ? temp.name : "";
                                //SIS-1045
                                item.edited = true;
                                $scope.courseGridOptions.data.push(item);
                                $scope.forms.CatalogsForm.$setDirty();
                                $scope.catalogSchoolTermSelected.edited = true;
                            }
                        });
                    }
                });
            }

            /**
             * STT-8373
             * STT.7803e.1 Modal is displayed so that the user can select the term they want to duplicate from
             */

            $scope.duplicateCatalogModal = function(){
                var tempCatalogSchoolYearSelected = $scope.catalogSchoolYearSelected;
                var tempCatalogSchoolTermSelected = $scope.catalogSchoolTermSelected.name;
                var appScopeCurrentSchool = angular.copy($scope.editSchoolData);
                var schoolDataEditSvcTmp = schoolDataEditSvc;
                var allGradeSets = $scope.allGradeSets
                var duplicateCatalogModalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'duplicateCatalogModal.html',
                    size: 'lg',
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            console.log("Viewing Duplication Modal");
                            $scope.loadingSchoolSpinner = true;
                            $scope.loadingXschSchTermSpinner = false;
                            $scope.catalogSchoolYearSelected = tempCatalogSchoolYearSelected;
                            $scope.catalogSchoolTermSelected = tempCatalogSchoolTermSelected;
                            $scope.schools = [];
                            $scope.currentSchool = appScopeCurrentSchool;
                            $scope.isDuplicationBusy = false;
                            $scope.allGradeSets = allGradeSets;
                            //  get Courses info service
                            schoolDataEditSvcTmp.getSchoolsByActivatedCourseCatalogs(authentication.getCurrentUser().keycode)
                            .then(function(response) {
                                 if (typeof (response) != 'undefined' && response.length > 0) {
                                    $scope.loadingSchoolSpinner = false;
                                    $scope.schools = response;
                                } else {
                                    $scope.duplicateCatModalErrorOccurred = true;
                                    $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.noResultsFound;
                                }
                            }, function(error) {
                                console.info('Error in showing schools by activated course catalog....'.concat(angular.toJson(error)));
                                $scope.duplicateCatModalErrorOccurred = true;
                                $scope.duplicateCatModalErrorMessage = "";
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.duplicateCatModalErrorMessage = $scope.duplicateCatModalErrorMessage + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.internalError;
                                }
                            });

                            var unSavedDupCatModalAlert = function(size) {
                                var dupCatalogModalInstance = $uibModalInstance;
                                $scope.modalInstance = $uibModal.open({
                                    animation: $scope.animationsEnabled,
                                    templateUrl: 'dupCatalogOkCancelModal.html',
                                    size: size,
                                    keyboard: false,
                                    backdrop: 'static',
                                    controller: ['$scope', '$uibModalInstance',
                                    function ($scope, $uibModalInstance) {
                                        $scope.okDupCatalog = function () {
                                            $uibModalInstance.close(true);
                                            dupCatalogModalInstance.close(true);
                                        };
                
                                        $scope.dialogMsg = 'You have selected a catalog to be duplicated. Do you want to continue without duplicating the catalog?';
                                        $scope.cancelDupCatalog = function () {
                                            $uibModalInstance.close(false);
                                        };
                                    }], 
                                    
                                });
                            }
                            
                            $scope.hasCourses= function(){
                                return function(item){
                                    return item.numberOfCatalogCourses > 0;
                                }
                            }

                            $scope.getSelectedTermCourses = function(selTermCourse, schoolId, year, term, event){
                                selTermCourse.displayCourses = false;
                                //invoke svc to fetch school courses
                                 schoolDataEditSvcTmp.getXschSchCourses(authentication.getCurrentUser().keycode, schoolId, year, term)
                                .then(function(data){
                                    if(data){
                                        selTermCourse.displayCourses = true;
                                        $scope.courseDuplicateOptions.data = data.schoolCatalogCourses;
                                        console.log("XschSchCourses were fetched successfully");
                                        // console.log("$scope.courseDuplicateOptions", $scope.courseDuplicateOptions)
                                    }
                                })

                                //initialize courseDuplicateOptions
                                $scope.courseDuplicateOptions = {
                                    enableFiltering: true,
                                    enableRowSelection: false,
                                    enableGridMenu: false,
                                    exporterMenuPdf: false,
                                    enableRowHeaderSelection: false,
                                    showGridFooter: true,
                                    enableCellEditOnFocus: false,
                                    rowHeight: 50,
                                    paginationPageSizes: [25, 50, 75],
                                    paginationPageSize: 25,
                                };

                                //build column definitions
                                $scope.courseDuplicateOptions.columnDefs = [
                                    { field: 'courseCode', displayName: 'Course Code', maxWidth: 200 },
                                    { field: 'courseName', displayName: 'Course Name', maxWidth: 500 },
                                    { field: 'subjectName', displayName: 'Subject', maxWidth: 200 },
                                    { field: 'credits', displayName: 'Credits', maxWidth: 100, enableFiltering: false, enableColumnMenu: false },
                                ];
                            }

                            $scope.schoolChanged = function(){
                                $scope.xschSchTermCatalogSelected = {row: null, checked: false, prevChecked: null};
                                if(typeof ($scope.currentSchool.schoolId) !== 'undefined'){
                                    $scope.loadingXschSchTermSpinner = true;
                                    schoolDataEditSvcTmp.getXschSchTermsBySchool(authentication.getCurrentUser().keycode,$scope.currentSchool.schoolId)
                                    .then(function(response) {
                                        if (typeof (response) != 'undefined' && response.length > 0) {
                                        $scope.loadingXschSchTermSpinner = false;
                                        $scope.xschSchTermCatalogs = response;
                                    } else {
                                        $scope.duplicateCatModalErrorOccurred = true;
                                        $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.noResultsFound;
                                    }
                                    }, function(error) {
                                        console.info('Error in showing xschSchTerms catalogs....'.concat(angular.toJson(error)));
                                        $scope.duplicateCatModalErrorOccurred = true;
                                        $scope.duplicateCatModalErrorMessage = "";
                                        if (error.status == 400) {
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.duplicateCatModalErrorMessage = $scope.duplicateCatModalErrorMessage + error.data._errors[j] + "\n";
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.internalError;
                                        }
                                    });
                                }  
                            }

                            $scope.selectXschSchTermCatalog = function(row,event){
                                if($scope.xschSchTermCatalogSelected.prevChecked == event.target.value){
                                    $scope.xschSchTermCatalogSelected.checked = false;
                                    $scope.xschSchTermCatalogSelected.row = null;
                                 }else{
                                    $scope.xschSchTermCatalogSelected.row = row;
                                }
                                $scope.xschSchTermCatalogSelected.prevChecked = $scope.xschSchTermCatalogSelected.checked;
                            }

                            $scope.duplicateCatalogModalCancel = function() {
                                if($scope.xschSchTermCatalogSelected.row != null 
                                    && $scope.xschSchTermCatalogSelected.checked != false){
                                    unSavedDupCatModalAlert();
                                }else{
                                    $uibModalInstance.dismiss('cancel');
                                }
                            };

                            $scope.closeNotification = function() {
                                $scope.closeDuplicateCatModal = true;
                            }

                            $scope.duplicateCatalog = function(){
                                $scope.isDuplicationBusy = true;
                                schoolDataEditSvcTmp.getXschSchCourses(
                                    authentication.getCurrentUser().keycode,
                                    $scope.currentSchool.schoolId,
                                    $scope.xschSchTermCatalogSelected.row.year,
                                    $scope.xschSchTermCatalogSelected.row.id,
                                    appScopeCurrentSchool.schoolId
                                ).then(function(data){
                                    if(data && data.schoolCatalogCourses.length > 0){
                                        data.schoolCatalogCourses.forEach(function(item,index){
                                            var temp = _.find($scope.allGradeSets, function(item2){return item2.gradeMarkSetId == item.gradeMarkSetId})
                                            item.name = typeof (temp) !== 'undefined' ? temp.name : "";
                                        },data.schoolCatalogCourses);
                                        $scope.isDuplicationBusy=false;
                                        //SIS-1070: 'xschSchTermIdOrigin' attribute was add to let the service duplicate default courses from the origin duplicated XschSchterm
                                        var tempObject = {
                                            xschSchTermIdOrigin: $scope.xschSchTermCatalogSelected.row.id,
                                            schoolCatalogCourses: data.schoolCatalogCourses
                                        }
                                        $uibModalInstance.close(tempObject);
                                    }
                                }, function(error) {
                                    console.info('Error in showing xschSchTerms catalogs....'.concat(angular.toJson(error)));
                                    $scope.duplicateCatModalErrorOccurred = true;
                                    $scope.duplicateCatModalErrorMessage = "";
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.duplicateCatModalErrorMessage = $scope.duplicateCatModalErrorMessage + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.duplicateCatModalErrorMessage = schoolwork12.app.errorMessages.internalError;
                                    }
                                    $scope.isDuplicationBusy=false;
                                });
                            }
                        }
                    ],
                });
                /**STT-8374: STT.7803e.2 Courses are pulled into the term's catalog from the catalog being duplicated */
                duplicateCatalogModalInstance.result.then(function (duplicatedCatalogObject){
                    if(duplicatedCatalogObject.schoolCatalogCourses.length > 0){
                        $scope.courseGridOptions.data = duplicatedCatalogObject.schoolCatalogCourses;
                        //SIS-1070: 'xschSchTermIdOrigin' attribute was add to let the service duplicate default courses from the origin duplicated XschSchterm
                        $scope.courseGridOptions.xschSchTermIdOrigin = duplicatedCatalogObject.xschSchTermIdOrigin;
                        $scope.catalogSchoolTermSelected.edited = true;
                        $scope.forms.CatalogsForm.$setDirty();
                    }
                });
            } /** END OF STT-8373 */

            /**STT-8382: STT.7803g.1 When saving the new catalog, user specifies whether or not to copy to future terms */
                $scope.replicateCatalogChanges = function(schoolyear, xschSchTermIdFrom, listXschSchTermIdsTo, courseCatalogChanges, isNewCatalog){
                    var appScopeCurrentSchool = $scope.editSchoolData;
                    var schoolDataEditSvcTmp = schoolDataEditSvc;
                    var replicateCatalogModalInstance = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'replicateCatalogChanges.html',
                        size: 'lg',
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function($scope, $uibModalInstance) {
                                console.log("Viewing Replication Modal");
                                $scope.xschSchTermsToBeApplied = [];
                                $scope.isReplicationBusy = false;
                                $scope.currentSchool = appScopeCurrentSchool;
                                $scope.xschSchTermsResponse =  listXschSchTermIdsTo;
                                $scope.xschSchTermsToBeApplied = [];
                                $scope.replicateCatModalErrorOccurred = false;
                                $scope.closeReplicateCatModal = false;
                                //SIS-1052
                                $scope.xschTermsToCopySelectStatus = true;
                                /* STT-8384: STT.7803h.1 When saving modifications for an existing catalog, user specifies whether to copy the changes to future terms */ 
                                $scope.replicateIntructionsMessage = isNewCatalog ? 'Select additional course terms that you would like the new catalog to be applied to. Applying the new catalog to additional course terms will overwrite any existing catalog for those terms.'
                                    : 'Select additional course terms that you would like your catalog edits applied to.';
                                var unSavedRepCatModalAlert = function(size) {
                                    var dupCatalogModalInstance = $uibModalInstance;
                                    $scope.modalInstance = $uibModal.open({
                                        animation: $scope.animationsEnabled,
                                        templateUrl: 'repCatalogOkCancelModal.html',
                                        size: size,
                                        keyboard: false,
                                        backdrop: 'static',
                                        controller: ['$scope', '$uibModalInstance',
                                        function ($scope, $uibModalInstance) {
                                            $scope.okRepCatalog = function () {
                                                $uibModalInstance.close(true);
                                                dupCatalogModalInstance.dismiss('cancel');
                                            };
                                            /* STT-8384: STT.7803h.1 When saving modifications for an existing catalog, user specifies whether to copy the changes to future terms */ 
                                            $scope.dialogMsg = isNewCatalog ? 'You are about to cancel without having applied your new catalog to additional terms. Do you want to continue?'
                                                : 'You are about to cancel without having applied your catalog edits to additional terms. Do you want to continue?';
                                            $scope.cancelRepCatalog = function () {
                                                $uibModalInstance.close(false);
                                            };
                                        }], 
                                        
                                    });
                                }

                                $scope.xschSchTermsSelection = function(){
                                    $scope.xschSchTermsToBeApplied = $scope.xschSchTermsResponse.filter(x => x.checked)
                                    if($scope.xschSchTermsToBeApplied.length == $scope.xschSchTermsResponse.length){
                                        $scope.xschTermsToCopySelectStatus = true;
                                    }else{
                                        $scope.xschTermsToCopySelectStatus = false;
                                    }
                                }

                                $scope.selectAllXschSchTermToBeApplied = function(){
                                    $scope.xschSchTermsResponse.forEach(function(item,index){
                                        item.checked = $scope.xschTermsToCopySelectStatus;
                                    },$scope.xschSchTermsResponse);
                                    if($scope.xschTermsToCopySelectStatus){
                                        $scope.xschSchTermsToBeApplied = $scope.xschSchTermsResponse;
                                    }else{
                                        $scope.xschSchTermsToBeApplied = [];
                                    }
                                };
    
                                $scope.replicateCatalogModalCancel = function() {
                                    if($scope.xschSchTermsToBeApplied.length > 0){
                                        unSavedRepCatModalAlert();
                                    }else{
                                        $uibModalInstance.dismiss('cancel');
                                    }
                                };
    
                                $scope.closeNotification = function() {
                                    $scope.closeReplicateCatModal = true;
                                }
    
                                $scope.replicateCatalog = function(){
                                    $scope.isReplicationBusy = true
                                    var replicateRequestObject = {
                                        "schoolYearTermList": $scope.xschSchTermsToBeApplied,
                                        "schoolCatalogCourses": courseCatalogChanges
                                    };
                                    schoolDataEditSvcTmp.replicateCatalogCourseChanges(
                                        authentication.getCurrentUser().keycode,
                                        $scope.currentSchool.schoolId,
                                        schoolyear,
                                        xschSchTermIdFrom,
                                        replicateRequestObject,
                                        isNewCatalog
                                    ).then(function(data){
                                            $scope.replicateCatModalErrorOccurred = false;
                                            $scope.isReplicationBusy=false;
                                            $uibModalInstance.close(true);
                                    }, function(error) {
                                        console.info('Error in showing xschSchTerms catalogs....'.concat(angular.toJson(error)));
                                        $scope.replicateCatModalErrorOccurred = true;
                                        $scope.replicateCatModalErrorMessage = "";
                                        if (error.status == 400) {
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.replicateCatModalErrorMessage = $scope.replicateCatModalErrorMessage + error.data._errors[j] + "\n";
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.replicateCatModalErrorMessage = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.replicateCatModalErrorMessage = schoolwork12.app.errorMessages.internalError;
                                        }
                                        $scope.isReplicationBusy=false;
                                    });
                                }
                            }
                        ],
                    });
                    replicateCatalogModalInstance.result.then(function(data){
                        if(data){
                            //this function is invoke to refresh xschSchTerms catalogcourse count within the schoolyear
                            $scope.setXschSchYears(schoolyear,null);
                        }
                    });
                }/**END OF STT-8373 */

            /***********************************************/
            /********* MANAGE DEFAULT COURSES ************ */
            /***********************************************/
            
            //STT-8800: fetch and set school years for default courses 
            $scope.setSchDefaultYears = function(schoolyear, event){
                if($scope.forms.CoursesForm.$dirty){
                    console.log("CoursesForm dirty - years accordion clicked");
                    event.preventDefault();
                    event.stopPropagation();
                    $scope.openAlertUnsavedGradeCourses();

                    $scope.modalInstanceCourse.result.then(function(option){
                        if (option) {
                            console.log("yes clicked - CoursesForm")
                            $scope.forms.CoursesForm.$setPristine();
                            $scope.resetCoursesFormPanel();
                            $scope.courseStatus = {};
                        }
                    });

                } else {
                    $scope.courseSchoolYearSelected = schoolyear;

                    $scope.courseStatus.isTermOpen = [];
                    $scope.xschSchYearTerms = [];
                    $scope.xschSchGrades = [];
                    $scope.courseGradeData = [];
                    schoolDataEditSvc.getXschSchTerms(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId,schoolyear.year)
                        .then(function(data){
                            console.log("XschSchYearTerms were fetched successfully");
                            if(data){
                                $scope.xschSchYearTerms = data;
                            }
                        });
                    }
                
                }

            //STT-8800: fetch and set school grades for specified year and term    
            $scope.setXschSchGrades = function(year, term, index, event){
                if($scope.forms.CoursesForm.$dirty){
                    console.log("CoursesForm dirty - terms accordion clicked");
                    event.preventDefault();
                    event.stopPropagation();
                    $scope.openAlertUnsavedGradeCourses();

                    $scope.modalInstanceCourse.result.then(function(option){
                        if (option) {
                            console.log("yes clicked - terms accordion")
                            $scope.forms.CoursesForm.$setPristine();
                            $scope.resetCoursesFormPanel();
                            $scope.courseStatus.isTermOpen = [];
                        }
                    });

                } else {
                    $scope.courseSchoolTermSelected = $scope.xschSchYearTerms.find(xsch => xsch.id == term);

                    $scope.courseStatus.isGradeOpen = [];
                    $scope.xschSchGrades = [];
                    $scope.courseGradeData = [];
                    $scope.isSearchGradesBusy = true;

                    $timeout(function () {
                        if($scope.courseStatus.isTermOpen){
                            var a = $scope.courseStatus.isTermOpen;
                            $scope.selTermIndex = a.indexOf(true);
                        }
                        
                        if($scope.selTermIndex == index){
                            //invoke svc to fetch school grades
                             schoolDataEditSvc.getXschSchGrades(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, year, term)
                            .then(function(data){
                                console.log("xschSchGrades were fetched successfully");
                                if(data){
                                    // this variable will contain original xschSchGrades list retrieved by service
                                    $scope.xschSchGrades = data;
                                    $scope.isSearchGradesBusy = false;
                                    $scope.isSearchBusy = false; 
                                    // $scope.showSavedSchoolDataMsg = false;
                                }
                            });
                        }
                    }, 500)

                }
            }    
            //----End of STT-8800----//
            
            $scope.gradeSelList = [];
            $scope.gradeList = [];
            //STT-8742: fetch and set school courses for specified year/term/grade
            $scope.setSchGradesCourses = function(year, term, grade, index, event){
                $scope.courseSchoolGradeSelected = grade;
                $rootScope.isSearchCoursesBusy = true;
                $scope.courseGradeData = [];

                var uniqueGradeList =   _.uniq($scope.gradeSelList, 'gradeLevelId');

                if($scope.forms.CoursesForm.$dirty && _.contains( uniqueGradeList, grade)){
                        console.log("grade call already made")
                        for(var i=0; i < $scope.xschSchGrades.length; i++){
                            if(angular.isDefined($scope.gradeList[i]) && ($scope.gradeList[i].defaultCourseGradeLevelId == grade.gradeLevelId)){
                                $scope.courseGradeData = $scope.gradeList[i];
                            }
                            else if($scope.xschSchGrades[i].gradeLevelId == grade.gradeLevelId){
                                $scope.courseGradeData = $scope.gradeList[i];
                            } else {
                                 $rootScope.isSearchCoursesBusy = false;
                                 console.log("no edits made")
                            }
                        }

                } else {
                    console.log("first time call");
                    $timeout(function () {
                        if($scope.courseStatus.isGradeOpen){
                            var a = $scope.courseStatus.isGradeOpen;
                            $scope.selGradeIndex = a.indexOf(true);
                        }
                        
                        if($scope.selGradeIndex == index){
                            //invoke svc to fetch school/term/grade courses
                             schoolDataEditSvc.getSchGradeCourses(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, year, term, grade.gradeLevelId)
                            .then(function(data){
                                console.log("schGradeCourses were fetched successfully");
                                if(data){
                                    $scope.courseGradeData = data.courseList;     
                                    $scope.origCourseGradeData = angular.copy(data.courseList);
                                    $rootScope.isSearchCoursesBusy = false;
                            
                            }
                            })['finally'](function () {
                                $rootScope.isSearchCoursesBusy = false;
                            });
                        }
                    }, 500)
                }
            }


            $scope.deleteGradeCourseRow = function(courseRow, allGrades, courseGradeModified){
                $scope.forms.CoursesForm.$setDirty();
                $scope.gradeSelList.push($scope.courseSchoolGradeSelected);

                if(courseGradeModified.length > 0){
                    for(var i=0; i < allGrades.length; i++){
                        for(var j=0; j < courseGradeModified.length; j++){
                            //bind to new property: defaultCourseGradeLevelId
                            if(allGrades[i].gradeLevelId == courseGradeModified[j].defaultCourseGradeLevelId){
                                $scope.gradeList[i] = courseGradeModified;
                            }
                            //set status = 0 and edited = true for deleted courses
                            if(courseGradeModified[j].courseCode == courseRow.courseCode){
                                courseGradeModified[j].status = 0;
                                courseGradeModified[j].edited = true;
                            } 
                        }
                    }
                }
            }

            $scope.resetCoursesFormPanel = function () {
                $scope.resetForms();
                $scope.courseGradeData = angular.copy($scope.origCourseGradeData);
                if($scope.gradeList.length > 0){
                    $scope.courseStatus.isTermOpen = [];
                }
                console.log("resetCoursesFormPanel");
            }

            $scope.openAlertUnsavedGradeCourses = function () {
                $scope.modalInstanceCourse = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'editDefaultCourses.html',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.okEditDefault = function () {
                            console.log("yes: discard grade course edits")
                            $uibModalInstance.close(true);
                        };

                        $scope.dialogMsg = 'You have unsaved changes for the default courses of the selected year and term. Do you want to continue without saving the changes?';
                        $scope.cancelEditDefault = function () {
                            console.log("no: keep grade course edits")
                            $uibModalInstance.close(false);
                        };
                    }], 
                    
                });
             };

            //----End of STT-8742----//

            
                /**
                 * STT-8805
                 * STT.7642e Modal is displayed so the user can select default courses
                 */

                $scope.defaultCoursesModal = function (){
                    var tempDefaultCatalogSchoolYearSelected = $scope.courseSchoolYearSelected;
                    var tempDefaultCatalogSchoolTermSelected = $scope.courseSchoolTermSelected;
                    var schoolId = $scope.editSchoolData.schoolId;
                    var tempSchoolDataEditSvc = schoolDataEditSvc;
                    var defaultCoursesModalInstance = $uibModal.open({
                        animation: $scope.animationsEnabled,
                        templateUrl: 'defaultCoursesModal.html',
                        size: 'lg',
                        backdrop: 'static',
                        controller: ['$scope', '$uibModalInstance',
                            function($scope, $uibModalInstance) {
                                console.log(`Viewing available ${tempDefaultCatalogSchoolYearSelected} - ${tempDefaultCatalogSchoolTermSelected} Courses`);
                                $scope.defaultCourseSchoolYearSelected = `${tempDefaultCatalogSchoolYearSelected.year}-${tempDefaultCatalogSchoolYearSelected.year+1}`;
                                $scope.defaultCourseSchoolTermSelected = tempDefaultCatalogSchoolTermSelected.name;
                                $scope.displayDefaultCoursesGridModal = false;
                                $scope.defaultCourseGridModalOptions = {
                                    enableFiltering: true,
                                    enableRowSelection: true,
                                    enableGridMenu: true,
                                    exporterMenuPdf: false,
                                    enableRowHeaderSelection: true,
                                    showGridFooter: true,
                                    enableCellEditOnFocus: true,
                                    rowHeight: 50,
                                    paginationPageSizes: [25, 50, 75],
                                    paginationPageSize: 25,
                                };

                                //build K12 Courses Table column definitions
                                $scope.defaultCourseGridModalOptions.columnDefs = [
                                    { field: 'courseCode', displayName: 'Course Code', minWidth: 130, cellClass: 'text-k12Grid-column'},
                                    { field: 'courseName', displayName: 'Course Name', minWidth: 350 },
                                    { field: 'subjectName', displayName: 'Subject', minWidth: 220, cellClass: 'text-k12Grid-column' },
                                    { field: 'gradeName', displayName: 'Grade Level', minWidth: 10, cellClass: 'text-k12Grid-column'},
                                ];

                                //  get Courses info service
                                tempSchoolDataEditSvc.getXschSchCourses(authentication.getCurrentUser().keycode, schoolId, 
                                            tempDefaultCatalogSchoolYearSelected.year, tempDefaultCatalogSchoolTermSelected.id)
                                .then(function(response){
                                    console.log("XschSchCourses were fetched successfully");
                                    if(response){
                                        if (typeof (response.schoolCatalogCourses) != 'undefined' && response.schoolCatalogCourses.length > 0) {
                                            $scope.displayDefaultCoursesGridModal = true;
                                            $scope.defaultCourseGridModalOptions.data = response.schoolCatalogCourses;
                                        } else {
                                            $scope.defaultCoursesModalErrorOccurred = true;
                                            $scope.defaultCoursesModalErrorMessage = schoolwork12.app.errorMessages.noResultsFound;
                                        }
                                    }
                                }, function(error){
                                    console.info('Error when retrieving XschSchCourses...'.concat(angular.toJson(error)));
                                    $scope.defaultCoursesModalErrorOccurred = true;
                                    $scope.defaultCoursesModalErrorMessage = "";
                                    if (error.status == 400) {
                                        for (var j = 0; j < error.data._errors.length; j++) {
                                            $scope.defaultCoursesModalErrorMessage = $scope.defaultCoursesModalErrorMessage + error.data._errors[j] + "\n";
                                        }
                                    } else if (error.status == 401 || error.status == 403) {
                                        $scope.defaultCoursesModalErrorMessage = schoolwork12.app.errorMessages.sessionExpired;
                                    } else {
                                        $scope.defaultCoursesModalErrorMessage = schoolwork12.app.errorMessages.internalError;
                                    }
                                })['finally'](function () {
                                   
                                });

                                var unSavedDefaultCoursesModalAlert = function(size) {
                                    var defaultCoursesModalInstance = $uibModalInstance;
                                    $scope.modalInstance = $uibModal.open({
                                        animation: $scope.animationsEnabled,
                                        templateUrl: 'defaultCoursesOkCancelModal.html',
                                        size: size,
                                        keyboard: false,
                                        backdrop: 'static',
                                        controller: ['$scope', '$uibModalInstance',
                                        function ($scope, $uibModalInstance) {
                                            $scope.okDefaultCourses = function () {
                                                $uibModalInstance.close(true);
                                                defaultCoursesModalInstance.close(true);
                                            };
                    
                                            $scope.defaultCoursesOkCanceldialogMsg = "You have selected default courses to be added. Do you want to continue without accepting the changes?";
                                            $scope.cancelDefaultCourses = function () {
                                                $uibModalInstance.close(false);
                                            };
                                        }], 
                                        
                                    });
                                }
                                
                                $scope.defaultCoursesModalCancel = function() {
                                    if ((typeof ($scope.gridApi.selection) !== 'undefined') && ($scope.gridApi.selection.getSelectedRows().length > 0)){
                                        unSavedDefaultCoursesModalAlert();
                                    }else{
                                        $uibModalInstance.dismiss('cancel');
                                    }
                                };

                                $scope.defaultCorsecloseNotificationModal = function() {
                                    $scope.closeDefaultCoursesModal = true;
                                }

                                $scope.addDefaultCourses = function(){
                                    $uibModalInstance.close($scope.gridApi.selection.getSelectedRows());
                                }

                                $scope.defaultCourseGridModalOptions.onRegisterApi = function(gridApi){
                                    //set gridApi on scope and make it available on HTML
                                    $scope.gridApi = gridApi;
                                };

                            }
                        ],
                    });
                    
                    defaultCoursesModalInstance.result.then(function (selectedCatalogCourses){
                        if(typeof (selectedCatalogCourses) != 'undefined' && selectedCatalogCourses.length > 0){
                            $scope.gradeSelList.push($scope.courseSchoolGradeSelected);
                            var gradeIndex = $scope.xschSchGrades.findIndex(x => x.gradeLevelId == $scope.courseSchoolGradeSelected.gradeLevelId);
                            selectedCatalogCourses.forEach(function(item,index){
                                if(!_.find($scope.courseGradeData, function (courseGridObject)
                                    { return courseGridObject.courseCode == item.courseCode; })
                                ){
                                    item.edited = true;
                                    item.defaultCourseGradeLevelId = $scope.courseSchoolGradeSelected.gradeLevelId;
                                    $scope.courseGradeData.push(item);
                                    $scope.forms.CoursesForm.$setDirty();
                                }
                            });
                            $scope.gradeList[gradeIndex] = $scope.courseGradeData;
                        }
                    });
                }/* END OF STT-8805 */


            /***********************************************/
            /***************** INTEGRATION *****************/
            /***********************************************/   
            
            $scope.integrationOptionChanged = function () {
                $scope.integration.object.isIntegrated = $scope.integration.optionSelected.isIntegrated;
            };

            $scope.resetIntegrationForm = function () {
                $scope.integration.object = angular.copy($rootScope.integrationObject);
                $scope.integration.optionSelected = $scope.integration.options.find(x => x.isIntegrated == $scope.integration.object.isIntegrated);
                $scope.resetSchoolIntegrationErrors();
            }

            $scope.maxInputLength = function ($event,value,maxLength) {    
                if (value != undefined && value.toString().length >= maxLength) {
                    $event.preventDefault();
                }    
            }


            $scope.saveSchoolIntegrationDetails = function(isValid){
                if(isValid){
                    var tempIntegrationObject = $scope.integration.object;
                    var tempLastRun = (tempIntegrationObject.lastRun instanceof Date) ? moment(tempIntegrationObject.lastRun).format("MM/DD/YYYY hh:mm:ss a") : null;
                    tempIntegrationObject.lastRun = tempLastRun;
                    console.log(tempIntegrationObject);
                    var saveSchoolIntegrationPromise = null;
                    saveSchoolIntegrationPromise = schoolDataEditSvc.saveSchoolIntegrationDetails(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId,tempIntegrationObject);
                    var saveSchoolIntegrationPromiseChain = saveSchoolIntegrationPromise.then(function (data) { 
                        if(data){
                            $scope.editReasonErrorOccurred= false;
                            $scope.showSavedSchoolDataMsg = true;
                            $scope.forms.integrationForm.$setPristine();  
                            $scope.getSchoolIntegrationDetails();    
                        }
                    },function(error) {
                        console.error('Error when saving School Integration details....'.concat(angular.toJson(error)));
                        $scope.editReasonErrorMsgOccurred =true;
                        $scope.editReasonErrorOccurred= true;

                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                        })['finally'](function () {
                        $scope.isSaveBusy=false;

                    });
                }
                return saveSchoolIntegrationPromiseChain;
            }

            $scope.resetSchoolIntegrationErrors = function(){
                $scope.forms.integrationForm['integrationLastRun'].$setValidity('lastRunValid', true);
                $scope.forms.integrationForm['integrationOption'].$setValidity('optionValid', true);
                $scope.forms.integrationForm['integrationBilling'].$setValidity('billingValid', true);
                $scope.forms.integrationForm['integrationVerificationYear'].$setValidity('verificationYearValid', true);
                $scope.forms.integrationForm['integrationShippingDays'].$setValidity('shippingDaysValid', true);
                $scope.forms.integrationForm['integrationSequence'].$setValidity('sequenceValid', true);
                $scope.editIntegrationErrorOccured = false;
            }

            var isSchoolIntegrationCheckValid= function(){
                var isSchoolIntegrationValid= true;
                $scope.editIntegrationErrorOccured = false;

                //clear and reset validation msgs
                $scope.resetSchoolIntegrationErrors();

                if(!document.getElementById("integrationLastRun").checkValidity()){
                    $scope.forms.integrationForm['integrationLastRun'].$setValidity('lastRunValid', false);
                    isSchoolIntegrationValid= false;
                }

                if($scope.integration.object.isIntegrated != null){
                    if(isNaN($scope.integration.object.isIntegrated)){
                        $scope.forms.integrationForm['integrationOption'].$setValidity('optionValid', false);
                        isSchoolIntegrationValid= false;
                    }
                }

                if(isNaN($scope.integration.object.billingOptionNum) || 
                    ($scope.integration.object.billingOptionNum != null && $scope.integration.object.billingOptionNum.toString().length > 4)){
                    $scope.forms.integrationForm['integrationBilling'].$setValidity('billingValid', false);
                    isSchoolIntegrationValid= false;
                }

                if(isNaN($scope.integration.object.verificationRegYear) || 
                    ($scope.integration.object.verificationRegYear != null && $scope.integration.object.verificationRegYear != 0
                    && $scope.integration.object.verificationRegYear.toString().length != 4)){
                    $scope.forms.integrationForm['integrationVerificationYear'].$setValidity('verificationYearValid', false);
                    isSchoolIntegrationValid= false;
                }

                if(isNaN($scope.integration.object.shipmentDays) || 
                    ($scope.integration.object.shipmentDays != null && $scope.integration.object.shipmentDays.toString().length > 4)){
                    $scope.forms.integrationForm['integrationShippingDays'].$setValidity('shippingDaysValid', false);
                    isSchoolIntegrationValid= false;
                }

                if(isNaN($scope.integration.object.sequence) || 
                    ($scope.integration.object.sequence != null && $scope.integration.object.sequence.toString().length > 4)){
                    $scope.forms.integrationForm['integrationSequence'].$setValidity('sequenceValid', false);
                    isSchoolIntegrationValid= false;
                }

                $scope.editIntegrationErrorOccured = !isSchoolIntegrationValid;
                return isSchoolIntegrationValid;
            
            }

            /***********************************************/
            /************ REACTIVATE CLASSROOMS ************/
            /***********************************************/

            $scope.clearReactSearchFilter = function() {
                $scope.searchFilter.deactClassName = "";
                $scope.searchFilter.deactClassID = "";
                $scope.searchFilter.deactCourseOffID = "";
                $scope.searchFilter.deactDate = "1";
            };

            $scope.initReactClassroomPanel = function() {                
                $scope.isSearchBusy = false;
                $scope.displaySearchGrid = false;
                $scope.searchFilter = {};
                $scope.clearReactSearchFilter();
                $scope.disableReactButton = true;
                $scope.selectedDeactClassCount = 0;
                $scope.pendingReactClassrooms = [];
                $scope.displayReactivationMsg = false;
                if ($scope.searchGridOptions)
                    $scope.searchGridOptions.data = [];
            };         

            $scope.allowOnlyNumbers = function(keyEvent) {
                if ((keyEvent.which >= 48 && keyEvent.which <= 57) 
                    || keyEvent.which == 8 || keyEvent.which == 9 || keyEvent.which == 46)
                    return; // default event

                keyEvent.preventDefault();
            };

            // init Reactivate Classrooms panel
            $scope.initReactClassroomPanel();

            $scope.searchGridOptions = {
                rowHeight: 50,
                paginationPageSizes : [ 25, 50, 75 ],
                paginationPageSize : 25,
                enableRowSelection : true,
                enableSelectAll: true,
                multiSelect: true,
                enableSorting: true
            };

            $scope.searchGridOptions.columnDefs = [
                { field: 'className', displayName: 'Classroom Name', width: '25%', minWidth: 150 },
                { field: 'courseOff', displayName: 'Course Offering', width: '15%', minWidth: 150},
                { field: 'createdBy', displayName: 'Created By',  width: '15%', minWidth: 150},
                { field: 'createdDate', displayName: 'Created Date', cellFilter: 'date', type: 'date', width: '15%', minWidth: 150},
                { field: 'deactDate', displayName: 'Deactivated Date', cellFilter: 'date', type: 'date', width: '15%', minWidth: 150},
                { field: 'deactBy', displayName: 'Deactivated By',  width: '*', minWidth: 150, enableColumnResizing: false},                
            ];

            $scope.searchGridOptions.onRegisterApi = function(gridApi) {
                console.log("on register API...");
                $scope.searchGridApi = gridApi;
                $scope.searchGridApi.grid.registerRowsProcessor($scope.hidePendingClassroomsActivation, 200);
                $scope.sdcPaginationChanged = false;
                $scope.sdcCurrentPageSize = 25;
                var pageNumber, pageSize;
                $scope.searchGridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize){  
                    console.log(""+pageNumber+"-"+pageSize);              
                    $scope.sdcPaginationChanged = true;
                    $scope.sdcCurrentPageSelection = pageNumber;
                    $scope.sdcCurrentPageSize = pageSize;                    
                });

                $scope.searchGridApi.selection.on.rowSelectionChanged($scope, function(row){
                    row.entity.status = row.isSelected ? 1 : 0;
                    $scope.selectedDeactClassCount = $scope.searchGridApi.selection.getSelectedRows().length;
                    $scope.disableReactButton = $scope.selectedDeactClassCount > 0 ? false : true;                    
                });

                $scope.searchGridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
                    if (!$scope.displayReactivationMsg) {
                        rows.forEach(function(row){
                            row.entity.status = row.isSelected ? 1 : 0;
                        });                    
                        $scope.selectedDeactClassCount = $scope.searchGridApi.selection.getSelectedRows().length;
                        $scope.disableReactButton = $scope.selectedDeactClassCount > 0 ? false : true;
                    }                        
                });
            };

            $scope.toggleSelectable = function() {

                $scope.searchGridOptions.isRowSelectable = function(row){
                    return !$scope.displayReactivationMsg;
                };
                $scope.searchGridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);                
            };

            $scope.resetReactClassroomPanel = function(){
                $scope.isSearchBusy = false;
                $scope.displaySearchGrid = true;
                $scope.disableReactButton = true;                
                
                // restores selected classrooms to grid
                angular.forEach($scope.pendingReactClassrooms, function(selectedClassroom){
                    $scope.searchGridOptions.data[selectedClassroom.index].status = 0;
                });
                $scope.pendingReactClassrooms = [];
                $scope.displayReactivationMsg = false;
                $scope.searchGridApi.selection.clearSelectedRows();                                
                $scope.searchGridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
            };

            $scope.hidePendingClassroomsActivation = function(renderableRows){
                console.log("hide pending classrooms..."+$scope.displayReactivationMsg);
                if ($scope.displayReactivationMsg) {
                    renderableRows.forEach( function(row) {
                        if (row.entity.status == 1)
                            row.visible = false;
                    });                    
                }
                    
                return renderableRows;
            };

            $scope.searchDeactivatedClassrooms = function() {
                $scope.clearErrorMessages();
                if ($scope.selectedDeactClassCount > 0)
                    $scope.searchGridApi.selection.clearSelectedRows();
                $scope.isSearchBusy = true;
                schoolDataEditSvc.searchDeactivatedClassrooms(authentication.getCurrentUser().keycode,
                                                              $scope.editSchoolData.schoolId,
                                                              $scope.searchFilter.deactClassName,
                                                              $scope.searchFilter.deactClassID,
                                                              $scope.searchFilter.deactCourseOffID,
                                                              getDateFilter($scope.searchFilter.deactDate))
                .then(function(data){
                    console.info("returned from service.");
                    if (data) {
                        if (data.classroomList && data.classroomList.length > 0) {
                            $scope.searchGridOptions.data = data.classroomList;
                            $scope.displaySearchGrid = true;
                            $scope.noSearchResults = false;
                            if ($scope.searchGridApi) // in the first search gridApi is undefined
                                $scope.toggleSelectable(); // re-enable row selection in case 'Reset' was pressed
                        } else {
                            $scope.noSearchResults = true;
                            $scope.displaySearchGrid = false;
                            $scope.searchGridOptions.data = [];                            
                        }                            
                    }
                }, function(error){
                    console.info('Error when searching deactivated classrooms...'.concat(angular.toJson(error)));
                    $scope.editErrorOccurred = true;
                    $scope.editErrorMsgOccurred = true;
                    if (error.status == 400) {
                        for (var j = 0; j < error.data._errors.length; j++) {
                            $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    } else {
                        $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    }
                })['finally'](function () {
                    $scope.isSearchBusy=false;
                });
            };

            // grab selected deactivated classrooms to be sent on saving.
            $scope.reactivateClassrooms = function() {

                $scope.clearErrorMessages();
                if ($scope.selectedDeactClassCount <= 1000) {
                    angular.forEach($scope.searchGridOptions.data, function(classroom, index){
                        if (classroom.status == 1)
                            this.push({index: index, classID: classroom.classroomID});
                    }, $scope.pendingReactClassrooms);
                        
                    // display warning message and disable search buttons and table to prevent further selection
                    $scope.displayReactivationMsg = true;
                    $scope.toggleSelectable();
                    $scope.searchGridApi.grid.refresh();
                } else {
                    $scope.editErrorMsgOccurred = true;
                    $scope.editErrorMesg = schoolwork12.app.manageSchoolData.errorMessages.maxClassroomsSelectedForActivation;
                    // $scope.reactivateErrorExists = true;
                }
                    
            };

            // convert selected Deactivated Date dropdown value to a month number
            var getDateFilter = function(deactDateValue) {
                var dateFilter = new Date();
                switch(deactDateValue) {
                    case "1":
                        dateFilter.setDate(1);
                        break;
                    case "2":
                        dateFilter.setMonth(dateFilter.getMonth() - 3);
                        break;
                    case "3":
                        dateFilter.setMonth(dateFilter.getMonth() - 6);
                        break;
                    default:
                        dateFilter = new Date('01/01/1900');
                }
                return $filter('date')(dateFilter, 'MM/dd/yyyy');
            };

            $scope.reset = function(){
                //reset data fields if form dirty
                if($scope.forms.FieldsForm.$dirty) {
                    $scope.resetDataFieldsPanel();
                }

                if($scope.forms.integrationForm.$dirty){
                    $scope.resetIntegrationForm();
                }

                if($scope.forms.CatalogsForm.$dirty) {
                    $scope.resetCatalogsFormPanel();
                }

                if($scope.forms.CoursesForm.$dirty) {
                    $scope.resetCoursesFormPanel();
                }

                if($scope.forms.dropDownListsForm) {
                    $scope.resetDropDownPanel();
                }

                $scope.resetClassroomDatesPanel();
                if($scope.searchGridApi){
                    $scope.resetReactClassroomPanel();
                }

                if($scope.isGradeSelected){
                    $scope.resetManageGradePanel();
                }
                
                if(!$scope.noSchoolYearSelected || !$scope.noSchoolYearDeletedSelected){
                    $scope.resetSchoolYearForm();
                }

                if($scope.forms.mainDataForm){
                    $scope.resetMainDataAccordion();
                }
                
            };
            
            //NgTagsInput Start
            $scope.allTagsAdded = [];
            $scope.tagsRemoved = [];
            $scope.loadTemplateTags = function ($query) 
            {   
                $scope.noMatchingTagFound = false;
                $query = $query.trim();
                var defer = $q.defer();
                schoolDataEditSvc.getSchoolMessageFieldTemplates(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId).then(function (data, status, headers, config) {

                    var matchingTagsList = data.schoolMessageFieldTemplatesList; 
                    var matchingTags = _.sortBy(matchingTagsList, function(o) { return o.templateName.toLowerCase(); });                 
                    
                    console.log("matchingTagsList", matchingTagsList.length);

                    if($scope.allTagsAdded.length > 0){
                        matchingTags = $scope.removeDuplicatesTags(matchingTags);                         
                    }                    
                    if ($query.length >= 1) {
                        matchingTags = matchingTags.filter(function (item) {
                            return item.templateName.toLowerCase().indexOf($query.toLowerCase()) != -1;
                        });                       
                        if (matchingTags.length <= 0) {
                                $scope.noMatchingTagFound = true;
                                matchingTags = [{
                                    "templateName": "Oops, nothing found! " + "'" + $query + "'"
                                }];
                        }
                    }
                defer.resolve(matchingTags);
               },
               function (data, status, headers, config) {
                console.error("ERROR OCCURRED");
               });
            return defer.promise;
          };
            
        $scope.removeDuplicatesTags = function(tagsArray){
            for(var i=0, len = $scope.allTagsAdded.length; i<len; i++){
                for(var j=0, length= tagsArray.length; j<length; j++){
                    if(tagsArray[j].templateName.toLowerCase() == $scope.allTagsAdded[i].templateName.toLowerCase()){
                        tagsArray.splice(j,1);
                        break;
                    }        
                }            
            }
            return tagsArray;
        };
            
        $scope.tagAdded = function(tag, termArray){ 
            if (tag.templateName.indexOf("Oops, nothing found!") !== -1) {
                termArray.pop(tag);                   
            } else {
                //set status 1 for tags added
                tag.status = 1;
                $scope.allTagsAdded.push(tag);
                console.log("$scope.allTagsAdded", $scope.allTagsAdded)
            }
        };
            
        var tempObj=[];    
        $scope.tagRemoved = function(tag, dataFieldList, fieldArray){
            $scope.allTagsAdded = $scope.allTagsAdded.filter(function(item){
                return item.templateName.toLowerCase() !== tag.templateName.toLowerCase() ;
            });            
        };

        $scope.saveClassReactFieldsSvc = function(){
            var classroomIdList = [];
            angular.forEach($scope.pendingReactClassrooms, function(selectedClassroom){
                this.push(selectedClassroom.classID);
            }, classroomIdList);

             //common service for classroom dates and reactivate panel
            schoolDataEditSvc.saveSchoolDataDetails(authentication.getCurrentUser().keycode, 
                                                $scope.editSchoolData.schoolId,
                                                classroomDatesCreate,
                                                classroomDatesDelete,
                                                classroomIdList)

            .then(function (data) {
                // $scope.resetForms();
                // $scope.editErrorOccurred =false;
                // $scope.showSavedSchoolDataMsg = true;
                $scope.editErrorMesg = "";
                $scope.editErrorMsgOccurred = false;
                $scope.forms.Dates.$setPristine();
                $scope.savedSchoolData = true;
                $scope.dateTags=[];
                getDatesList(data);
                $scope.currentDateTags = angular.copy($scope.dateTags);
                $scope.classDatePicker.dateToAdd = '';
                classroomDatesCreate = [];
                classroomDatesDelete = [];
                $scope.initReactClassroomPanel();
                $scope.toggleSelectable();
                $scope.classroomErrorSave = false;
                console.info("View saved school data details");
            },function(error) {
                $scope.classroomErrorSave = true;
                // $scope.showSavedSchoolDataMsg = false;
                $scope.editErrorOccurred =true;
                $scope.savedStudent = false;
                console.info("Error in saving school data details");
                if (error.status == 400) {
                    for ( var j = 0; j < error.data._errors.length; j++) {
                        $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                    }
                } else if (error.status == 401 || error.status == 403) {
                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                } else {
                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                }
            })['finally'](function () {
                $scope.isSaveBusy=false;
            });
        }

        $scope.saveManageDataFieldsSvc = function(){
             var saveManageDataFieldsPromise = null;
            //call save REST if fields panel is dirty or no error exists
            saveManageDataFieldsPromise = schoolDataEditSvc.saveSchoolDataFields(authentication.getCurrentUser().keycode, 
                                                    $scope.editSchoolData.schoolId,
                                                    $scope.record.dataFields )
            var saveManageDataFieldsChain = saveManageDataFieldsPromise.then(function (data) {
                // $scope.resetForms();
                $scope.editErrorOccurred =false;
                $scope.editErrorMesg = "";
                $scope.editErrorMsgOccurred = false;
                $scope.forms.FieldsForm.$setPristine();
                $scope.showSavedSchoolDataMsg = true;
                $scope.savedSchoolData = true;
                $scope.messageFieldError = false;
                console.info("View saved school data fields");
            },function(error) {
                $scope.showSavedSchoolDataMsg = false;
                $scope.editErrorOccurred =true;
                $scope.editErrorMsgOccurred = true;
                $scope.savedStudent = false;
                console.info("Error in saving school data fields");
                if (error.status == 400) {
                    for ( var j = 0; j < error.data._errors.length; j++) {
                        $scope.editErrorMesgTemp = $scope.editErrorMesgTemp + error.data._errors[j] + "\n";
                    }
                    var checkErrorMsg = $scope.editErrorMesgTemp;
                    $scope.invalidtemplateNameError = (~checkErrorMsg.indexOf("At least one Template must be selected")) ? true : false; 
                    $scope.duplicatetemplateNameError = (~checkErrorMsg.indexOf("only be mapped to one messaged field")) ? true : false; 
                    $scope.invalidHideTemplateError = (~checkErrorMsg.indexOf("may not be specified when Hiding a messaged field")) ? true : false; 

                    var text, str;
                        str = checkErrorMsg;
                        text = checkErrorMsg.split('[').pop().split(']')[0];
                        var dupTempIds = text.split(",");

                        //check for duplicate templates
                        for(var i =0; i< $scope.record.dataFields.length;i++){
                            for(var j =0; j< $scope.record.dataFields[i].templateDetails.length;j++){
                                $scope.record.dataFields[i].dupErrorExists = false;
                                if($scope.record.dataFields[i].templateDetails[j].templateId == dupTempIds[0]){
                                    $scope.record.dataFields[i].dupErrorExists = true;  
                                    break;
                                } 
                            }
                        }
                  
                    if($scope.invalidtemplateNameError || $scope.duplicatetemplateNameError || $scope.invalidHideTemplateError){
                        console.log("messageFieldError")
                        $scope.messageFieldError = true;
                        // $scope.editErrorMsgOccurred = false;
                    } 
    
                } else if (error.status == 401 || error.status == 403) {
                    $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                    // $scope.editErrorMsgOccurred = true;
                } else {
                    $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                    // $scope.editErrorMsgOccurred = true;
                }

            })['finally'](function () {
                $scope.isSaveBusy=false;
            });
            return saveManageDataFieldsChain;
        }

        //save button click: invoke promises
            $scope.saveSchoolDataDetails = function(){
                // $scope.clearErrorMessages();
                $scope.isSaveBusy = true;
                $scope.editErrorMesg = "";
                $scope.editGradeMErrorMesg= "";

                var isValid= true;
                var isReasonValid = true;
                var isSchoolYearValid = true;
                var isSchoolIntegrationValid = true;
                var isMainDataValid = true;

                if($scope.forms.grademarkForm.$dirty){
                    isValid = isGradeMarkValid();
                }

                if($scope.forms.dropDownListsForm.$dirty){
                    isReasonValid = isDropdownSetValid();
                }

                if($scope.forms.schoolYearForm.$dirty){
                    isSchoolYearValid = isSchoolYearCheckValid();
                }

                if($scope.forms.integrationForm.$dirty){
                    isSchoolIntegrationValid = isSchoolIntegrationCheckValid();
                }

                if($scope.forms.mainDataForm.$dirty){
                    isMainDataValid = isMainDataCheckValid();   
                }
                
                if(!isValid || !isReasonValid || !isSchoolYearValid || !isSchoolIntegrationValid || !isMainDataValid){
                  $scope.isSaveBusy = false;
                  return;
                }

                //STT-9214: STT.9185d User saves edits made to the Main Data for a school in TV Action
                if($scope.forms.mainDataForm.$dirty && isMainDataValid){
                    $scope.mainData.object.phone ? $scope.mainData.object.phone.replace(/[- )(]/g,'') : null;
                    let saveSchoolMainDataPromise = schoolDataEditSvc.saveSchoolMainData(authentication.getCurrentUser().keycode,
                        $scope.editSchoolData.schoolId,
                        $scope.mainData.object);
                    saveSchoolMainDataPromise.then(function(data){
                        if(data){
                            $scope.editMainDataErrorOccured = false;
                            $scope.showSavedSchoolDataMsg = true;
                            $scope.forms.mainDataForm.$setPristine();
                        }
                    }, function(error){
                        console.error('Error when saving School Main Data....'.concat(angular.toJson(error)));
                        $scope.editMainDataErrorOccured= true;
                        $scope.editMainDataErrorMsg = "";

                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.editMainDataErrorMsg = $scope.editMainDataErrorMsg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.editMainDataErrorMsg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.editMainDataErrorMsg = schoolwork12.app.errorMessages.internalError;
                        }
                    })['finally'](function(){
                        $scope.isSaveBusy = false;
                    });

                }

                for(var i =0; i< $scope.record.dataFields.length;i++){
                    if( $scope.record.dataFields[i].dupErrorExists){
                        $scope.record.dataFields[i].dupErrorExists = false;
                    }       
                }

                //check on dates/classroom section if dirty
                if($scope.forms.Dates.$dirty || $scope.displayReactivationMsg){
                    if($scope.forms.FieldsForm.$dirty){
                        $scope.saveManageDataFieldsSvc();
                        if($scope.messageFieldError){
                            $scope.editErrorOccurred =true;
                        } 
                    } else { 
                        if(!$scope.buttonDisabled){
                            $scope.saveClassReactFieldsSvc();
                            if(!$scope.classroomErrorSave){
                                $scope.showClassroomSavedMsg = true;
                                $scope.editErrorMsgOccurred = false;
                                console.log("save classroom successful")
                            }
                        }
                        
                        
                    }

                }
               
                //check if FieldsForm dirty and check on MessagedDataFieldsForm
                if($scope.forms.FieldsForm.$dirty){
                    if($scope.forms.MessagedDataFieldsForm.$dirty){
                        for(var j =0; j< $scope.record.dataFields.length;j++){
                            if($scope.record.dataFields[j].value && $scope.record.dataFields[j].templateDetails.length == 0){
                                $scope.record.dataFields[j].errorExists = true;
                                $scope.messageFieldError = true;
                            } else {
                                $scope.record.dataFields[j].errorExists = false;
                                $scope.messageFieldError = false;
                            }

                            if(!$scope.record.dataFields[j].value && $scope.record.dataFields[j].templateDetails.length > 0){
                                $scope.record.dataFields[j].hideErrorExists = true;
                               $scope.messageFieldError = true;
                            } else {
                                $scope.record.dataFields[j].hideErrorExists = false;
                                $scope.messageFieldError = false;
                            }
                        }
                    }

                    // $scope.invalidtemplateNameError = false;
                    if($scope.forms.Dates.$dirty || $scope.displayReactivationMsg){ 
                        if(!$scope.buttonDisabled){
                            console.log("field & dates forms dirty")
                            $scope.saveClassReactFieldsSvc(); 
                            if($scope.classroomErrorSave){
                                $scope.editErrorOccurred =true;
                            } else {
                                 $scope.editErrorOccurred =false;
                                 $scope.editErrorMsgOccurred = false;
                            }
                        }
                        
                    } else if($scope.forms.FieldsForm.$dirty){
                        console.log("save data fields HERE") 
                        $scope.saveManageDataFieldsSvc();         
                    } else {
                        console.log("save Grademark set");
                        $scope.gradeSetAdded = false;
                    }

                }

                //check if Manage Course Catalog section if ditry
                if($scope.forms.CatalogsForm.$dirty){
                    $scope.catalogSchoolTermSelected.schoolCatalogCourses = $scope.courseGridOptions.data;
                    //SIS-1070: 'xschSchTermIdOrigin' attribute was add to let the service duplicate default courses from the origin duplicated XschSchterm
                    var courseCatalogModified = {
                        "schoolYearTermDetails": $scope.catalogSchoolTermSelected,
                        "xschSchTermIdOrigin": $scope.courseGridOptions.xschSchTermIdOrigin
                    };
                    // console.log("courseCatalogModified", courseCatalogModified)
                    var isNewCatalog = $scope.catalogSchoolTermSelected.numberOfCatalogCourses == 0;
                    var saveCourseCatalogs = schoolDataEditSvc.saveCourseCatalogs(authentication.getCurrentUser().keycode,
                        $scope.editSchoolData.schoolId,
                        $scope.catalogSchoolYearSelected.split('-')[0].trim(),
                        $scope.catalogSchoolTermSelected.id,
                        courseCatalogModified);

                    $scope.isSearchBusy = true;
                    var saveCourseCatalogsPromiseChain = saveCourseCatalogs.then(function(data){
                        if(data){
                            $scope.editReasonErrorOccurred= false;
                            $scope.showSavedSchoolDataMsg = true;
                            $scope.forms.CatalogsForm.$setPristine(); 
                            $scope.setXschSchCourses($scope.catalogSchoolYearSelected.split('-')[0].trim(),
                            $scope.catalogSchoolTermSelected.id, $scope.selCatalogTermIndex, null);
                            var changesToReplicateTmp = $scope.catalogSchoolTermSelected.schoolCatalogCourses;
                            if(data.length > 0){
                                $scope.replicateCatalogChanges($scope.catalogSchoolTermSelected.year,
                                    $scope.catalogSchoolTermSelected.id,data,changesToReplicateTmp,isNewCatalog);
                            }
                        }
                    }, function(error){
                        console.error('Error when saving Catalogs Courses....'.concat(angular.toJson(error)));
                        $scope.editReasonErrorMsgOccurred =true;
                        $scope.editReasonErrorOccurred= true;

                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })['finally'](function(){
                        $scope.isSaveBusy = false;
                    });
                    
                    return saveCourseCatalogsPromiseChain;
                }

                //check if Manage Default Courses section if ditry
                if($scope.forms.CoursesForm.$dirty){

                    //set request payload structure for saving multiple grade edits
                    var courseModifiedData = [];
                    $scope.gradeList = $scope.gradeList.filter(Boolean);
                    for (var i=0; i < $scope.xschSchGrades.length; i++){
                        if(angular.isDefined($scope.gradeList[i])){
                            courseModifiedData[i] = {
                                "courseList": $scope.gradeList[i],
                                "xSchSchTerm": $scope.courseSchoolTermSelected
                            };
                        }
                    }

                    //STT-8743: Save default courses edits: delete and add feature
                    var saveDefaultCourses = schoolDataEditSvc.saveDefaultCourses(authentication.getCurrentUser().keycode,
                        $scope.editSchoolData.schoolId,
                        $scope.courseSchoolYearSelected.year,
                        $scope.courseSchoolTermSelected.id,
                        courseModifiedData);

                    $scope.isSearchBusy = true;
                    var saveDefaultCoursesPromiseChain = saveDefaultCourses.then(function(data){
                        if(data){
                            $scope.editReasonErrorOccurred= false;
                            $scope.showSavedSchoolDataMsg = true;
                            $scope.forms.CoursesForm.$setPristine();

                            courseModifiedData = [];
                            $scope.gradeList = [];
                            //invoke grades to fetch values after save
                            $scope.setXschSchGrades($scope.courseSchoolYearSelected.year,
                            $scope.courseSchoolTermSelected.id, $scope.selTermIndex, null);
                        }
                    }, function(error){
                        console.error('Error when saving default courses....'.concat(angular.toJson(error)));
                        $scope.editReasonErrorMsgOccurred =true;
                        $scope.editReasonErrorOccurred= true;

                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })['finally'](function(){
                        $scope.isSaveBusy = false;
                        // $scope.isSearchBusy = false;
                    });
                    
                    return saveDefaultCoursesPromiseChain;
                }


                //check if Grademark section is dirty
                $scope.gradeMarkSaved = false;
                if($scope.forms.grademarkForm.$dirty && !$scope.editErrorOccurred){
                     $scope.saveSchoolGradeMarkSetsSvc(isValid);
                }

                if($scope.forms.integrationForm.$dirty && !$scope.editErrorOccurred){
                    $scope.saveSchoolIntegrationDetails(isSchoolIntegrationValid);
                }

                //check if Dropdown section is dirty
                $scope.reasonSaved = false;
                if($scope.forms.dropDownListsForm.$dirty && !$scope.editErrorOccurred){

                    if($scope.dropdown.selectedType==2 || $scope.dropdown.selectedType==3){
                        $scope.saveSchoolCTESvc(isReasonValid);
                        console.log("save cteList call svc")
                    } 

                    else if($scope.dropdown.selectedType==4){
                        $scope.saveSchoolPartProgramsSvc(isReasonValid);
                        console.log("save partList call svc")
                    } 

                    else {
                        //SIS-1198
                        if($scope.dropDownTypeDetails.length > 0){
                            $scope.saveSchoolDropdownDetailsSvc(isReasonValid, $scope.dropdown.selectedType);
                            console.log("save svc with type param")
                        }else{
                            $scope.dropDownTypeDetails = angular.copy($scope.currentDownTypeDetails);
                            $scope.forms.dropDownListsForm.$setPristine(); 
                            $scope.editReasonErrorOccurred= false;
                            $scope.isSaveBusy = false;
                        }
                    }
                }

                //check if School year section is dirty
                $scope.schoolYearSaved = false;
                if($scope.forms.schoolYearForm.$dirty && !$scope.editErrorOccurred){
                     $scope.saveSchoolYearSvc(isSchoolYearValid);
                }


            };

            //Saves the pathways for current or future cte
            $scope.saveSchoolCTESvc = function(isReasonValid){
                    $scope.showSavedSchoolDataMsg = false;

                    if(isReasonValid == true) {
                        $scope.editReasonErrorOccurred = false;

                        const payload = $scope.CTEList.filter(cte=> !(!cte.xschcteid && cte.status === 0))
                        .map(cte => ({
                          cteId: cte.id,
                          name: cte.name,
                          isFutureCte: cte.isFuture? 1:0,
                          isCurrentCte: cte.isCurrent? 1:0,
                          displayName: cte.displayName,
                          xschcteid: cte.xschcteid,
                          status: cte.status
                        }));


                    
                        var saveSchoolCTEPromise = null;
                        saveSchoolCTEPromise = schoolDataEditSvc.saveSchoolCTEPrograms(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, payload);
                        var saveSchoolCTEPromiseChain = saveSchoolCTEPromise.then(function (data) {
                                if (data) {
                                     $scope.editReasonErrorOccurred= false;
                                     $scope.showSavedSchoolDataMsg = true;
                                     getAllDropDownTypeDetails();
                                     $scope.forms.dropDownListsForm.$setPristine();  
                                }

                            },function(error) {
                                console.error('Error when saving dropdown CTE details....'.concat(angular.toJson(error)));
                                $scope.editReasonErrorMsgOccurred =true;
                                $scope.editReasonErrorOccurred= true;

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                             })['finally'](function () {
                                $scope.isSaveBusy=false;

                            });

                }
                return saveSchoolCTEPromiseChain;
             } 

               $scope.saveSchoolPartProgramsSvc = function(isReasonValid){
                    $scope.showSavedSchoolDataMsg = false;
            
                    if(isReasonValid == true) {
                        $scope.editReasonErrorOccurred = false;
                    
                        var saveSchoolPartPromise = null;
                        saveSchoolPartPromise = schoolDataEditSvc.saveSchoolPartPrograms(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, $scope.allPartProgramList);
                        var saveSchoolPartPromiseChain = saveSchoolPartPromise.then(function (data) {
                                if (data) {
                                     $scope.editReasonErrorOccurred= false;
                                     $scope.showSavedSchoolDataMsg = true;
                                                    
                                     $scope.forms.dropDownListsForm.$setPristine();  
                                     console.log("saved dropdown Part Programs", data);  
                                }

                            },function(error) {
                                console.error('Error when saving dropdown Program details....'.concat(angular.toJson(error)));
                                $scope.editReasonErrorMsgOccurred =true;
                                $scope.editReasonErrorOccurred= true;

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                             })['finally'](function () {
                                $scope.isSaveBusy=false;
                            });

                }
                return saveSchoolPartPromiseChain;
             } 

             $scope.ethnicityOnChange = (item) => {
              item.edited = true;
             };


             $scope.checkDropdownStatus = function(val){
                $scope.dropDownTypeDetails.forEach(function (item) {
                    if($scope.dropdown.selectedType==20 || $scope.dropdown.selectedType==21 || $scope.dropdown.selectedType==22 || 
                        $scope.dropdown.selectedType==23 || $scope.dropdown.selectedType==24 || $scope.dropdown.selectedType==25 || 
                        $scope.dropdown.selectedType==26 || $scope.dropdown.selectedType==27){
                        //typeis one of the reasons
                        if(item.reasonId == val.reasonId){
                            item.edited = true;
                        }
                    }

                   if($scope.dropdown.selectedType==28){
                        //type - Immunization
                       if(item.immunshotId == val.immunshotId){
                           item.edited = true;
                       }
                   }

                   if($scope.dropdown.selectedType==7){
                    //match the object within the list
                    if(item.xschSRoleId == val.xschSRoleId && item.name == val.name){
                        let tempOriginalObjectState = $scope.currentDownTypeDetails.find(x => x.name == val.name && x.xschSRoleId == val.xschSRoleId);
                        //validate if status has changed from its initial state
                        if(tempOriginalObjectState.status != val.status){
                            item.edited = true;
                        }else{
                            item.edited = false;
                        }
                    }
                }
                   
                });
                console.log("val", val)
             }

             $scope.saveSchoolDropdownDetailsSvc = function(isReasonValid, type){
                    $scope.showSavedSchoolDataMsg = false;
            
                    if(isReasonValid == true) {
                        $scope.editReasonErrorOccurred = false;

                        if($scope.dropdown.selectedType==5){
                            angular.forEach($scope.dropDownTypeDetails, function (row) {
                                if(row.schoolEthyId){
                                    delete row.schoolEthyId
                                }
                            });
                        }
                    
                        var saveSchoolTypePromise = null;
                        saveSchoolTypePromise = schoolDataEditSvc.saveSchoolDropdownDetails(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, $scope.dropDownTypeDetails, type);
                        var saveSchoolTypePromiseChain = saveSchoolTypePromise.then(function (data) {
                                if (data) {
                                     $scope.editReasonErrorOccurred= false;
                                     $scope.showSavedSchoolDataMsg = true;
                                                    
                                     $scope.forms.dropDownListsForm.$setPristine();
                                     getAllDropDownTypeDetails();  
                                     // console.log("saved dropdown details by type", data, $scope.dropDownTypeDetails);  
                                }

                            },function(error) {
                                console.error('Error when saving dropdown details....'.concat(angular.toJson(error)));
                                $scope.editReasonErrorMsgOccurred =true;
                                $scope.editReasonErrorOccurred= true;

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                             })['finally'](function () {
                                $scope.isSaveBusy=false;
                            });

                }
                return saveSchoolTypePromiseChain;
             }  


            $scope.saveSchoolYearSvc = function(isSchoolYearValid){
                    $scope.showSavedSchoolDataMsg = false;

                    if(isSchoolYearValid == true) {
                        $scope.editYearErrorOccurred = false;

                        var saveSchoolYearObj = {};
                        //save existing year
                        if($scope.displayNewSchoolYear){
                            var saveExistingSchoolYearObj = 
                            {
                                'schoolId': $scope.editSchoolData.schoolId,
                                'schoolCurrentYear': $scope.editSchoolData.currentYear,
                                'schoolYear':{
                                    'id': $scope.displayNewSchoolYear.id,
                                    'schoolId': $scope.displayNewSchoolYear.schoolId,
                                    'year': parseInt($scope.displayNewSchoolYear.year),
                                    'status': $scope.displayNewSchoolYear.status,
                                    'startDate': $scope.displayNewSchoolYear.startDate ? $filter('date')($scope.displayNewSchoolYear.startDate, 'MM/dd/yyyy') : '',
                                    'endDate': $scope.displayNewSchoolYear.endDate ? $filter('date')($scope.displayNewSchoolYear.endDate, 'MM/dd/yyyy') : '',
                                    'courseStartDate': $scope.displayNewSchoolYear.courseStartDate ? $filter('date')($scope.displayNewSchoolYear.courseStartDate, 'MM/dd/yyyy') : '',
                                    'courseEndDate': $scope.displayNewSchoolYear.courseEndDate ? $filter('date')($scope.displayNewSchoolYear.courseEndDate, 'MM/dd/yyyy') : '',
                                    'createDate': $scope.displayNewSchoolYear.createDate,
                                    'createdBy': $scope.displayNewSchoolYear.createdBy,
                                    'modifyDate': $scope.displayNewSchoolYear.modifyDate,
                               }
                             }
                        }
                        
                        //save new year 
                        if($scope.displayNewSchoolSet){
                            var saveNewSchoolYearObj = {  
                               "schoolId": $scope.editSchoolData.schoolId,
                               "schoolCurrentYear": $scope.editSchoolData.currentYear,
                               "schoolYear":{
                                    "id": -1,
                                    'schoolId': $scope.editSchoolData.schoolId,
                                    'year': parseInt($scope.displayNewSchoolSet.yearVal),
                                    'status': 1,
                                    'startDate': $scope.displayNewSchoolSet.startDate ? $filter('date')($scope.displayNewSchoolSet.startDate, 'MM/dd/yyyy') : '',
                                    'endDate': $scope.displayNewSchoolSet.endDate ? $filter('date')($scope.displayNewSchoolSet.endDate, 'MM/dd/yyyy') : '',
                                    'courseStartDate': $scope.displayNewSchoolSet.courseStartDate ? $filter('date')($scope.displayNewSchoolSet.courseStartDate, 'MM/dd/yyyy') : '',
                                    'courseEndDate': $scope.displayNewSchoolSet.courseEndDate ? $filter('date')($scope.displayNewSchoolSet.courseEndDate, 'MM/dd/yyyy') : '',
                               }
                            }
                        }


                        console.log(saveNewSchoolYearObj);
                        saveSchoolYearObj = $scope.schoolYearAdded ? saveNewSchoolYearObj : saveExistingSchoolYearObj;
                        //STT-8343 && STT-8346
                        saveSchoolYearObj['xschSchTermList'] = $scope.setSchoolTerms;
                        //STT-9162
                        saveSchoolYearObj['holidays'] = $scope.setSchoolHolidays;
                        console.log("saveSchoolYearObj", saveSchoolYearObj);
                    
                        var saveSchoolYearPromise = null;
                        saveSchoolYearPromise = schoolDataEditSvc.saveSchoolYearSets(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, saveSchoolYearObj);
                        var saveSchoolYearPromiseChain = saveSchoolYearPromise.then(function (data) {
                                if (data) {
                                     $scope.editYearErrorOccurred= false;
                                     $scope.showSavedSchoolDataMsg = true;

                                    schoolDataEditSvc.getAllSchoolYear(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId)
                                    .then(function (data) {
                                        if (data) {
                                            $rootScope.schoolYears = data.schoolYearList;
                                            $scope.currentSchoolYears = data.schoolYearList;
                                            $scope.currentSchoolYearsDeleted = angular.copy(data.schoolYearList);
                                            $scope.resetSchoolYearForm();
                                            console.log("$rootScope.schoolYears", $rootScope.schoolYears, data);
                                        }
                                    })

                                     $scope.forms.schoolYearForm.$setPristine(); 
                                     // $scope.resetSchoolYearForm();
                                }

                            },function(error) {
                                console.error('Error when saving school year details....'.concat(angular.toJson(error)));
                                $scope.editReasonErrorMsgOccurred =true;
                                $scope.editYearErrorOccurred= true;
                                $scope.editReasonErrorMesg = "";

                                $scope.invalidNewSchoolYearError = false;
                                $scope.duplicateSchoolYearError = false;
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editReasonErrorMesg = $scope.editReasonErrorMesg + error.data._errors[j] + "\n";
                                    }

                                var checkSchoolErrorMsg = $scope.editReasonErrorMesg;
                                $scope.invalidNewSchoolYearError = (~checkSchoolErrorMsg.indexOf("New years may not be prior")) ? true : false; 
                                $scope.duplicateSchoolYearError = (~checkSchoolErrorMsg.indexOf("Year already exists for the school.")) ? true : false; 

                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editReasonErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                             })['finally'](function () {
                                $scope.isSaveBusy=false;

                            });

                }
                return saveSchoolYearPromiseChain;
             } 


            $scope.nextCourseChange = function(index){
                console.log("next course change", index);
                
                $scope.selectedSetDetails[index].edited = true;
                console.log("$scope.selectedSetDetails-course", index, $scope.selectedSetDetails)

                $scope.forms.grademarkForm.$dirty = true;
                $scope.forms.grademarkForm.$pristine= false;
            }

            $scope.editGradeName = function(index){
                 console.log("editGradeName", index);
                 $scope.selectedSetDetails[index].edited = true;
                 console.log("$scope.selectedSetDetails-name", index, $scope.selectedSetDetails)
            }

            $scope.editGradePercent = function(index){
                 console.log("editGradePercent", index);
                 $scope.selectedSetDetails[index].edited = true;
                 console.log("$scope.selectedSetDetails-percent", index, $scope.selectedSetDetails)
            }

            $scope.editGradeGpa = function(index){
                 console.log("editGradeGpa", index);
                 $scope.selectedSetDetails[index].edited = true;
                 console.log("$scope.allGradeDetail-gpa", index, $scope.selectedSetDetails)
            }

            $scope.saveSchoolGradeMarkSetsSvc = function(isValid){

                    $scope.noGradeMarks = false;
                    $scope.showSavedSchoolDataMsg = false;

                    if(isValid == true) {
                        $scope.editGradeMErrorOccurred = false;
                        var saveGradeMark = '';
                        if($scope.newSetSelected) {
                            saveGradeMark = {
                             'gradeMarkSetId': 0,
                             'name': $scope.displayNewSet.name,
                             'schoolId': $scope.editSchoolData.schoolId,
                             'gradeMarksList': $scope.newSetDetails,
                             'status': 1,

                            }
                            console.log("saveGradeMark", saveGradeMark);
                        } 
                        else {
                            $scope.allGradeDetails.gradeMarksList = angular.copy($scope.selectedSetDetails);
                            saveGradeMark = $scope.allGradeDetails ;
                        }
                        var saveSchoolGradeMarkSetsPromise = null;
                        saveSchoolGradeMarkSetsPromise = schoolDataEditSvc.saveSchoolGradeMarkSets(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId, saveGradeMark);
                        var saveSchoolGradeMarkSetsChain = saveSchoolGradeMarkSetsPromise.then(function (data) {
                                if (data) {
                                     $scope.editGradeMErrorOccurred= false;
                                     $scope.showSavedSchoolDataMsg = true;
                                    
                                     $scope.savedId = parseInt(data); 
                                     $scope.gradeMarkSaved = true;

                                    schoolDataEditSvc.getAllGradesList(authentication.getCurrentUser().keycode, $scope.editSchoolData.schoolId)
                                    .then(function (dataList) {
                                        if (dataList) {
                                            $rootScope.allGradeSets = dataList;
                                            $scope.currentGrades = dataList;

                                            $rootScope.noGradeSelected = true;
                                            $scope.gradeSetAdded = false;
                                            console.log("$scope.allGradeSets", $scope.allGradeSets);
                                        }

                                    },function(error) {
                                        console.error('Error when getting grades....'.concat(angular.toJson(error)));
                                        $scope.editErrorOccurred = true;
                                        if (error.status == 400) {
                                            for (var j = 0; j < error.data._errors.length; j++) {
                                                $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                                            }
                                        } else if (error.status == 401 || error.status == 403) {
                                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                        } else {
                                            $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                                        }
                                    })

                                     $rootScope.allGradeSets = angular.copy($scope.currentGrades);
                                     resetNewGradeMark();                  
                                     $scope.forms.grademarkForm.$setPristine();  
                                     console.log("SAVE DATA", data);  
                                }

                            },function(error) {
                                console.error('Error when getting grade details....'.concat(angular.toJson(error)));
                                $scope.editGradeMErrorMsgOccurred =true;
                                $scope.editGradeMErrorOccurred= true;
                                $scope.gradeMarkSaved = false;

                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.editGradeMErrorMesg = $scope.editGradeMErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.editGradeMErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.editGradeMErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                             })['finally'](function () {
                                $scope.isSaveBusy=false;
                            });

                }
                return saveSchoolGradeMarkSetsChain;
             }      

            var isGradeMarkValid= function(){
                var isValid= true;
                $scope.forms.grademarkForm['gradeSetName'].$setValidity('nameValid', true);

                if($scope.newSetSelected) {// if is new grademark
                    console.log("validating new Grademark");
                      if($scope.displayNewSet && !$scope.displayNewSet.name ){
                        $scope.forms.grademarkForm['gradeSetName'].$setValidity('nameValid', false);
                         isValid = false;

                      } 
                      if(!$scope.newSetDetails || ($scope.newSetDetails && $scope.newSetDetails.length==0)){
                            isValid = false;
                            $scope.noGradeMarks = true;
                      }
                      angular.forEach($scope.newSetDetails, function (row, index) {
                       isValid = isGradeMarkSetValid(row, index,isValid);
                      });
                      //validating duplicates
                     if(isValid){
                          isValid = validateDuplicateSet($scope.newSetDetails, isValid);
                      }

                  
                }else{//if  existing grademark is selected
                    console.log("Validating selected Grademark");

                    if(!$scope.allGradeDetails.name ){
                        $scope.forms.grademarkForm['gradeSetName'].$setValidity('nameValid', false);
                        isValid = false;

                    } 
                
                    if(!$scope.selectedSetDetails || ($scope.selectedSetDetails && $scope.selectedSetDetails.length==0)){
                        $scope.noGradeMarks = true;
                        isValid = false;
                    }

                     angular.forEach($scope.selectedSetDetails, function (row, index) {
                      isValid =  isGradeMarkSetValid(row, index,isValid);
                    });

                     //validate duplicates 
                     if(isValid){
                         isValid = validateDuplicateSet ($scope.selectedSetDetails,isValid );
                     }
                }
              if(!isValid) $scope.editGradeMErrorOccurred = true;
              return isValid;
            }


            var isDropdownSetValid= function(index){
                var isReasonValid= true;

                // Function to validate DROPDOWN LIST's CTE current and future
                if ($scope.dropdown.selectedType == 2) {
                  //DO EXTRA VALIDATIONS
                  $scope.dropDownListExtraErrors = [];
          
                  //VALIDATES if has isCurrent or isFuture
                  $scope.activeCTEList().forEach(cte => {
                    if (!cte.isCurrent && !cte.isFuture) {
                      $scope.dropDownListExtraErrors.push(`School pathway ${cte.displayName} was specified neither as a current nor a future pathway. Please select one (or both) of those options or delete the pathway for the school.`);
                                }
                  });
          
                  //VALIDATES if has duplicated displayName
                  const displayNames = [];
                  $scope.activeCTEList().forEach(({ displayName }) => {
                    if (displayName && displayNames.includes(displayName))
                      $scope.dropDownListExtraErrors.push(`Display name ${displayName} has been specified for more than one school pathway. Please specify a different display name for each pathway in order to proceed.`);
                    displayNames.push(displayName);
                  });
          
                  //VALIDATES max pathway number to 10
                  const uniqueCoursesList = $scope.activeCTEList().reduce((arr, cte) => {
                    if (cte.id && !arr.includes(cte.id)){
                      arr.push(cte.id)
                                    }
                    return arr
                  }, []);
          
                  uniqueCoursesList.forEach(cteId=>{
                    const repeatedTimes = $scope.activeCTEList().reduce((c, cte)=>cte.id === cteId? c+1: c, 0);
          
                    if(repeatedTimes > 10){
                      const {name} = $scope.allCTEProgList.find(cte => cte.cteId == cteId);
                      $scope.dropDownListExtraErrors.push(`More than 10 school pathways have been associated with the ${name} pathway. Please remove some pathways.`);
                    }
                                });
          
                  if ($scope.dropDownListExtraErrors.length)
                    $scope.forms.dropDownListsForm.$valid = false;
          
                  isReasonValid = $scope.forms.dropDownListsForm.$valid;
                  $scope.forms.dropDownListsForm.$submitted = true;
                        }

                if($scope.dropdown.selectedType==4){
                    angular.forEach($scope.allPartProgramList, function (row, index) {
                        if(!angular.isDefined(row.displayName) || (row.displayName == "")){
                           $scope.forms.dropDownListsForm['pCodeDisplayName_'+index].$setValidity('pCodeDisplayNameValid', false);
                           isReasonValid = false;
                        } else {
                           $scope.forms.dropDownListsForm['pCodeDisplayName_'+index].$setValidity('pCodeDisplayNameValid', true); 
                        }

                        var values = angular.copy($scope.allPartProgramList);
                        var valueArr = values.map(function(item){ 
                            return item.displayName.toLowerCase() });
                        var isDuplicate = valueArr.some(function(item, idx){ 

                            if(angular.isDefined(item) && item!="" && valueArr.indexOf(item) != idx){
                                $scope.forms.dropDownListsForm['pCodeDisplayName_'+idx].$setValidity('pCodeDuplicateNameValid', false);
                                isReasonValid = false;
                            }
                            else {
                                $scope.forms.dropDownListsForm['pCodeDisplayName_'+idx].$setValidity('pCodeDuplicateNameValid', true); 
                            }
                             
                        });

                    });
                }

                if($scope.dropdown.selectedType == 6){
                    isReasonValid = $scope.isSchoolPeriodsCheckValid();
                }
              
              console.log("Validating Dropdown fields: isReasonValid", isReasonValid) 
              if(!isReasonValid) $scope.editReasonErrorOccurred = true;
              return isReasonValid;
            }


            var isSchoolYearCheckValid= function(){
                var isSchoolYearValid= true;
                $scope.editYearErrorOccurred = false;
                // console.log("ERROR RESET", $scope.forms.schoolYearForm)

                //clear and reset validation msgs
                    if($scope.displayNewSchoolYear){ 
                        $scope.forms.schoolYearForm['year'].$setValidity('nameValid', true);
                        $scope.forms.schoolYearForm['schoolYearStartDate'].$setValidity('startDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearStartDate'].$setValidity('startDateValid', true);
                        $scope.forms.schoolYearForm['schoolYearEndDate'].$setValidity('endDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearEndDate'].$setValidity('endDateValid', true);
                        $scope.forms.schoolYearForm['schoolYearCourseStartDate'].$setValidity('courseStartDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearCourseStartDate'].$setValidity('courseStartDateValid', true);
                        $scope.forms.schoolYearForm['schoolYearCourseEndDate'].$setValidity('courseEndDateRequired', true);
                        $scope.forms.schoolYearForm['schoolYearCourseEndDate'].$setValidity('courseEndDateValid', true);
                    }

                    if($scope.displayNewSchoolSet && !$scope.noSchoolYearSelected){
                        $scope.forms.schoolYearForm['yearVal'].$setValidity('nameValid', true);
                        $scope.forms.schoolYearForm['yearVal'].$setValidity('yearInvalid', true);
                        $scope.forms.schoolYearForm['newSchoolYearStartDate'].$setValidity('startDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearStartDate'].$setValidity('startDateValid', true);
                        $scope.forms.schoolYearForm['newSchoolYearEndDate'].$setValidity('endDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearEndDate'].$setValidity('endDateValid', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseStartDate'].$setValidity('courseStartDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseStartDate'].$setValidity('courseStartDateValid', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseEndDate'].$setValidity('courseEndDateRequired', true);
                        $scope.forms.schoolYearForm['newSchoolYearCourseEndDate'].$setValidity('courseEndDateValid', true);
                    }
                
        
                $scope.currentSchoolYear =  $scope.editSchoolData.currentYear;
                console.log("$scope.currentSchoolYear", $scope.currentSchoolYear);

                if($scope.displayNewSchoolSet && !$scope.noSchoolYearSelected){
                    if($scope.displayNewSchoolSet.yearVal==null || $scope.displayNewSchoolSet.yearVal==''){
                        $scope.forms.schoolYearForm['yearVal'].$setValidity('nameValid', false);
                        isSchoolYearValid = false;
                    } else if($scope.displayNewSchoolSet.yearVal!=null && !/^[0-9]{4}$/.test($scope.displayNewSchoolSet.yearVal) ){
                        $scope.forms.schoolYearForm['yearVal'].$setValidity('yearInvalid', false);
                        isSchoolYearValid = false;
                    }
                }

                // Validating new school's years dates
                if($scope.displayNewSchoolSet && !$scope.noSchoolYearSelected){
                    console.info("Validating new school's years dates");
                    var valStartDate = $("#newSchoolYearStartDate").val();
                    var startDate = new Date(valStartDate);
                    console.log("$scope.currentSchoolYear == $scope.displayNewSchoolSet.yearVal", $scope.currentSchoolYear == $scope.displayNewSchoolSet.yearVal)

                    if (valStartDate == null || valStartDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolSet.yearVal){
                            $scope.forms.schoolYearForm['newSchoolYearStartDate'].$setValidity('startDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
                    // else if(startDate == 'Invalid Date'){
                    else if(!dateRegex.test(valStartDate)){
                        $scope.forms.schoolYearForm['newSchoolYearStartDate'].$setValidity('startDateValid', false);
                        isSchoolYearValid = false;
                    } 

                    var valEndDate = $("#newSchoolYearEndDate").val();
                    var endDate = new Date(valEndDate);
                    if (valEndDate == null || valEndDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolSet.yearVal){
                            $scope.forms.schoolYearForm['newSchoolYearEndDate'].$setValidity('endDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
        
                    else if(!dateRegex.test(valEndDate)){
                        $scope.forms.schoolYearForm['newSchoolYearEndDate'].$setValidity('endDateValid', false);
                        isSchoolYearValid = false;
                    } 

                    var valCourseStartDate = $("#newSchoolYearCourseStartDate").val();
                    var courseStartDate = new Date(valCourseStartDate);
                    if (valCourseStartDate == null || valCourseStartDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolSet.yearVal){
                            $scope.forms.schoolYearForm['newSchoolYearCourseStartDate'].$setValidity('courseStartDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 

                    else if(!dateRegex.test(valCourseStartDate)){
                        $scope.forms.schoolYearForm['newSchoolYearCourseStartDate'].$setValidity('courseStartDateValid', false);
                        isSchoolYearValid = false;
                    } 

                    var valCourseEndDate = $("#newSchoolYearCourseEndDate").val();
                    var courseEndDate = new Date(valCourseEndDate);
                    if (valCourseEndDate == null || valCourseEndDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolSet.yearVal){
                            $scope.forms.schoolYearForm['newSchoolYearCourseEndDate'].$setValidity('courseEndDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
                   
                    else if(!dateRegex.test(valCourseEndDate)){
                        $scope.forms.schoolYearForm['newSchoolYearCourseEndDate'].$setValidity('courseEndDateValid', false);
                        isSchoolYearValid = false;
                    }
                }
     
             
                // Validating existing school's years dates
                if($scope.displayNewSchoolYear){
                    console.info("Validating existing school's years dates");
                    var valStartDate = $("#schoolYearStartDate").val();
                    var startDate = new Date(valStartDate);
                    
                    if (valStartDate == null || valStartDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolYear.year){
                            $scope.forms.schoolYearForm['schoolYearStartDate'].$setValidity('startDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
                   
                    else if(!dateRegex.test(valStartDate)){
                        $scope.forms.schoolYearForm['schoolYearStartDate'].$setValidity('startDateValid', false);
                        isSchoolYearValid = false;
                    } 

                    var valEndDate = $("#schoolYearEndDate").val();
                    var endDate = new Date(valEndDate);
                    if (valEndDate == null || valEndDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolYear.year){
                            $scope.forms.schoolYearForm['schoolYearEndDate'].$setValidity('endDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
            
                    else if(!dateRegex.test(valEndDate)){
                        $scope.forms.schoolYearForm['schoolYearEndDate'].$setValidity('endDateValid', false);
                        isSchoolYearValid = false;
                    } 

                    var valCourseStartDate = $("#schoolYearCourseStartDate").val();
                    var courseStartDate = new Date(valCourseStartDate);
                    if (valCourseStartDate == null || valCourseStartDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolYear.year){
                            $scope.forms.schoolYearForm['schoolYearCourseStartDate'].$setValidity('courseStartDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
                    
                    else if(!dateRegex.test(valCourseStartDate)){
                        $scope.forms.schoolYearForm['schoolYearCourseStartDate'].$setValidity('courseStartDateValid', false);
                        isSchoolYearValid = false;
                    } 

                    var valCourseEndDate = $("#schoolYearCourseEndDate").val();
                    var courseEndDate = new Date(valCourseEndDate);
                    if (valCourseEndDate == null || valCourseEndDate == "") {
                        if($scope.currentSchoolYear == $scope.displayNewSchoolYear.year){
                            $scope.forms.schoolYearForm['schoolYearCourseEndDate'].$setValidity('courseEndDateRequired', false);
                            isSchoolYearValid = false;
                        }
                    } 
                   
                    else if(!dateRegex.test(valCourseEndDate)){
                        $scope.forms.schoolYearForm['schoolYearCourseEndDate'].$setValidity('courseEndDateValid', false);
                        isSchoolYearValid = false;
                    } 
                }
                
                //STT-8344 & STT-8347 - Validations for XschSchTerms
                $scope.schTermsError = false;
                var schoolTermsFinalDeleted = {
                    finalCount: 0,
                    deletedCount: 0
                };
                $scope.setSchoolTerms.forEach(element => {
                    schoolTermsFinalDeleted.deletedCount = element.status == 0 ? schoolTermsFinalDeleted.deletedCount + 1 : schoolTermsFinalDeleted.deletedCount;
                    schoolTermsFinalDeleted.finalCount = element.finalId == 1 ? schoolTermsFinalDeleted.finalCount + 1 : schoolTermsFinalDeleted.finalCount;
                });
                console.log(schoolTermsFinalDeleted);
                if($scope.setSchoolTerms.length == 0 || schoolTermsFinalDeleted.deletedCount == $scope.setSchoolTerms.length){
                    $scope.schTermsError = true;
                    $scope.schTermsErrorMsg = schoolwork12.app.manageSchoolData.errorMessages.termCountValid;
                    isSchoolYearValid = false;
                } else {
                    if(schoolTermsFinalDeleted.finalCount == 0){
                        $scope.schTermsError = true;
                        $scope.schTermsErrorMsg = schoolwork12.app.manageSchoolData.errorMessages.termFinalValid;
                        isSchoolYearValid = false;
                    } 
                }
                //invoke existing SchoolYearSet Validations  
                angular.forEach($scope.setSchoolTerms, function (row, index) {
                  isSchoolYearValid =  isSchoolYearSetValid(row, index, isSchoolYearValid);
                });

                //invoke validation for Holidays
                if(!isHolidaysValidCheck()){
                    isSchoolYearValid = false;
                }

                console.log("Validating School year fields: isSchoolYearValid", isSchoolYearValid) 
                if(!isSchoolYearValid) $scope.editYearErrorOccurred = true;
                return isSchoolYearValid;
            }

            //school year term validations
            var isSchoolYearSetValid= function ( row, index, isSchoolYearValid){
                //SIS-1007 - Validating if "null" value, means an empty date
                row.startDate = row.startDate === null ? "" : row.startDate;
                row.endDate = row.endDate === null ? "" : row.endDate;
                if($scope.forms.schoolYearForm['schoolYearForm_' + index]){  // && row.status == 1
                    //clear and reset validation msgs
                    $scope.forms.schoolYearForm['schoolYearForm_' +index]["termYearStartDate"].$setValidity('startDateValid', true);
                    $scope.forms.schoolYearForm['schoolYearForm_' +index]["termYearEndDate"].$setValidity('endDateValid', true);
                    $scope.forms.schoolYearForm['schoolYearForm_' +index]["termYearEndDate"].$setValidity('endDateRange', true);
                    //reset termNameValid error
                    if($scope.forms.schoolYearForm['schoolYearForm_' +index].$error.hasOwnProperty('termNameValid'))
                    $scope.forms.schoolYearForm['schoolYearForm_' +index]["termName"].$setValidity('termNameValid', true);
                    //reset duplicateTermNameValid error
                    if($scope.forms.schoolYearForm['schoolYearForm_' +index].$error.hasOwnProperty('duplicateTermNameValid'))
                    $scope.forms.schoolYearForm['schoolYearForm_' +index]["termName"].$setValidity('duplicateTermNameValid', true);
                    
                    // console.log("row details", row)
                    if(row.startDate != "" && !dateRegex.test(row.startDate)){
                      $scope.forms.schoolYearForm['schoolYearForm_' +index]["termYearStartDate"].$setValidity('startDateValid', false);
                      $scope.schoolStartDateError = schoolwork12.app.manageSchoolData.errorMessages.startDateValid;
                      isSchoolYearValid = false;
                    }

                    if(row.endDate != "" && !dateRegex.test(row.endDate)){
                      $scope.forms.schoolYearForm['schoolYearForm_' +index]["termYearEndDate"].$setValidity('endDateValid', false);
                      $scope.schoolEndDateError = schoolwork12.app.manageSchoolData.errorMessages.endDateValid;
                      isSchoolYearValid = false;
                    }

                    if((row.startDate!=null) && (row.endDate!=null)) {
                        var formattedSchoolStartDate = new Date(row.startDate);
                        var formattedSchoolEndDate = new Date(row.endDate);
                        if((formattedSchoolEndDate < formattedSchoolStartDate)){
                            $scope.forms.schoolYearForm['schoolYearForm_' +index]["termYearEndDate"].$setValidity('endDateRange', false);
                            $scope.schoolEndDateRangeError = schoolwork12.app.manageSchoolData.errorMessages.endDateRange;
                            isSchoolYearValid = false;
                        }
                    }

                    if(row.name == ""){
                      $scope.forms.schoolYearForm['schoolYearForm_' +index]["termName"].$setValidity('termNameValid', false);
                      $scope.termNameError = schoolwork12.app.manageSchoolData.errorMessages.termNameValid;
                      isSchoolYearValid = false;
                    } 

                    var values = angular.copy($scope.setSchoolTerms);
                    var valueArr = values.map(function(item){ 
                        return item.name.toLowerCase() });
                    var isDuplicateTerm = valueArr.some(function(item, index){ 
                        if(item!="" && (valueArr.indexOf(item) != index)){
                           $scope.forms.schoolYearForm['schoolYearForm_' +index]["termName"].$setValidity('duplicateTermNameValid', false);
                           $scope.termDuplicateNameError = schoolwork12.app.manageSchoolData.errorMessages.termDuplicateNameValid;
                           isSchoolYearValid = false;
                        }
                    });
                }
                return isSchoolYearValid;

            }

            var isGradeMarkSetValid= function ( row, index, isValid){
                if($scope.forms.grademarkForm['grademarkForm_' +index] && row.status == 1){
                    $scope.forms.grademarkForm['grademarkForm_' +index]["gradePercent"].$setValidity('percentValid', true);
                    if(!row.gradeMarkId ) $scope.forms.grademarkForm['grademarkForm_' +index]["gradeSetAbbr"].$setValidity('abbrValid', true);
                      $scope.forms.grademarkForm['grademarkForm_' +index]["gradeSetNewName"].$setValidity('nameValid', true);
                      $scope.forms.grademarkForm['grademarkForm_' +index]["gradeGPA"].$setValidity('gpaValid', true);

                    if( row.start_percent && !/^\d*(\.\d{1,5})*$/.test(row.start_percent)){
                      $scope.forms.grademarkForm['grademarkForm_' +index]["gradePercent"].$setValidity('percentValid', false);
                      $scope.sPercentError = schoolwork12.app.manageSchoolData.errorMessages.percentValid;
                      isValid = false;
                    }
                    if( row.gpa && !/^\d*(\.\d{1,3})*$/.test(row.gpa)){
                      $scope.forms.grademarkForm['grademarkForm_' +index]["gradeGPA"].$setValidity('gpaValid', false);
                      $scope.gpaError = schoolwork12.app.manageSchoolData.errorMessages.gpaValid;
                      isValid = false;
                    }
                    if(!row.gradeMarkId &&( !row.abbreviation || (row.abbreviation && row.abbreviation=="") )){
                      $scope.forms.grademarkForm['grademarkForm_' +index]["gradeSetAbbr"].$setValidity('abbrValid', false);
                      $scope.abbrError = schoolwork12.app.manageSchoolData.errorMessages.abbrValid;
                      isValid = false;
                    }
                    if( !row.name || (row.name && row.name=="") ){
                      $scope.forms.grademarkForm['grademarkForm_' +index]["gradeSetNewName"].$setValidity('nameValid', false);
                      $scope.nameSetError = schoolwork12.app.manageSchoolData.errorMessages.nameValid;
                      isValid = false;
                    }
                }
                return isValid;

            }
            var gradeSetAbbrCount = 0;
            var nameValidCount = 0;
            var percentValidCount= 0;
            var validateDuplicateSet = function(fullSetDetails, isValid){
                var setDetails= $filter('filter')(fullSetDetails, function(item) {
                    return item.status !== 0;
                });
                for(var i = 0; i<setDetails.length; i++ ){
                   if($scope.forms.grademarkForm['grademarkForm_' +i]){

                       if($scope.forms.grademarkForm['grademarkForm_' +i]["gradeSetAbbr"].abbrValid) $scope.forms.grademarkForm['grademarkForm_' +i]["gradeSetAbbr"].$setValidity('abbrValid', true);
                       if($scope.forms.grademarkForm['grademarkForm_' +i]["gradePercent"].abbrValid) $scope.forms.grademarkForm['grademarkForm_' +i]["gradePercent"].$setValidity('percentValid', true);
                       if($scope.forms.grademarkForm['grademarkForm_' +i]["gradeSetNewName"].abbrValid) $scope.forms.grademarkForm['grademarkForm_' +i]["gradeSetNewName"].$setValidity('nameValid', true);
                        gradeSetAbbrCount = 0;
                        nameValidCount = 0;
                        percentValidCount= 0;
                        for (var j= i +1; j<setDetails.length; j++ ){
                             gradeSetAbbrCount = 0;
                             nameValidCount = 0;
                             percentValidCount= 0;
                            if(setDetails[i].status==1 && setDetails[j].status==1 && setDetails[i].abbreviation!=""  && setDetails[j].abbreviation!="" && setDetails[i].abbreviation == setDetails[j].abbreviation){
                                gradeSetAbbrCount = gradeSetAbbrCount +1;
                                if(gradeSetAbbrCount>=1) {
                                    $scope.forms.grademarkForm['grademarkForm_' +j]["gradeSetAbbr"].$setValidity('abbrValid', false);
                                    isValid = false;
                                    $scope.abbrError = schoolwork12.app.manageSchoolData.errorMessages.abbrUniq;
                                }
                            }
                            if(setDetails[i].status==1 && setDetails[j].status==1 &&setDetails[i].start_percent && setDetails[j].start_percent && setDetails[i].start_percent == setDetails[j].start_percent){
                                percentValidCount = percentValidCount +1;
                                if(percentValidCount>=1){
                                   $scope.forms.grademarkForm['grademarkForm_' +j]["gradePercent"].$setValidity('percentValid', false);
                                    isValid = false;
                                     $scope.sPercentError = schoolwork12.app.manageSchoolData.errorMessages.percentUniq;
                                }                        
                            }
                            if(setDetails[i].status==1 && setDetails[j].status==1 && setDetails[i].name!=""  && setDetails[j].name!="" && setDetails[i].name == setDetails[j].name){
                                nameValidCount = nameValidCount +1;
                                if(nameValidCount>=1){
                                    $scope.forms.grademarkForm['grademarkForm_' +j]["gradeSetNewName"].$setValidity('nameValid', false);
                                    isValid = false;
                                    $scope.nameSetError = schoolwork12.app.manageSchoolData.errorMessages.nameUniq;
                                }
                            }
                            
                        } 
                    }
                }
                return isValid;
            }


         }]);
}(angular, schoolwork12));
